import React from "react";
import { SvgIconProps } from "./Icon.types";

export const PasswordIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  className,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    width={width}
    height={height}
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <path
      d="M5.54545 6.95V5.4625C5.54545 2.99771 7.53939 1 10 1C12.4606 1 14.4545 2.99665 14.4545 5.4625V6.95H14.6669C15.9549 6.95 17 7.99784 17 9.2875V15.6625C17 16.9539 15.9566 18 14.6669 18H5.33333C4.04512 18 3 16.9522 3 15.6625V9.2875C3 7.99614 4.04342 6.95 5.33312 6.95H5.54545ZM6.81818 6.95H13.1818V5.4625C13.1818 3.70088 11.7578 2.275 10 2.275C8.24236 2.275 6.81818 3.70194 6.81818 5.4625V6.95ZM4.27273 9.2875V15.6625C4.27273 16.2481 4.7483 16.725 5.33312 16.725H14.6667C14.806 16.7252 14.944 16.6978 15.0727 16.6445C15.2015 16.5911 15.3185 16.5129 15.417 16.4142C15.5155 16.3155 15.5936 16.1983 15.6469 16.0693C15.7001 15.9403 15.7274 15.8021 15.7273 15.6625V9.2875C15.7273 8.70185 15.2517 8.225 14.6669 8.225H5.33333C5.19401 8.22483 5.05601 8.2522 4.92726 8.30554C4.7985 8.35887 4.68152 8.43713 4.583 8.53582C4.48448 8.63452 4.40636 8.75172 4.35312 8.8807C4.29988 9.00968 4.27256 9.14792 4.27273 9.2875Z"
      fill="url(#paint0_linear_7090_2076)"
    />
    <path
      d="M5.54545 6.95V5.4625C5.54545 2.99771 7.53939 1 10 1C12.4606 1 14.4545 2.99665 14.4545 5.4625V6.95H14.6669C15.9549 6.95 17 7.99784 17 9.2875V15.6625C17 16.9539 15.9566 18 14.6669 18H5.33333C4.04512 18 3 16.9522 3 15.6625V9.2875C3 7.99614 4.04342 6.95 5.33312 6.95H5.54545ZM6.81818 6.95H13.1818V5.4625C13.1818 3.70088 11.7578 2.275 10 2.275C8.24236 2.275 6.81818 3.70194 6.81818 5.4625V6.95ZM4.27273 9.2875V15.6625C4.27273 16.2481 4.7483 16.725 5.33312 16.725H14.6667C14.806 16.7252 14.944 16.6978 15.0727 16.6445C15.2015 16.5911 15.3185 16.5129 15.417 16.4142C15.5155 16.3155 15.5936 16.1983 15.6469 16.0693C15.7001 15.9403 15.7274 15.8021 15.7273 15.6625V9.2875C15.7273 8.70185 15.2517 8.225 14.6669 8.225H5.33333C5.19401 8.22483 5.05601 8.2522 4.92726 8.30554C4.7985 8.35887 4.68152 8.43713 4.583 8.53582C4.48448 8.63452 4.40636 8.75172 4.35312 8.8807C4.29988 9.00968 4.27256 9.14792 4.27273 9.2875Z"
      fill="url(#paint1_linear_7090_2076)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7090_2076"
        x1="7"
        y1="17"
        x2="7"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-header-start, currentColor)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(-color-icon-header-end, currentColor)" }}
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_7090_2076"
        x1="7"
        y1="0"
        x2="7"
        y2="17"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-start, currentColor)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-end, currentColor)" }}
        />
      </linearGradient>
    </defs>
  </svg>
);

// 个人信息页重置密码图标（圆弧箭头+锁）
export const PasswordResetIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <defs>
      <linearGradient
        id="paint0_linear_password_reset"
        x1="10"
        y1="18"
        x2="10"
        y2="2"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-header-start, currentColor)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-header-end, currentColor)" }}
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_password_reset"
        x1="10"
        y1="2"
        x2="10"
        y2="18"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-start, currentColor)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-end, currentColor)" }}
        />
      </linearGradient>
    </defs>
    <path
      d="M10.5028 17C9.46567 17 8.49359 16.8053 7.58654 16.4159C6.67949 16.0264 5.88639 15.4952 5.20724 14.8223C4.52809 14.1493 3.99043 13.358 3.59426 12.4482C3.19809 11.5385 3 10.5664 3 9.53205H3.83334C3.83334 10.4487 4.00962 11.3106 4.36218 12.1178C4.71475 12.9249 5.19311 13.6306 5.79728 14.2348C6.40144 14.8389 7.10807 15.3154 7.91715 15.6643C8.72624 16.0131 9.58719 16.1875 10.5 16.1875C12.3611 16.1875 13.9375 15.5417 15.2292 14.25C16.5208 12.9583 17.1667 11.3819 17.1667 9.52083C17.1667 7.65972 16.5208 6.08334 15.2292 4.79167C13.9375 3.5 12.3611 2.85417 10.5 2.85417C9.14637 2.85417 7.93403 3.20967 6.86298 3.92068C5.79194 4.63168 4.99146 5.56197 4.46154 6.71154H6.87821V7.54487H3V3.66667H3.83334V6.15063C4.43697 4.91239 5.32853 3.91105 6.50802 3.14663C7.6875 2.38221 9.01816 2 10.5 2C11.5375 2 12.5125 2.1968 13.425 2.59041C14.3375 2.98401 15.1313 3.51819 15.8063 4.19293C16.4813 4.86768 17.0156 5.66114 17.4094 6.5733C17.8031 7.48546 18 8.4601 18 9.49721C18 10.5343 17.8032 11.5094 17.4096 12.4224C17.016 13.3354 16.4818 14.1296 15.8071 14.805C15.1323 15.4804 14.3389 16.0151 13.4267 16.409C12.5145 16.803 11.5399 17 10.5028 17V17M8.83333 12.641C8.62447 12.641 8.44939 12.5704 8.30809 12.4291C8.1668 12.2878 8.09615 12.1127 8.09615 11.9038V9.40385C8.09615 9.19498 8.17602 9.0199 8.33574 8.87861C8.49546 8.73731 8.69338 8.66667 8.92949 8.66667V7.73718C8.92949 7.30529 9.082 6.93557 9.38702 6.62801C9.69204 6.32045 10.063 6.16667 10.5 6.16667C10.937 6.16667 11.308 6.32045 11.613 6.62801C11.918 6.93557 12.0705 7.30529 12.0705 7.73718V8.66667C12.3066 8.66667 12.5045 8.73731 12.6643 8.87861C12.824 9.0199 12.9038 9.19498 12.9038 9.40385V11.9038C12.9038 12.1127 12.8332 12.2878 12.6919 12.4291C12.5506 12.5704 12.3755 12.641 12.1667 12.641H8.83333V12.641M9.57051 8.66667H11.4295V7.74337C11.4295 7.48176 11.3389 7.26042 11.1579 7.07933C10.9768 6.89824 10.7575 6.8077 10.5 6.8077C10.2425 6.8077 10.0232 6.89824 9.84215 7.07933C9.66106 7.26042 9.57051 7.48176 9.57051 7.74337V8.66667V8.66667"
      fill="url(#paint0_linear_password_reset)"
      stroke="url(#paint0_linear_password_reset)"
      strokeWidth="0.3"
    />
    <path
      d="M10.5028 17C9.46567 17 8.49359 16.8053 7.58654 16.4159C6.67949 16.0264 5.88639 15.4952 5.20724 14.8223C4.52809 14.1493 3.99043 13.358 3.59426 12.4482C3.19809 11.5385 3 10.5664 3 9.53205H3.83334C3.83334 10.4487 4.00962 11.3106 4.36218 12.1178C4.71475 12.9249 5.19311 13.6306 5.79728 14.2348C6.40144 14.8389 7.10807 15.3154 7.91715 15.6643C8.72624 16.0131 9.58719 16.1875 10.5 16.1875C12.3611 16.1875 13.9375 15.5417 15.2292 14.25C16.5208 12.9583 17.1667 11.3819 17.1667 9.52083C17.1667 7.65972 16.5208 6.08334 15.2292 4.79167C13.9375 3.5 12.3611 2.85417 10.5 2.85417C9.14637 2.85417 7.93403 3.20967 6.86298 3.92068C5.79194 4.63168 4.99146 5.56197 4.46154 6.71154H6.87821V7.54487H3V3.66667H3.83334V6.15063C4.43697 4.91239 5.32853 3.91105 6.50802 3.14663C7.6875 2.38221 9.01816 2 10.5 2C11.5375 2 12.5125 2.1968 13.425 2.59041C14.3375 2.98401 15.1313 3.51819 15.8063 4.19293C16.4813 4.86768 17.0156 5.66114 17.4094 6.5733C17.8031 7.48546 18 8.4601 18 9.49721C18 10.5343 17.8032 11.5094 17.4096 12.4224C17.016 13.3354 16.4818 14.1296 15.8071 14.805C15.1323 15.4804 14.3389 16.0151 13.4267 16.409C12.5145 16.803 11.5399 17 10.5028 17V17M8.83333 12.641C8.62447 12.641 8.44939 12.5704 8.30809 12.4291C8.1668 12.2878 8.09615 12.1127 8.09615 11.9038V9.40385C8.09615 9.19498 8.17602 9.0199 8.33574 8.87861C8.49546 8.73731 8.69338 8.66667 8.92949 8.66667V7.73718C8.92949 7.30529 9.082 6.93557 9.38702 6.62801C9.69204 6.32045 10.063 6.16667 10.5 6.16667C10.937 6.16667 11.308 6.32045 11.613 6.62801C11.918 6.93557 12.0705 7.30529 12.0705 7.73718V8.66667C12.3066 8.66667 12.5045 8.73731 12.6643 8.87861C12.824 9.0199 12.9038 9.19498 12.9038 9.40385V11.9038C12.9038 12.1127 12.8332 12.2878 12.6919 12.4291C12.5506 12.5704 12.3755 12.641 12.1667 12.641H8.83333V12.641M9.57051 8.66667H11.4295V7.74337C11.4295 7.48176 11.3389 7.26042 11.1579 7.07933C10.9768 6.89824 10.7575 6.8077 10.5 6.8077C10.2425 6.8077 10.0232 6.89824 9.84215 7.07933C9.66106 7.26042 9.57051 7.48176 9.57051 7.74337V8.66667V8.66667"
      fill="url(#paint1_linear_password_reset)"
      stroke="url(#paint1_linear_password_reset)"
      strokeWidth="0.3"
    />
  </svg>
);

// 用户图标SVG组件
export const UserIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <defs>
      <linearGradient
        id="user_icon_grad0"
        x1="10"
        y1="10"
        x2="10"
        y2="19.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-header-start, currentColor)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-header-end, currentColor)" }}
        />
      </linearGradient>
      <linearGradient
        id="user_icon_grad1"
        x1="10"
        y1="0.5"
        x2="10"
        y2="9.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-start, currentColor)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-end, currentColor)" }}
        />
      </linearGradient>
    </defs>
    <path
      d="M8.33301 10.5996H11.667C14.8332 10.5998 17.4002 13.1668 17.4004 16.333C17.4004 17.7505 16.2505 18.9004 14.833 18.9004H5.16699C3.74946 18.9004 2.59961 17.7505 2.59961 16.333C2.59979 13.1668 5.16683 10.5998 8.33301 10.5996Z"
      stroke="url(#user_icon_grad0)"
      strokeWidth="1.2"
    />
    <circle
      cx="10"
      cy="5"
      r="3.9"
      stroke="url(#user_icon_grad1)"
      strokeWidth="1.2"
    />
  </svg>
);

// 搜索图标SVG组件
export const SearchIcon: React.FC<SvgIconProps> = ({
  width = "1.25rem",
  height = "1.25rem",
  color = "currentColor",
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default", color }}
  >
    <defs>
      <linearGradient
        id="paint0_linear_874_1860"
        x1="11.9997"
        y1="1.00024"
        x2="16.9997"
        y2="23.0002"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--icon-nav-grad-start, currentColor)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--icon-nav-grad-end, currentColor)" }}
        />
      </linearGradient>
      <clipPath id="clip0_874_1860">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
    <g clipPath="url(#clip0_874_1860)">
      <path
        d="M19.2158 16.6802L24.0198 21.1731L21.8188 23.3779L17.0793 18.9456C15.2318 20.3909 12.9523 21.1736 10.6066 21.1681C4.86211 21.1681 0.204803 16.5841 0.204803 10.9306C0.204803 5.2771 4.86211 0.693115 10.6079 0.693115C16.3537 0.693115 21.011 5.2771 21.011 10.9306C21.0128 12.9853 20.3865 14.9915 19.2158 16.6802ZM10.6066 18.0961C14.6293 18.0961 17.8897 14.8875 17.8897 10.9306C17.8897 6.97365 14.6293 3.76385 10.6079 3.76385C6.58647 3.76385 3.32611 6.97238 3.32611 10.9306C3.32611 14.8875 6.58647 18.0961 10.6079 18.0961H10.6066Z"
        fill="url(#paint0_linear_874_1860)"
      />
    </g>
  </svg>
);

// 菜单图标SVG组件
export const MenuIcon: React.FC<SvgIconProps> = ({
  width = 25,
  height = 25,
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <g clipPath="url(#clip0_874_1923)">
      <circle cx="12.5" cy="12.5" r="12.5" fill="black" fillOpacity="0.2" />
      <path
        d="M6 7H7.76007V8.74074H6V7ZM9.57516 7H19V8.74074H9.57516V7ZM6 11.7822H7.76007V13.5229H6V11.7822ZM9.57516 11.7822H19V13.5229H9.57516V11.7822ZM6 16.2625H7.76007V18H6V16.2625ZM9.57516 16.2625H19V18H9.57516V16.2625Z"
        fill="#FFF9C7"
      />
    </g>
    <defs>
      <clipPath id="clip0_874_1923">
        <rect width="25" height="25" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// 刷新图标SVG组件
export const RefreshIcon: React.FC<SvgIconProps> = ({
  width = 12,
  height = 13,
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <path
      d="M10.5 2.825V4.925C10.5 5.15 10.425 5.3 10.275 5.45C10.125 5.6 9.9 5.675 9.75 5.675H7.65C7.425 5.675 7.275 5.6 7.125 5.45C6.825 5.15 6.825 4.7 7.125 4.4C7.275 4.25 7.425 4.175 7.65 4.175H7.95C7.35 3.725 6.75 3.5 6.075 3.5C5.175 3.5 4.425 3.8 3.9 4.4C3.6 4.7 3.15 4.7 2.85 4.4C2.55 4.1 2.55 3.65 2.85 3.35C3.675 2.525 4.8 2 6.075 2C7.2 2 8.25 2.45 9 3.125V2.825C9 2.6 9.075 2.45 9.225 2.3C9.525 2 9.975 2 10.275 2.3C10.425 2.375 10.5 2.6 10.5 2.825ZM4.875 8.6C4.725 8.75 4.5 8.825 4.35 8.825H4.125C4.65 9.275 5.25 9.5 5.925 9.5C6.75 9.5 7.5 9.2 8.025 8.6C8.325 8.3 8.775 8.3 9.075 8.6C9.375 8.9 9.375 9.35 9.075 9.65C8.325 10.475 7.2 11 5.925 11C4.8 11 3.75 10.55 3 9.875V10.25C3 10.475 2.925 10.625 2.775 10.775C2.475 11.075 2.025 11.075 1.725 10.775C1.575 10.625 1.5 10.4 1.5 10.175V8.075C1.5 7.85 1.575 7.7 1.725 7.55C1.875 7.4 2.025 7.325 2.25 7.325H4.35C4.575 7.325 4.725 7.4 4.875 7.55C5.175 7.85 5.175 8.3 4.875 8.6Z"
      fill="#DCB587"
    />
  </svg>
);

// 邮件/信封图标SVG组件
export const MailTopRightIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  className,
  color = "currentColor",
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default", color }}
  >
    <path
      d="M10.0023 1H9.93476C8.12754 1.01464 6.3665 1.57225 4.88055 2.60037C3.3946 3.62849 2.25246 5.07957 1.60256 6.765C0.95266 8.45044 0.825069 10.2923 1.23637 12.0511C1.64767 13.81 2.57883 15.4045 3.90884 16.6275L3.18425 17.8822C3.11848 17.9956 3.08383 18.1243 3.08381 18.2554C3.08378 18.3864 3.11838 18.5152 3.18411 18.6286C3.24984 18.742 3.34436 18.8361 3.45813 18.9013C3.57189 18.9665 3.70087 19.0006 3.83201 19H10.0023C11.3144 19.0027 12.6109 18.7164 13.7997 18.1615C15.657 17.2958 17.1634 15.8229 18.0702 13.9862C18.977 12.1494 19.23 10.0585 18.7875 8.05868C18.345 6.05883 17.2334 4.26955 15.6362 2.98624C14.039 1.70293 12.0517 1.00229 10.0023 1ZM12.2366 12.3005H5.73689C5.64651 12.3028 5.55659 12.287 5.47241 12.2541C5.38824 12.2211 5.31153 12.1716 5.24679 12.1085C5.18205 12.0455 5.1306 11.9701 5.09547 11.8868C5.06034 11.8036 5.04225 11.7141 5.04225 11.6238C5.04225 11.5334 5.06034 11.444 5.09547 11.3607C5.1306 11.2775 5.18205 11.2021 5.24679 11.139C5.31153 11.0759 5.38824 11.0265 5.47241 10.9935C5.55659 10.9605 5.64651 10.9447 5.73689 10.947H12.2366C12.327 10.9447 12.4169 10.9605 12.5011 10.9935C12.5852 11.0265 12.662 11.0759 12.7267 11.139C12.7914 11.2021 12.8429 11.2775 12.878 11.3607C12.9131 11.444 12.9312 11.5334 12.9312 11.6238C12.9312 11.7141 12.9131 11.8036 12.878 11.8868C12.8429 11.9701 12.7914 12.0455 12.7267 12.1085C12.662 12.1716 12.5852 12.2211 12.5011 12.2541C12.4169 12.287 12.327 12.3028 12.2366 12.3005ZM5.73689 9.05251C5.64651 9.05481 5.55659 9.03901 5.47241 9.00604C5.38824 8.97307 5.31153 8.92359 5.24679 8.86052C5.18205 8.79745 5.1306 8.72207 5.09547 8.63881C5.06034 8.55556 5.04225 8.46612 5.04225 8.37576C5.04225 8.28541 5.06034 8.19597 5.09547 8.11271C5.1306 8.02946 5.18205 7.95408 5.24679 7.89101C5.31153 7.82794 5.38824 7.77846 5.47241 7.74548C5.55659 7.71251 5.64651 7.69671 5.73689 7.69902H14.2678C14.4443 7.70353 14.6122 7.77681 14.7355 7.90323C14.8588 8.02965 14.9278 8.19921 14.9278 8.37576C14.9278 8.55231 14.8588 8.72188 14.7355 8.8483C14.6122 8.97472 14.4443 9.048 14.2678 9.05251H5.73689Z"
      fill="url(#mail_grad)"
    />
    <defs>
      <linearGradient
        id="mail_grad"
        x1="10"
        y1="1"
        x2="10"
        y2="19"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-header-start, currentColor)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-header-end, currentColor)" }}
        />
      </linearGradient>
    </defs>
  </svg>
);

export const MailIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="-2 0 20 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <defs>
      <linearGradient
        id="paint0_linear_7090_4474"
        x1="8"
        y1="13"
        x2="8"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-header-start, currentColor)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-header-end, currentColor)" }}
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_7090_4474"
        x1="8"
        y1="0"
        x2="8"
        y2="13"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-start, currentColor)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-end, currentColor)" }}
        />
      </linearGradient>
    </defs>
    <path
      d="M0 0.688259C0 0.307692 0.311795 0 0.697436 0H15.3026C15.6882 0 16 0.307692 16 0.688259V4.06154L8.20103 7.84858C8.06966 7.88769 7.92952 7.88769 7.79815 7.84858L0 4.06073V3.71093V0.688259ZM0 4.96356V12.3117C0 12.6923 0.311795 13 0.697436 13H15.3026C15.6882 13 16 12.6923 16 12.3117V4.96356L14.7692 5.56113V11.7854H1.23077V5.56194L0 4.96437V4.96356ZM14.7692 1.21457H1.23077V3.31579L8 6.60324L14.7692 3.31579V1.21457Z"
      fill="url(#paint0_linear_7090_4474)"
    />
    <path
      d="M0 0.688259C0 0.307692 0.311795 0 0.697436 0H15.3026C15.6882 0 16 0.307692 16 0.688259V4.06154L8.20103 7.84858C8.06966 7.88769 7.92952 7.88769 7.79815 7.84858L0 4.06073V3.71093V0.688259ZM0 4.96356V12.3117C0 12.6923 0.311795 13 0.697436 13H15.3026C15.6882 13 16 12.6923 16 12.3117V4.96356L14.7692 5.56113V11.7854H1.23077V5.56194L0 4.96437V4.96356ZM14.7692 1.21457H1.23077V3.31579L8 6.60324L14.7692 3.31579V1.21457Z"
      fill="url(#paint1_linear_7090_4474)"
    />
  </svg>
);

// 关闭图标SVG组件
export const CloseIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  color = "currentColor",
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <path
      d="M15 5L5 15M5 5l10 10"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// 关闭对话框图标SVG组件
export const CloseDialogIcon: React.FC<SvgIconProps> = ({
  width = 36,
  height = 36,
  color = "white",
  className,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 36 36"
    fill="none"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <path
      d="M12.8103 21.8108L16.6211 18L12.8108 14.1896L14.1896 12.8108L18 16.6211L21.8104 12.8108L23.1892 14.1896L19.3789 18L23.1896 21.8108L21.8108 23.1896L18 19.3789L14.1892 23.1896L12.8103 21.8108Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.25 18C32.25 25.8701 25.8701 32.25 18 32.25C10.1299 32.25 3.75 25.8701 3.75 18C3.75 10.1299 10.1299 3.75 18 3.75C25.8701 3.75 32.25 10.1299 32.25 18ZM30.3 18C30.3 24.7931 24.7931 30.3 18 30.3C11.2069 30.3 5.7 24.7931 5.7 18C5.7 11.2069 11.2069 5.7 18 5.7C24.7931 5.7 30.3 11.2069 30.3 18Z"
      fill={color}
    />
  </svg>
);

// 首页图标SVG组件
export const HomeActiveIcon: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
    viewBox="-1 -1 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0606 0C11.4987 9.83261e-05 11.9216 0.16271 12.2461 0.457031V0.458008L21.708 9.55957C21.7943 9.63739 21.8642 9.73201 21.9141 9.83691C21.9639 9.94167 21.9931 10.0551 21.999 10.1709C22.005 10.2868 21.9881 10.4033 21.9492 10.5127C21.9103 10.6221 21.8494 10.7234 21.7715 10.8096C21.4445 11.1734 20.8869 11.2001 20.4942 10.8447V20.2295C20.4944 20.4619 20.4491 20.6925 20.3604 20.9072C20.2716 21.1219 20.1408 21.3171 19.9766 21.4814C19.8123 21.6458 19.6171 21.7763 19.4024 21.8652C19.1876 21.9542 18.9571 22.0001 18.7246 22H13V18C13 16.8954 12.1046 16 11 16C9.89545 16 9.00001 16.8954 9.00001 18V22H3.39259C3.1601 22 2.92962 21.9543 2.71486 21.8652C2.50017 21.7762 2.30488 21.6459 2.14064 21.4814C1.97636 21.317 1.84659 21.1211 1.75782 20.9062C1.66918 20.6916 1.62379 20.4617 1.62404 20.2295V10.7285L1.47072 10.873C1.29614 11.0277 1.06788 11.1078 0.834973 11.0947C0.60208 11.0817 0.383744 10.9769 0.227551 10.8037C0.0714461 10.6305 -0.0100333 10.4028 0.000988829 10.1699C0.0120609 9.93695 0.115193 9.71721 0.287122 9.55957L9.87501 0.457031C10.1996 0.16287 10.6225 0 11.0606 0Z"
      fill="url(#paint0_linear_6269_4920)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6269_4920"
        x1="0"
        y1="0"
        x2="21.6056"
        y2="22.381"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-tab-active-start)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-tab-active-end)" }}
        />
      </linearGradient>
    </defs>
  </svg>
);

// 首页导航栏默认态图标（白色半透明渐变，用于底部导航未选中状态）
export const HomeDefaultIcon: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0606 1C12.4987 1.0001 12.9216 1.16271 13.2461 1.45703V1.45801L22.708 10.5596C22.7943 10.6374 22.8642 10.732 22.9141 10.8369C22.9639 10.9417 22.9931 11.0551 22.999 11.1709C23.005 11.2868 22.9881 11.4033 22.9492 11.5127C22.9103 11.6221 22.8494 11.7234 22.7715 11.8096C22.4445 12.1734 21.8869 12.2001 21.4942 11.8447V21.2295C21.4944 21.4619 21.4491 21.6925 21.3604 21.9072C21.2716 22.1219 21.1408 22.3171 20.9766 22.4814C20.8123 22.6458 20.6171 22.7763 20.4024 22.8652C20.1876 22.9542 19.9571 23.0001 19.7246 23H14V19C14 17.8954 13.1046 17 12 17C10.8954 17 10 17.8954 10 19V23H4.39259C4.1601 23 3.92962 22.9543 3.71486 22.8652C3.50017 22.7762 3.30488 22.6459 3.14064 22.4814C2.97636 22.317 2.84659 22.1211 2.75782 21.9062C2.66918 21.6916 2.62379 21.4617 2.62404 21.2295V11.7285L2.47072 11.873C2.29614 12.0277 2.06788 12.1078 1.83497 12.0947C1.60208 12.0817 1.38374 11.9769 1.22755 11.8037C1.07145 11.6305 0.989967 11.4028 1.00099 11.1699C1.01206 10.9369 1.11519 10.7172 1.28712 10.5596L10.875 1.45703C11.1996 1.16287 11.6225 1 12.0606 1Z"
      fill="url(#homeDefault_linear)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0606 1C12.4987 1.0001 12.9216 1.16271 13.2461 1.45703V1.45801L22.708 10.5596C22.7943 10.6374 22.8642 10.732 22.9141 10.8369C22.9639 10.9417 22.9931 11.0551 22.999 11.1709C23.005 11.2868 22.9881 11.4033 22.9492 11.5127C22.9103 11.6221 22.8494 11.7234 22.7715 11.8096C22.4445 12.1734 21.8869 12.2001 21.4942 11.8447V21.2295C21.4944 21.4619 21.4491 21.6925 21.3604 21.9072C21.2716 22.1219 21.1408 22.3171 20.9766 22.4814C20.8123 22.6458 20.6171 22.7763 20.4024 22.8652C20.1876 22.9542 19.9571 23.0001 19.7246 23H14V19C14 17.8954 13.1046 17 12 17C10.8954 17 10 17.8954 10 19V23H4.39259C4.1601 23 3.92962 22.9543 3.71486 22.8652C3.50017 22.7762 3.30488 22.6459 3.14064 22.4814C2.97636 22.317 2.84659 22.1211 2.75782 21.9062C2.66918 21.6916 2.62379 21.4617 2.62404 21.2295V11.7285L2.47072 11.873C2.29614 12.0277 2.06788 12.1078 1.83497 12.0947C1.60208 12.0817 1.38374 11.9769 1.22755 11.8037C1.07145 11.6305 0.989967 11.4028 1.00099 11.1699C1.01206 10.9369 1.11519 10.7172 1.28712 10.5596L10.875 1.45703C11.1996 1.16287 11.6225 1 12.0606 1Z"
      fill="url(#homeDefault_radial)"
      fillOpacity="0.15"
    />
    <defs>
      <linearGradient
        id="homeDefault_linear"
        x1="12"
        y1="1"
        x2="12"
        y2="23"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-tab-default-start)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-tab-default-end)" }}
        />
      </linearGradient>
      <radialGradient
        id="homeDefault_radial"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(12 1) rotate(90) scale(18.0714 22.9904)"
      >
        <stop style={{ stopColor: "var(--color-icon-tab-default-radial)" }} />
        <stop
          offset="1"
          style={{
            stopColor: "var(--color-icon-tab-default-radial)",
            stopOpacity: 0,
          }}
        />
      </radialGradient>
    </defs>
  </svg>
);

export const EventActiveIcon: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.7617 5.76529C22.6859 5.68931 22.5959 5.62911 22.4967 5.58815C22.3976 5.5472 22.2914 5.5263 22.1842 5.52666H19.2453C19.4937 5.05683 19.6166 4.53067 19.6021 3.99927C19.5875 3.46786 19.436 2.94925 19.1622 2.49376C18.8885 2.03827 18.5017 1.66138 18.0396 1.39965C17.5775 1.13792 17.0556 1.00025 16.5247 1C14.8527 0.998166 13.4722 2.29779 12.7993 3.07426C12.5061 3.4108 12.2389 3.76917 12 4.14627C11.7672 3.77914 11.494 3.41202 11.2007 3.0761C10.526 2.29963 9.1455 1 7.4735 1C6.94297 1.00074 6.42163 1.13867 5.95999 1.40043C5.49835 1.66219 5.11206 2.0389 4.83856 2.49407C4.56507 2.94924 4.41363 3.46742 4.39893 3.99841C4.38423 4.5294 4.50677 5.05519 4.75467 5.52482H1.81767C1.36667 5.52482 1 5.89195 1 6.34351V9.73759C1 10.1873 1.36667 10.5544 1.81767 10.5544H2.13117V21.0506C2.13117 22.1262 3.00567 23 4.08 23H19.92C20.9943 23 21.8688 22.1262 21.8688 21.0506V10.5544H22.1842C22.6333 10.5544 23 10.1873 23 9.73759V6.34168C23.0002 6.23461 22.9793 6.12856 22.9384 6.02963C22.8975 5.93071 22.8374 5.84087 22.7617 5.76529ZM10.9092 5.52666H7.47167C7.08867 5.52617 6.72149 5.37362 6.45067 5.10246C6.17985 4.8313 6.02748 4.46367 6.027 4.08019C6.02797 3.69685 6.18048 3.3295 6.4512 3.05844C6.72192 2.78739 7.08881 2.63468 7.47167 2.63371C8.2215 2.63371 9.13083 3.1844 9.96867 4.1481C10.3427 4.57948 10.6782 5.07326 10.9073 5.52482L10.9092 5.52666ZM13.0358 6.53442V22.0914H10.9642V6.53442H13.0358ZM17.9712 4.08019C17.9697 4.4632 17.817 4.83008 17.5463 5.10074C17.2757 5.3714 16.909 5.52386 16.5265 5.52482H13.0908C13.3182 5.07326 13.6537 4.57948 14.0295 4.1481C14.8673 3.1844 15.7767 2.63371 16.5283 2.63371C17.3258 2.63371 17.973 3.28352 17.973 4.08019H17.9712Z"
      fill="url(#paint0_linear_6313_9370)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6313_9370"
        x1="1"
        y1="1"
        x2="22.6056"
        y2="23.3808"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-tab-active-start)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-tab-active-end)" }}
        />
      </linearGradient>
    </defs>
  </svg>
);

// 首页导航栏默认态图标（白色半透明渐变，用于底部导航未选中状态）
export const EventDefaultIcon: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.7617 5.76529C22.6859 5.68931 22.5959 5.62911 22.4967 5.58815C22.3976 5.5472 22.2914 5.5263 22.1842 5.52666H19.2453C19.4937 5.05683 19.6166 4.53067 19.6021 3.99927C19.5875 3.46786 19.436 2.94925 19.1622 2.49376C18.8885 2.03827 18.5017 1.66138 18.0396 1.39965C17.5775 1.13792 17.0556 1.00025 16.5247 1C14.8527 0.998166 13.4722 2.29779 12.7993 3.07426C12.5061 3.4108 12.2389 3.76917 12 4.14627C11.7672 3.77914 11.494 3.41202 11.2007 3.0761C10.526 2.29963 9.1455 1 7.4735 1C6.94297 1.00074 6.42163 1.13867 5.95999 1.40043C5.49835 1.66219 5.11206 2.0389 4.83856 2.49407C4.56507 2.94924 4.41363 3.46742 4.39893 3.99841C4.38423 4.5294 4.50677 5.05519 4.75467 5.52482H1.81767C1.36667 5.52482 1 5.89195 1 6.34351V9.73759C1 10.1873 1.36667 10.5544 1.81767 10.5544H2.13117V21.0506C2.13117 22.1262 3.00567 23 4.08 23H19.92C20.9943 23 21.8688 22.1262 21.8688 21.0506V10.5544H22.1842C22.6333 10.5544 23 10.1873 23 9.73759V6.34168C23.0002 6.23461 22.9793 6.12856 22.9384 6.02963C22.8975 5.93071 22.8374 5.84087 22.7617 5.76529ZM10.9092 5.52666H7.47167C7.08867 5.52617 6.72149 5.37362 6.45067 5.10246C6.17985 4.8313 6.02748 4.46367 6.027 4.08019C6.02797 3.69685 6.18048 3.3295 6.4512 3.05844C6.72192 2.78739 7.08881 2.63468 7.47167 2.63371C8.2215 2.63371 9.13083 3.1844 9.96867 4.1481C10.3427 4.57948 10.6782 5.07326 10.9073 5.52482L10.9092 5.52666ZM13.0358 6.53442V22.0914H10.9642V6.53442H13.0358ZM17.9712 4.08019C17.9697 4.4632 17.817 4.83008 17.5463 5.10074C17.2757 5.3714 16.909 5.52386 16.5265 5.52482H13.0908C13.3182 5.07326 13.6537 4.57948 14.0295 4.1481C14.8673 3.1844 15.7767 2.63371 16.5283 2.63371C17.3258 2.63371 17.973 3.28352 17.973 4.08019H17.9712Z"
      fill="url(#paint0_linear_6313_9376)"
    />
    <path
      d="M22.7617 5.76529C22.6859 5.68931 22.5959 5.62911 22.4967 5.58815C22.3976 5.5472 22.2914 5.5263 22.1842 5.52666H19.2453C19.4937 5.05683 19.6166 4.53067 19.6021 3.99927C19.5875 3.46786 19.436 2.94925 19.1622 2.49376C18.8885 2.03827 18.5017 1.66138 18.0396 1.39965C17.5775 1.13792 17.0556 1.00025 16.5247 1C14.8527 0.998166 13.4722 2.29779 12.7993 3.07426C12.5061 3.4108 12.2389 3.76917 12 4.14627C11.7672 3.77914 11.494 3.41202 11.2007 3.0761C10.526 2.29963 9.1455 1 7.4735 1C6.94297 1.00074 6.42163 1.13867 5.95999 1.40043C5.49835 1.66219 5.11206 2.0389 4.83856 2.49407C4.56507 2.94924 4.41363 3.46742 4.39893 3.99841C4.38423 4.5294 4.50677 5.05519 4.75467 5.52482H1.81767C1.36667 5.52482 1 5.89195 1 6.34351V9.73759C1 10.1873 1.36667 10.5544 1.81767 10.5544H2.13117V21.0506C2.13117 22.1262 3.00567 23 4.08 23H19.92C20.9943 23 21.8688 22.1262 21.8688 21.0506V10.5544H22.1842C22.6333 10.5544 23 10.1873 23 9.73759V6.34168C23.0002 6.23461 22.9793 6.12856 22.9384 6.02963C22.8975 5.93071 22.8374 5.84087 22.7617 5.76529ZM10.9092 5.52666H7.47167C7.08867 5.52617 6.72149 5.37362 6.45067 5.10246C6.17985 4.8313 6.02748 4.46367 6.027 4.08019C6.02797 3.69685 6.18048 3.3295 6.4512 3.05844C6.72192 2.78739 7.08881 2.63468 7.47167 2.63371C8.2215 2.63371 9.13083 3.1844 9.96867 4.1481C10.3427 4.57948 10.6782 5.07326 10.9073 5.52482L10.9092 5.52666ZM13.0358 6.53442V22.0914H10.9642V6.53442H13.0358ZM17.9712 4.08019C17.9697 4.4632 17.817 4.83008 17.5463 5.10074C17.2757 5.3714 16.909 5.52386 16.5265 5.52482H13.0908C13.3182 5.07326 13.6537 4.57948 14.0295 4.1481C14.8673 3.1844 15.7767 2.63371 16.5283 2.63371C17.3258 2.63371 17.973 3.28352 17.973 4.08019H17.9712Z"
      fill="url(#paint1_radial_6313_9376)"
      fillOpacity="0.15"
    />
    <path
      d="M16.5244 1.25C17.0121 1.25023 17.4915 1.37682 17.916 1.61719C18.3406 1.85762 18.6967 2.20359 18.9482 2.62207C19.1998 3.04058 19.3391 3.51756 19.3525 4.00586C19.3659 4.49424 19.2527 4.97839 19.0244 5.41016L18.8301 5.77637H22.1846C22.2587 5.77612 22.3328 5.791 22.4014 5.81934C22.4699 5.84767 22.5325 5.88885 22.585 5.94141V5.94238C22.6373 5.99459 22.6787 6.05663 22.707 6.125C22.7353 6.19336 22.7501 6.26681 22.75 6.34082V9.7373C22.75 10.0491 22.4952 10.3045 22.1846 10.3047H21.6191V21.0508C21.619 21.9883 20.8561 22.75 19.9199 22.75H4.08008C3.14388 22.75 2.38098 21.9883 2.38086 21.0508V10.3047H1.81738C1.50451 10.3045 1.25 10.0488 1.25 9.7373V6.34375L1.26172 6.22852C1.31498 5.96984 1.54412 5.77455 1.81738 5.77441H5.16895L4.97559 5.4082C4.74778 4.97662 4.63493 4.49288 4.64844 4.00488C4.66201 3.51712 4.80156 3.04115 5.05273 2.62305C5.304 2.20488 5.659 1.85866 6.08301 1.61816C6.45428 1.40765 6.86783 1.2838 7.29199 1.25586L7.47363 1.25C8.24425 1.25003 8.95967 1.54959 9.57324 1.95508C10.1863 2.36027 10.6831 2.86205 11.0117 3.24023H11.0127C11.2976 3.56646 11.563 3.92377 11.7891 4.28027L12 4.61328L12.2109 4.28027C12.3851 4.00533 12.5751 3.74047 12.7793 3.4873L12.9883 3.23828C13.3158 2.86032 13.8122 2.35899 14.4248 1.9541C14.9615 1.59944 15.5767 1.32592 16.2383 1.26367L16.5244 1.25ZM10.7139 22.3418H13.2861V6.28418H10.7139V22.3418ZM7.4707 2.38379C7.0218 2.38501 6.59176 2.56411 6.27441 2.88184C5.95711 3.19954 5.7786 3.62995 5.77734 4.0791V4.08008C5.77791 4.52961 5.9559 4.96131 6.27344 5.2793C6.59104 5.5973 7.02238 5.7758 7.47168 5.77637H11.5117L11.1064 5.37012C10.9295 5.02901 10.6994 4.66848 10.4385 4.3291L10.1572 3.98438L9.99609 3.80469C9.18275 2.92763 8.27762 2.3838 7.47168 2.38379H7.4707ZM16.5283 2.38379C15.6671 2.38379 14.6943 3.00179 13.8408 3.9834C13.4528 4.42881 13.1049 4.94003 12.8672 5.41211L12.6855 5.77441H16.5273C16.9759 5.77322 17.4054 5.59457 17.7227 5.27734C17.9807 5.01933 18.146 4.68669 18.2002 4.33008H18.2227V4.08008C18.2226 3.1459 17.4644 2.38379 16.5283 2.38379Z"
      stroke="url(#paint2_linear_6313_9376)"
      strokeOpacity="0.2"
      strokeWidth="0.5"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6313_9376"
        x1="12"
        y1="1"
        x2="12"
        y2="23"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-tab-default-start)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-tab-default-end)" }}
        />
      </linearGradient>
      <radialGradient
        id="paint1_radial_6313_9376"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(12 1) rotate(90) scale(18.0714 22.9904)"
      >
        <stop style={{ stopColor: "var(--color-icon-tab-default-radial)" }} />
        <stop
          offset="1"
          style={{
            stopColor: "var(--color-icon-tab-default-radial)",
            stopOpacity: 0,
          }}
        />
      </radialGradient>
      <linearGradient
        id="paint2_linear_6313_9376"
        x1="12"
        y1="1"
        x2="12"
        y2="23"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-tab-default-stroke-start)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-tab-default-stroke-end)" }}
        />
      </linearGradient>
    </defs>
  </svg>
);

export const RewardActiveIcon: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.66771 11.836C2.59503 11.4698 1.66631 10.7916 1.00945 9.89459C0.352601 8.99763 -7.32871e-05 7.92611 1.14232e-08 6.82759V3.03448C1.75282e-08 2.63209 0.165561 2.24617 0.460261 1.96163C0.754961 1.67709 1.15466 1.51724 1.57143 1.51724H3.14286V0H18.8571V1.51724H20.4286C20.8453 1.51724 21.245 1.67709 21.5397 1.96163C21.8344 2.24617 22 2.63209 22 3.03448V6.82759C22 9.13986 20.4694 11.1062 18.3323 11.836C17.8083 13.1442 16.9192 14.2868 15.7636 15.1368C14.6081 15.9869 13.2312 16.5112 11.7857 16.6517V18.9655H14.9286C15.3453 18.9655 15.745 19.1254 16.0397 19.4099C16.3344 19.6944 16.5 20.0804 16.5 20.4828C16.5 20.8852 16.3344 21.2711 16.0397 21.5556C15.745 21.8401 15.3453 22 14.9286 22H7.07143C6.65466 22 6.25496 21.8401 5.96026 21.5556C5.66556 21.2711 5.5 20.8852 5.5 20.4828C5.5 20.0804 5.66556 19.6944 5.96026 19.4099C6.25496 19.1254 6.65466 18.9655 7.07143 18.9655H10.2143V16.6517C8.76884 16.5112 7.39195 15.9869 6.23637 15.1368C5.08079 14.2868 4.19169 13.1442 3.66771 11.836ZM3.18529 9.89241C3.15712 9.6303 3.14296 9.36697 3.14286 9.10345V3.03448H1.57143V6.82759C1.57143 8.0869 2.20629 9.20207 3.18529 9.89241ZM18.8571 3.03448V9.10345C18.8571 9.37048 18.8414 9.63448 18.8147 9.89241C19.315 9.54064 19.722 9.07959 20.0025 8.54694C20.2829 8.01429 20.429 7.42513 20.4286 6.82759V3.03448H18.8571Z"
      fill="url(#paint0_linear_6313_9458)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6313_9458"
        x1="0"
        y1="0"
        x2="21.6056"
        y2="22.3808"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-tab-active-start)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-tab-active-end)" }}
        />
      </linearGradient>
    </defs>
  </svg>
);

// 首页导航栏默认态图标（白色半透明渐变，用于底部导航未选中状态）
export const RewardDefaultIcon: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.66771 11.836C2.59503 11.4698 1.66631 10.7916 1.00945 9.89459C0.352601 8.99763 -7.32871e-05 7.92611 1.14232e-08 6.82759V3.03448C1.75282e-08 2.63209 0.165561 2.24617 0.460261 1.96163C0.754961 1.67709 1.15466 1.51724 1.57143 1.51724H3.14286V0H18.8571V1.51724H20.4286C20.8453 1.51724 21.245 1.67709 21.5397 1.96163C21.8344 2.24617 22 2.63209 22 3.03448V6.82759C22 9.13986 20.4694 11.1062 18.3323 11.836C17.8083 13.1442 16.9192 14.2868 15.7636 15.1368C14.6081 15.9869 13.2312 16.5112 11.7857 16.6517V18.9655H14.9286C15.3453 18.9655 15.745 19.1254 16.0397 19.4099C16.3344 19.6944 16.5 20.0804 16.5 20.4828C16.5 20.8852 16.3344 21.2711 16.0397 21.5556C15.745 21.8401 15.3453 22 14.9286 22H7.07143C6.65466 22 6.25496 21.8401 5.96026 21.5556C5.66556 21.2711 5.5 20.8852 5.5 20.4828C5.5 20.0804 5.66556 19.6944 5.96026 19.4099C6.25496 19.1254 6.65466 18.9655 7.07143 18.9655H10.2143V16.6517C8.76884 16.5112 7.39195 15.9869 6.23637 15.1368C5.08079 14.2868 4.19169 13.1442 3.66771 11.836ZM3.18529 9.89241C3.15712 9.6303 3.14296 9.36697 3.14286 9.10345V3.03448H1.57143V6.82759C1.57143 8.0869 2.20629 9.20207 3.18529 9.89241ZM18.8571 3.03448V9.10345C18.8571 9.37048 18.8414 9.63448 18.8147 9.89241C19.315 9.54064 19.722 9.07959 20.0025 8.54694C20.2829 8.01429 20.429 7.42513 20.4286 6.82759V3.03448H18.8571Z"
      fill="url(#paint0_linear_6313_9456)"
    />
    <path
      d="M3.66771 11.836C2.59503 11.4698 1.66631 10.7916 1.00945 9.89459C0.352601 8.99763 -7.32871e-05 7.92611 1.14232e-08 6.82759V3.03448C1.75282e-08 2.63209 0.165561 2.24617 0.460261 1.96163C0.754961 1.67709 1.15466 1.51724 1.57143 1.51724H3.14286V0H18.8571V1.51724H20.4286C20.8453 1.51724 21.245 1.67709 21.5397 1.96163C21.8344 2.24617 22 2.63209 22 3.03448V6.82759C22 9.13986 20.4694 11.1062 18.3323 11.836C17.8083 13.1442 16.9192 14.2868 15.7636 15.1368C14.6081 15.9869 13.2312 16.5112 11.7857 16.6517V18.9655H14.9286C15.3453 18.9655 15.745 19.1254 16.0397 19.4099C16.3344 19.6944 16.5 20.0804 16.5 20.4828C16.5 20.8852 16.3344 21.2711 16.0397 21.5556C15.745 21.8401 15.3453 22 14.9286 22H7.07143C6.65466 22 6.25496 21.8401 5.96026 21.5556C5.66556 21.2711 5.5 20.8852 5.5 20.4828C5.5 20.0804 5.66556 19.6944 5.96026 19.4099C6.25496 19.1254 6.65466 18.9655 7.07143 18.9655H10.2143V16.6517C8.76884 16.5112 7.39195 15.9869 6.23637 15.1368C5.08079 14.2868 4.19169 13.1442 3.66771 11.836ZM3.18529 9.89241C3.15712 9.6303 3.14296 9.36697 3.14286 9.10345V3.03448H1.57143V6.82759C1.57143 8.0869 2.20629 9.20207 3.18529 9.89241ZM18.8571 3.03448V9.10345C18.8571 9.37048 18.8414 9.63448 18.8147 9.89241C19.315 9.54064 19.722 9.07959 20.0025 8.54694C20.2829 8.01429 20.429 7.42513 20.4286 6.82759V3.03448H18.8571Z"
      fill="url(#paint1_radial_6313_9456)"
      fillOpacity="0.15"
    />
    <path
      d="M1.32129 6.82715C1.32129 8.17331 2.00043 9.36284 3.04102 10.0967L3.49316 10.415L3.43359 9.86523C3.40642 9.61218 3.39268 9.35792 3.39258 9.10352V2.78418H1.32129V6.82715ZM18.6074 9.10352C18.6074 9.36061 18.5923 9.61579 18.5664 9.86621L18.5098 10.4131L18.959 10.0967C19.4909 9.72253 19.9245 9.23122 20.2236 8.66309C20.5228 8.09481 20.6791 7.46556 20.6787 6.82715V2.78418H18.6074V9.10352ZM10.4639 16.4248L10.2383 16.4033C8.83723 16.2671 7.5035 15.7584 6.38477 14.9355C5.26601 14.1126 4.40574 13.0073 3.89941 11.7432L3.85742 11.6367L3.74805 11.5996L3.55762 11.5303C2.61333 11.1676 1.79773 10.5484 1.21094 9.74707C0.585063 8.89241 0.24993 7.87186 0.25 6.82715V3.03418C0.250083 2.70114 0.387043 2.3799 0.633789 2.1416C0.880953 1.90296 1.2181 1.76761 1.57129 1.76758H3.39258V0.25H18.6074V1.76758H20.4287C20.7819 1.76761 21.119 1.90296 21.3662 2.1416C21.613 2.3799 21.7499 2.70114 21.75 3.03418V6.82715C21.75 9.02443 20.2954 10.9016 18.252 11.5996L18.1426 11.6367L18.1006 11.7432C17.5943 13.0073 16.734 14.1126 15.6152 14.9355C14.4965 15.7584 13.1628 16.2671 11.7617 16.4033L11.5361 16.4248V19.2158H14.9287C15.2819 19.2159 15.619 19.3512 15.8662 19.5898C16.113 19.8281 16.2499 20.1494 16.25 20.4824C16.25 20.8156 16.1131 21.1376 15.8662 21.376C15.6191 21.6146 15.2819 21.75 14.9287 21.75H7.07129C6.71812 21.75 6.38095 21.6146 6.13379 21.376C5.88689 21.1376 5.75 20.8156 5.75 20.4824C5.75009 20.1494 5.88704 19.8281 6.13379 19.5898C6.38095 19.3512 6.7181 19.2159 7.07129 19.2158H10.4639V16.4248Z"
      stroke="url(#paint2_linear_6313_9456)"
      strokeOpacity="0.2"
      strokeWidth="0.5"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6313_9456"
        x1="11"
        y1="3.07334e-08"
        x2="11"
        y2="22"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-tab-default-start)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-tab-default-end)" }}
        />
      </linearGradient>
      <radialGradient
        id="paint1_radial_6313_9456"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(11) rotate(90) scale(18.0714 22.9904)"
      >
        <stop style={{ stopColor: "var(--color-icon-tab-default-radial)" }} />
        <stop
          offset="1"
          style={{
            stopColor: "var(--color-icon-tab-default-radial)",
            stopOpacity: 0,
          }}
        />
      </radialGradient>
      <linearGradient
        id="paint2_linear_6313_9456"
        x1="11"
        y1="0"
        x2="11"
        y2="22"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-tab-default-stroke-start)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-tab-default-stroke-end)" }}
        />
      </linearGradient>
    </defs>
  </svg>
);

export const ProfileActiveIcon: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
    viewBox="-2 -1 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.82993 12.9648C4.32785 12.5241 5.03944 12.5977 5.5018 13.0752C6.63987 14.2502 8.20461 14.9844 9.94711 14.9844C11.6896 14.9844 13.2544 14.2502 14.3924 13.0752C14.8548 12.5977 15.5664 12.5608 16.0643 12.9648C18.0559 14.6543 19.4785 16.821 19.9764 19.7959C20.1542 21.0079 19.3005 22 18.1268 22H1.87387C0.664629 22 -0.153569 21.0079 0.024261 19.7959C0.486618 16.821 1.90941 14.6543 3.82993 12.9648ZM9.98227 0C11.6519 0 13.2538 0.685154 14.4344 1.9043C15.6148 3.12341 16.2782 4.77698 16.2782 6.50098C16.2781 8.22499 15.6149 9.87856 14.4344 11.0977C13.2538 12.3168 11.6519 13.002 9.98227 13.002C8.31286 13.0018 6.71156 12.3167 5.5311 11.0977C4.35063 9.87856 3.68738 8.225 3.68735 6.50098C3.68735 4.77697 4.35069 3.12341 5.5311 1.9043C6.71156 0.685268 8.31286 0.000127933 9.98227 0Z"
      fill="url(#paint0_linear_7305_1004)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7305_1004"
        x1="0"
        y1="0"
        x2="21.5801"
        y2="20.3221"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-tab-active-start)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-tab-active-end)" }}
        />
      </linearGradient>
    </defs>
  </svg>
);

// 首页导航栏默认态图标（白色半透明渐变，用于底部导航未选中状态）
export const ProfileDefaultIcon: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="path-1-inside-1_6313_9378" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.82993 13.9648C6.32785 13.5241 7.03944 13.5977 7.5018 14.0752C8.63987 15.2502 10.2046 15.9844 11.9471 15.9844C13.6896 15.9844 15.2544 15.2502 16.3924 14.0752C16.8548 13.5977 17.5664 13.5608 18.0643 13.9648C20.0559 15.6543 21.4785 17.821 21.9764 20.7959C22.1542 22.0079 21.3005 23 20.1268 23H3.87387C2.66463 23 1.84643 22.0079 2.02426 20.7959C2.48662 17.821 3.90941 15.6543 5.82993 13.9648ZM11.9823 1C13.6519 1 15.2538 1.68515 16.4344 2.9043C17.6148 4.12341 18.2782 5.77698 18.2782 7.50098C18.2781 9.22499 17.6149 10.8786 16.4344 12.0977C15.2538 13.3168 13.6519 14.002 11.9823 14.002C10.3129 14.0018 8.71156 13.3167 7.5311 12.0977C6.35063 10.8786 5.68738 9.225 5.68735 7.50098C5.68735 5.77697 6.35069 4.12341 7.5311 2.9043C8.71156 1.68527 10.3129 1.00013 11.9823 1Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.82993 13.9648C6.32785 13.5241 7.03944 13.5977 7.5018 14.0752C8.63987 15.2502 10.2046 15.9844 11.9471 15.9844C13.6896 15.9844 15.2544 15.2502 16.3924 14.0752C16.8548 13.5977 17.5664 13.5608 18.0643 13.9648C20.0559 15.6543 21.4785 17.821 21.9764 20.7959C22.1542 22.0079 21.3005 23 20.1268 23H3.87387C2.66463 23 1.84643 22.0079 2.02426 20.7959C2.48662 17.821 3.90941 15.6543 5.82993 13.9648ZM11.9823 1C13.6519 1 15.2538 1.68515 16.4344 2.9043C17.6148 4.12341 18.2782 5.77698 18.2782 7.50098C18.2781 9.22499 17.6149 10.8786 16.4344 12.0977C15.2538 13.3168 13.6519 14.002 11.9823 14.002C10.3129 14.0018 8.71156 13.3167 7.5311 12.0977C6.35063 10.8786 5.68738 9.225 5.68735 7.50098C5.68735 5.77697 6.35069 4.12341 7.5311 2.9043C8.71156 1.68527 10.3129 1.00013 11.9823 1Z"
      fill="url(#paint0_linear_6313_9378)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.82993 13.9648C6.32785 13.5241 7.03944 13.5977 7.5018 14.0752C8.63987 15.2502 10.2046 15.9844 11.9471 15.9844C13.6896 15.9844 15.2544 15.2502 16.3924 14.0752C16.8548 13.5977 17.5664 13.5608 18.0643 13.9648C20.0559 15.6543 21.4785 17.821 21.9764 20.7959C22.1542 22.0079 21.3005 23 20.1268 23H3.87387C2.66463 23 1.84643 22.0079 2.02426 20.7959C2.48662 17.821 3.90941 15.6543 5.82993 13.9648ZM11.9823 1C13.6519 1 15.2538 1.68515 16.4344 2.9043C17.6148 4.12341 18.2782 5.77698 18.2782 7.50098C18.2781 9.22499 17.6149 10.8786 16.4344 12.0977C15.2538 13.3168 13.6519 14.002 11.9823 14.002C10.3129 14.0018 8.71156 13.3167 7.5311 12.0977C6.35063 10.8786 5.68738 9.225 5.68735 7.50098C5.68735 5.77697 6.35069 4.12341 7.5311 2.9043C8.71156 1.68527 10.3129 1.00013 11.9823 1Z"
      fill="url(#paint1_radial_6313_9378)"
      fillOpacity="0.15"
    />
    <path
      d="M5.82993 13.9648L6.16018 14.3403L6.16132 14.3392L5.82993 13.9648ZM7.5018 14.0752L7.14261 14.423L7.14264 14.4231L7.5018 14.0752ZM11.9471 15.9844L11.9471 16.4844H11.9471V15.9844ZM16.3924 14.0752L16.7516 14.4231L16.7516 14.423L16.3924 14.0752ZM18.0643 13.9648L18.3878 13.5835L18.3793 13.5766L18.0643 13.9648ZM21.9764 20.7959L22.4712 20.7233L22.4695 20.7134L21.9764 20.7959ZM2.02426 20.7959L1.53017 20.7191L1.52956 20.7233L2.02426 20.7959ZM11.9823 1V0.5H11.9822L11.9823 1ZM16.4344 2.9043L16.7936 2.55649L16.7936 2.55647L16.4344 2.9043ZM18.2782 7.50098L18.7782 7.50099V7.50098H18.2782ZM16.4344 12.0977L16.7936 12.4455L16.7936 12.4455L16.4344 12.0977ZM11.9823 14.002L11.9822 14.502H11.9823V14.002ZM7.5311 12.0977L7.1719 12.4455L7.17191 12.4455L7.5311 12.0977ZM5.68735 7.50098H5.18735V7.50099L5.68735 7.50098ZM7.5311 2.9043L7.17191 2.55647L7.17189 2.55649L7.5311 2.9043ZM5.82993 13.9648L6.16132 14.3392C6.43289 14.0989 6.84105 14.1116 7.14261 14.423L7.5018 14.0752L7.86099 13.7274C7.23783 13.0839 6.22281 12.9494 5.49853 13.5904L5.82993 13.9648ZM7.5018 14.0752L7.14264 14.4231C8.36791 15.6881 10.0595 16.4844 11.9471 16.4844L11.9471 15.9844V15.4844C10.3497 15.4844 8.91184 14.8123 7.86096 13.7273L7.5018 14.0752ZM11.9471 15.9844V16.4844C13.8347 16.4844 15.5263 15.6881 16.7516 14.4231L16.3924 14.0752L16.0333 13.7273C14.9824 14.8123 13.5445 15.4844 11.9471 15.4844V15.9844ZM16.3924 14.0752L16.7516 14.423C17.0348 14.1306 17.4539 14.1134 17.7493 14.3531L18.0643 13.9648L18.3793 13.5766C17.6789 13.0083 16.6748 13.0649 16.0332 13.7274L16.3924 14.0752ZM18.0643 13.9648L17.7409 14.3461C19.6527 15.9679 21.007 18.0327 21.4833 20.8784L21.9764 20.7959L22.4695 20.7134C21.95 17.6093 20.4591 15.3407 18.3877 13.5835L18.0643 13.9648ZM21.9764 20.7959L21.4817 20.8685C21.6168 21.7893 20.9848 22.5 20.1268 22.5V23V23.5C21.6162 23.5 22.6917 22.2265 22.4711 20.7233L21.9764 20.7959ZM20.1268 23V22.5H3.87387V23V23.5H20.1268V23ZM3.87387 23V22.5C2.98689 22.5 2.38288 21.796 2.51896 20.8685L2.02426 20.7959L1.52956 20.7233C1.30998 22.2198 2.34236 23.5 3.87387 23.5V23ZM2.02426 20.7959L2.51833 20.8727C2.96012 18.0301 4.31396 15.9644 6.16017 14.3403L5.82993 13.9648L5.49968 13.5894C3.50485 15.3443 2.01312 17.6119 1.53019 20.7191L2.02426 20.7959ZM11.9823 1V1.5C13.514 1.5 14.9871 2.12845 16.0752 3.25212L16.4344 2.9043L16.7936 2.55647C15.5206 1.24186 13.7897 0.5 11.9823 0.5V1ZM16.4344 2.9043L16.0752 3.2521C17.1637 4.37633 17.7782 5.90452 17.7782 7.50098H18.2782H18.7782C18.7782 5.64945 18.0659 3.8705 16.7936 2.55649L16.4344 2.9043ZM18.2782 7.50098L17.7782 7.50097C17.7781 9.09747 17.1638 10.6257 16.0752 11.7498L16.4344 12.0977L16.7936 12.4455C18.066 11.1315 18.7781 9.3525 18.7782 7.50099L18.2782 7.50098ZM16.4344 12.0977L16.0752 11.7498C14.9871 12.8735 13.514 13.502 11.9823 13.502V14.002V14.502C13.7897 14.502 15.5206 13.7601 16.7936 12.4455L16.4344 12.0977ZM11.9823 14.002L11.9823 13.502C10.4508 13.5018 8.97834 12.8734 7.89029 11.7498L7.5311 12.0977L7.17191 12.4455C8.44478 13.7599 10.1749 14.5018 11.9822 14.502L11.9823 14.002ZM7.5311 12.0977L7.8903 11.7498C6.80173 10.6257 6.18738 9.09748 6.18735 7.50097L5.68735 7.50098L5.18735 7.50099C5.18739 9.35251 5.89953 11.1315 7.1719 12.4455L7.5311 12.0977ZM5.68735 7.50098H6.18735C6.18735 5.90451 6.80177 4.37633 7.89031 3.2521L7.5311 2.9043L7.17189 2.55649C5.8996 3.8705 5.18735 5.64944 5.18735 7.50098H5.68735ZM7.5311 2.9043L7.89029 3.25212C8.97834 2.12852 10.4508 1.50012 11.9823 1.5L11.9823 1L11.9822 0.5C10.1749 0.500138 8.44478 1.24201 7.17191 2.55647L7.5311 2.9043Z"
      fill="url(#paint2_linear_6313_9378)"
      fillOpacity="0.2"
      mask="url(#path-1-inside-1_6313_9378)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6313_9378"
        x1="12"
        y1="1"
        x2="12"
        y2="23"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-tab-default-start)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-tab-default-end)" }}
        />
      </linearGradient>
      <radialGradient
        id="paint1_radial_6313_9378"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(12 1) rotate(90) scale(18.0714 20.9003)"
      >
        <stop style={{ stopColor: "var(--color-icon-tab-default-radial)" }} />
        <stop
          offset="1"
          style={{
            stopColor: "var(--color-icon-tab-default-radial)",
            stopOpacity: 0,
          }}
        />
      </radialGradient>
      <linearGradient
        id="paint2_linear_6313_9378"
        x1="12"
        y1="1"
        x2="12"
        y2="23"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-tab-default-stroke-start)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-tab-default-stroke-end)" }}
        />
      </linearGradient>
    </defs>
  </svg>
);

// 设置图标SVG组件
export const SettingsIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  color = "currentColor",
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <circle cx="12" cy="12" r="3" stroke={color} strokeWidth="2" />
    <path
      d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// 通知图标SVG组件
export const NotificationIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  color = "currentColor",
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <path
      d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.73 21a2 2 0 0 1-3.46 0"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// 游戏图标SVG组件
export const GamesIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  color = "currentColor",
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <rect
      x="2"
      y="3"
      width="16"
      height="12"
      rx="2"
      ry="2"
      stroke={color}
      strokeWidth="2"
    />
    <line x1="8" y1="21" x2="8" y2="15" stroke={color} strokeWidth="2" />
    <line x1="12" y1="21" x2="12" y2="15" stroke={color} strokeWidth="2" />
    <line x1="2" y1="15" x2="22" y2="15" stroke={color} strokeWidth="2" />
  </svg>
);

// 心形图标SVG组件
export const HeartIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  color = "currentColor",
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <path
      d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// 星星图标SVG组件
export const StarIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  color = "currentColor",
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <polygon
      points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// 邀请码图标SVG组件
export const InviteCodeIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  className,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1024 1024"
    fill="none"
    width={width}
    height={height}
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <g transform="translate(112, 112) scale(0.78)">
      {/* 圆角矩形边框 — stroke 方式，线条更粗 */}
      <rect
        x="30"
        y="160"
        width="964"
        height="704"
        rx="110"
        ry="110"
        fill="none"
        stroke="url(#paint0_linear_invite_code)"
        strokeWidth="72"
      />
      <rect
        x="30"
        y="160"
        width="964"
        height="704"
        rx="110"
        ry="110"
        fill="none"
        stroke="url(#paint1_linear_invite_code)"
        strokeWidth="72"
      />
      {/* 左侧圆点 */}
      <circle cx="310" cy="512" r="68" fill="url(#paint1_linear_invite_code)" />
      {/* 中间圆点 */}
      <circle cx="512" cy="512" r="68" fill="url(#paint1_linear_invite_code)" />
      {/* 右侧圆点 */}
      <circle cx="714" cy="512" r="68" fill="url(#paint1_linear_invite_code)" />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_invite_code"
        x1="512"
        y1="889"
        x2="512"
        y2="135"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-header-start, currentColor)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-header-end, currentColor)" }}
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_invite_code"
        x1="512"
        y1="135"
        x2="512"
        y2="889"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-start, currentColor)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-end, currentColor)" }}
        />
      </linearGradient>
    </defs>
  </svg>
);

// Copy图标SVG组件
export const CopyIcon: React.FC<SvgIconProps> = ({
  width = 14,
  height = 14,
  className,
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 15"
    fill="none"
  >
    <path
      d="M9.04167 3.70833C9.27373 3.70833 9.49629 3.80052 9.66039 3.96462C9.82448 4.12871 9.91667 4.35127 9.91667 4.58333V12.75C9.91667 12.9821 9.82448 13.2046 9.66039 13.3687C9.49629 13.5328 9.27373 13.625 9.04167 13.625H2.625C2.51009 13.625 2.39631 13.6024 2.29015 13.5584C2.18399 13.5144 2.08753 13.45 2.00628 13.3687C1.92503 13.2875 1.86058 13.191 1.81661 13.0848C1.77263 12.9787 1.75 12.8649 1.75 12.75V4.58333C1.75 4.35127 1.84219 4.12871 2.00628 3.96462C2.17038 3.80052 2.39294 3.70833 2.625 3.70833H9.04167ZM8.75 4.875H2.91667V12.4583H8.75V4.875ZM11.3727 1.375C11.5903 1.37487 11.8001 1.45583 11.9613 1.60208C12.1224 1.74834 12.2233 1.94939 12.2442 2.166L12.2477 2.25V10.1209C12.2475 10.2696 12.1906 10.4126 12.0885 10.5207C11.9864 10.6288 11.8469 10.6939 11.6985 10.7026C11.5501 10.7113 11.4039 10.663 11.2899 10.5676C11.1759 10.4722 11.1026 10.3368 11.0851 10.1892L11.081 10.1209V2.54167H5.25C5.10712 2.54165 4.96922 2.48919 4.86245 2.39425C4.75568 2.29931 4.68747 2.16848 4.67075 2.02658L4.66667 1.95833C4.66669 1.81546 4.71914 1.67755 4.81408 1.57078C4.90903 1.46401 5.03985 1.3958 5.18175 1.37908L5.25 1.375H11.3727Z"
      fill="currentColor"
    />
  </svg>
);

// 加载图标SVG组件
export const LoadingIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  color = "currentColor",
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeDasharray="31.416"
      strokeDashoffset="31.416"
    >
      <animate
        attributeName="stroke-dasharray"
        dur="2s"
        values="0 31.416;15.708 15.708;0 31.416"
        repeatCount="indefinite"
      />
      <animate
        attributeName="stroke-dashoffset"
        dur="2s"
        values="0;-15.708;-31.416"
        repeatCount="indefinite"
      />
    </circle>
  </svg>
);

// 成功图标SVG组件
export const SuccessIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  color = "currentColor",
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <path
      d="M22 11.08V12a10 10 0 1 1-5.93-9.14"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polyline
      points="22,4 12,14.01 9,11.01"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// 警告图标SVG组件
export const WarningIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  color = "currentColor",
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <path
      d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="12"
      y1="9"
      x2="12"
      y2="13"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="12"
      y1="17"
      x2="12.01"
      y2="17"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// 错误图标SVG组件
export const ErrorIcon: React.FC<SvgIconProps> = ({
  width = 12,
  height = 12,
  color = "currentColor",
  className,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    color={color}
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M6 10.8C5.36965 10.8 4.74548 10.6758 4.16312 10.4346C3.58076 10.1934 3.05161 9.83983 2.60589 9.39411C2.16017 8.94839 1.8066 8.41924 1.56538 7.83688C1.32416 7.25452 1.2 6.63034 1.2 6C1.2 5.36965 1.32416 4.74548 1.56538 4.16312C1.8066 3.58076 2.16017 3.05161 2.60589 2.60589C3.05161 2.16017 3.58076 1.8066 4.16312 1.56538C4.74548 1.32416 5.36965 1.2 6 1.2C7.27304 1.2 8.49394 1.70571 9.39411 2.60589C10.2943 3.50606 10.8 4.72696 10.8 6C10.8 7.27304 10.2943 8.49394 9.39411 9.39411C8.49394 10.2943 7.27304 10.8 6 10.8ZM6 0C2.6862 0 0 2.6862 0 6C0 9.3138 2.6862 12 6 12C9.3138 12 12 9.3138 12 6C12 4.4087 11.3679 2.88258 10.2426 1.75736C9.11742 0.632141 7.5913 0 6 0ZM7.554 3.6L6 5.154L4.446 3.6L3.6 4.446L5.154 6L3.6 7.554L4.446 8.4L6 6.846L7.554 8.4L8.4 7.554L6.846 6L8.4 4.446L7.554 3.6Z"
      fill="#DC0000"
    />
  </svg>
);

// 信息图标SVG组件
export const InfoIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  color = "currentColor",
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" />
    <line
      x1="12"
      y1="16"
      x2="12"
      y2="12"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="12"
      y1="8"
      x2="12.01"
      y2="8"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// 眼睛图标SVG组件（显示/隐藏密码）
export const EyeIcon: React.FC<SvgIconProps> = ({
  width = 18,
  height = 14,
  color = "currentColor",
  variant,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 18 14"
    fill="none"
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    {variant === "golden" && (
      <defs>
        <linearGradient
          id="paint0_linear_eye"
          x1="9"
          y1="14"
          x2="9"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBF3B4" />
          <stop offset="1" stopColor="#FFC871" />
        </linearGradient>
      </defs>
    )}
    {variant === "custom" && (
      <defs>
        <linearGradient
          id="paint0_linear_eye_custom"
          x1="9"
          y1="0"
          x2="9"
          y2="14"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="#C7D8EF" />
          <stop offset="49.04%" stopColor="#98AEC9" />
          <stop offset="100%" stopColor="#9DB7D1" />
        </linearGradient>
      </defs>
    )}
    <path
      d="M9 14C3.4929 14 0 9.16305 0 7.12133V6.87952C0 4.8378 3.4929 0 9 0C14.5611 0 17.9811 4.77054 18 6.86845V7.12048C17.9811 9.2269 14.562 14 9 14ZM9 1.27799C4.3551 1.27799 1.35 5.44061 1.35 6.88037V7.12218C1.35 8.56194 4.3551 12.7237 9 12.7237C13.5711 12.7237 16.6347 8.73308 16.65 7.11707V6.87527C16.6347 5.26437 13.5711 1.27799 9 1.27799ZM9 10.3457C8.06238 10.3448 7.16342 9.99207 6.50033 9.36493C5.83725 8.7378 5.46419 7.88744 5.463 7.00043C5.463 5.15539 7.0497 3.65432 9 3.65432C10.9503 3.65432 12.537 5.15539 12.537 7.00043C12.5358 7.88744 12.1628 8.7378 11.4997 9.36493C10.8366 9.99207 9.93762 10.3448 9 10.3457ZM9 4.93146C7.794 4.93146 6.813 5.85951 6.813 7.00043C6.813 8.14048 7.794 9.06854 9 9.06854C10.206 9.06854 11.187 8.14048 11.187 7.00043C11.187 5.85951 10.206 4.93146 9 4.93146Z"
      fill={
        variant === "golden"
          ? "url(#paint0_linear_eye)"
          : variant === "custom"
            ? "url(#paint0_linear_eye_custom)"
            : color
      }
    />
  </svg>
);

// 闭眼图标SVG组件（显示/隐藏密码）
export const EyeClosedIcon: React.FC<SvgIconProps> = ({
  width = 18,
  height = 16,
  color = "currentColor",
  variant,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 18 16"
    fill="none"
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    {variant === "golden" && (
      <defs>
        <linearGradient
          id="paint0_linear_eye_closed"
          x1="9"
          y1="16"
          x2="9"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBF3B4" />
          <stop offset="1" stopColor="#FFC871" />
        </linearGradient>
      </defs>
    )}
    {variant === "custom" && (
      <defs>
        <linearGradient
          id="paint0_linear_eye_closed_custom"
          x1="9"
          y1="0"
          x2="9"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="#C7D8EF" />
          <stop offset="49.04%" stopColor="#98AEC9" />
          <stop offset="100%" stopColor="#9DB7D1" />
        </linearGradient>
      </defs>
    )}
    <path
      d="M2.39211 12.0246C0.858568 10.6574 0 9.06383 0 8.11423V7.88703C0 5.96862 3.49277 1.423 8.99967 1.423C10.6043 1.423 12.0227 1.803 13.2412 2.3814L12.2296 3.28061C11.2211 2.85134 10.1178 2.62672 8.99967 2.623C4.35494 2.623 1.34995 6.53422 1.34995 7.88703V8.11423C1.34995 8.77583 2.07172 10.047 3.34788 11.1742L2.39211 12.0246ZM17.9993 7.87743V8.11423C17.9804 10.0918 14.5615 14.5775 8.99967 14.5775C7.08994 14.5775 5.4313 14.0263 4.06875 13.2303L1.15196 15.8239C1.08941 15.8797 1.01508 15.924 0.933226 15.9542C0.851373 15.9844 0.76361 16 0.674975 16C0.58634 16 0.498577 15.9844 0.416724 15.9542C0.334871 15.924 0.260538 15.8797 0.197993 15.8239C0.13527 15.7681 0.0855126 15.702 0.0515649 15.6292C0.0176172 15.5563 0.000144049 15.4783 0.000144049 15.3995C0.000144049 15.3206 0.0176172 15.2426 0.0515649 15.1698C0.0855126 15.0969 0.13527 15.0308 0.197993 14.9751L16.8474 0.175793C16.9101 0.12006 16.9845 0.0758497 17.0664 0.0456871C17.1483 0.0155245 17.2361 0 17.3248 0C17.4135 0 17.5013 0.0155245 17.5832 0.0456871C17.6651 0.0758497 17.7395 0.12006 17.8022 0.175793C17.8649 0.231526 17.9147 0.297691 17.9486 0.37051C17.9825 0.443329 18 0.521376 18 0.600195C18 0.679014 17.9825 0.757061 17.9486 0.82988C17.9147 0.902699 17.8649 0.968863 17.8022 1.0246L15.0357 3.48381C16.9221 4.92781 17.9876 6.78462 17.9993 7.87743ZM10.9382 7.12542L8.0142 9.72384C8.31119 9.86064 8.64238 9.94384 8.99877 9.94384C10.2047 9.94384 11.1857 9.07183 11.1857 7.99983C11.1843 7.69481 11.0994 7.39468 10.9382 7.12542ZM16.6494 7.88223C16.6404 7.04462 15.6936 5.52542 14.0791 4.33341L11.921 6.25262C12.3043 6.75262 12.5374 7.35022 12.5374 7.99983C12.5365 8.83341 12.1635 9.63261 11.5005 10.222C10.8374 10.8115 9.93831 11.143 9.00057 11.1438C8.26889 11.1438 7.59662 10.9366 7.03414 10.595L5.05241 12.3566C6.16567 12.9607 7.49312 13.3767 9.00057 13.3767C13.5715 13.3767 16.635 9.62704 16.6503 8.10863V7.88223H16.6494ZM8.99967 6.05662C9.03297 6.05662 9.06356 6.06382 9.09686 6.06542L10.2245 5.06301C9.83351 4.92934 9.41859 4.85942 8.99967 4.85661C8.06192 4.85746 7.16286 5.18898 6.49977 5.77841C5.83669 6.36784 5.46375 7.16704 5.4628 8.00063C5.4628 8.38463 5.55189 8.74943 5.69409 9.08943L6.82175 8.08703C6.82175 8.05743 6.81275 8.03023 6.81275 8.00063C6.81275 6.92862 7.79371 6.05662 8.99967 6.05662Z"
      fill={
        variant === "golden"
          ? "url(#paint0_linear_eye_closed)"
          : variant === "custom"
            ? "url(#paint0_linear_eye_closed_custom)"
            : color
      }
    />
  </svg>
);

// 手机图标SVG组件
export const PhoneIcon: React.FC<SvgIconProps> = ({
  width = "1.25rem",
  height = "1.25rem",
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <rect
      x="3.6"
      y="1.6"
      width="12.8"
      height="16.8"
      rx="2.4"
      stroke="url(#paint0_phone_h)"
      strokeWidth="1.2"
    />
    <rect
      x="3.6"
      y="1.6"
      width="12.8"
      height="16.8"
      rx="2.4"
      stroke="url(#paint1_phone_v)"
      strokeWidth="1.2"
    />
    <rect
      x="7.8"
      y="3.8"
      width="4.4"
      height="0.6"
      rx="0.3"
      stroke="url(#paint2_phone_notch)"
      strokeWidth="0.6"
    />
    <circle
      cx="10"
      cy="15"
      r="0.75"
      stroke="url(#paint3_phone_btn)"
      strokeWidth="1.5"
    />
    <defs>
      <linearGradient
        id="paint0_phone_h"
        x1="10"
        y1="19"
        x2="10"
        y2="1"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-header-start, #F5E68A)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-header-end, #F6B447)" }}
        />
      </linearGradient>
      <linearGradient
        id="paint1_phone_v"
        x1="10"
        y1="1"
        x2="10"
        y2="19"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-start, #FAB137)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-end, #F9E56C)" }}
        />
      </linearGradient>
      <linearGradient
        id="paint2_phone_notch"
        x1="10"
        y1="4.7"
        x2="10"
        y2="3.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-header-start, #F5E68A)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-header-end, #F6B447)" }}
        />
      </linearGradient>
      <linearGradient
        id="paint3_phone_btn"
        x1="10"
        y1="16.5"
        x2="10"
        y2="13.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-header-start, #F5E68A)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-header-end, #F6B447)" }}
        />
      </linearGradient>
    </defs>
  </svg>
);

// 消息图标SVG组件
export const MessageIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  // color = "currentColor",
  className,
  // variant,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <g transform="translate(0, 2)">
      <defs>
        <linearGradient
          id="paint0_linear_message"
          x1="10"
          y1="3"
          x2="10"
          y2="17"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            style={{ stopColor: "var(--color-icon-start, currentColor)" }}
          />
          <stop
            offset="1"
            style={{ stopColor: "var(--color-icon-end, currentColor)" }}
          />
        </linearGradient>
      </defs>
      <path
        d="M4 3.5H16C16.8284 3.5 17.5 4.17157 17.5 5V13C17.5 13.8284 16.8284 14.5 16 14.5H12.3242L10 16.3594L7.67578 14.5H4C3.17157 14.5 2.5 13.8284 2.5 13V5C2.5 4.17157 3.17157 3.5 4 3.5ZM4.5 4C3.67157 4 3 4.67157 3 5.5V12.5C3 13.3284 3.67157 14 4.5 14H7.8125L9.6709 15.626L10 15.9141L10.3291 15.626L12.1875 14H15.5C16.3284 14 17 13.3284 17 12.5V5.5C17 4.67157 16.3284 4 15.5 4H4.5ZM6.25 10.5H9.75C9.88807 10.5 10 10.6119 10 10.75C10 10.8881 9.88807 11 9.75 11H6.25C6.11193 11 6 10.8881 6 10.75C6 10.6119 6.11193 10.5 6.25 10.5ZM6.25 7H13.75C13.8881 7 14 7.11193 14 7.25C14 7.38807 13.8881 7.5 13.75 7.5H6.25C6.11193 7.5 6 7.38807 6 7.25C6 7.11193 6.11193 7 6.25 7Z"
        fill={"url(#paint0_linear_message)"}
        stroke={"url(#paint0_linear_message)"}
      />
    </g>
  </svg>
);

// 金币图标SVG组件
export const CoinIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  color = "currentColor",
  className,
  variant,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    {variant === "golden" && (
      <defs>
        <linearGradient
          id="paint0_linear_coin"
          x1="10"
          y1="18"
          x2="10"
          y2="2"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBF3B4" />
          <stop offset="1" stopColor="#FFC871" />
        </linearGradient>
      </defs>
    )}
    <circle
      cx="10"
      cy="10"
      r="8"
      fill={variant === "golden" ? "url(#paint0_linear_coin)" : color}
    />
    <text
      x="10"
      y="14"
      fontSize="10"
      fontWeight="bold"
      textAnchor="middle"
      fill="#6B4A28"
    >
      ₹
    </text>
  </svg>
);

// 默认图标SVG组件（问号）
export const DefaultIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  color = "currentColor",
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" />
    <path
      d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="12"
      y1="17"
      x2="12.01"
      y2="17"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// 历史图标SVG组件
export const HistoryIcon: React.FC<SvgIconProps> = ({
  width = "1.5rem",
  height = "1.5rem",
  className,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <defs>
      <filter
        id="history_filter0"
        x="4"
        y="2"
        width="16"
        height="20"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.3" dy="0.3" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend mode="overlay" in2="shape" result="effect1_innerShadow" />
      </filter>
      <filter
        id="history_filter1"
        x="15"
        y="14.5996"
        width="7.3999"
        height="7.40002"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.3" dy="0.3" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend mode="overlay" in2="shape" result="effect1_innerShadow" />
      </filter>
      <linearGradient
        id="history_grad0"
        x1="12"
        y1="6"
        x2="12"
        y2="17"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-header-start, currentColor)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-header-end, currentColor)" }}
        />
      </linearGradient>
      <linearGradient
        id="history_grad1"
        x1="18.7"
        y1="16.0796"
        x2="18.7"
        y2="20.1496"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-header-start, currentColor)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-header-end, currentColor)" }}
        />
      </linearGradient>
    </defs>
    <g filter={"url(#history_filter0)"}>
      <path
        d="M18.1935 2C19.1912 2 20 2.80809 20 3.80493L20 13.9046C19.5318 13.7393 19.028 13.6494 18.5032 13.6494C16.0232 13.6494 14.0129 15.6572 14.0129 18.1339C14.0129 19.7807 14.9017 21.2202 16.2263 22L5.80645 21.9999C4.80877 21.9999 4 21.1918 4 20.195V3.80493C4 2.80809 4.80877 2 5.80645 2H18.1935ZM13.6003 12.6185H6.0642C5.6938 12.6185 5.39355 12.9185 5.39355 13.2886C5.39355 13.6587 5.6938 13.9587 6.0642 13.9587H13.6003C13.9707 13.9587 14.2709 13.6587 14.2709 13.2886C14.2709 12.9185 13.9707 12.6185 13.6003 12.6185ZM17.9358 9.01027H6.0642C5.6938 9.01027 5.39355 9.31027 5.39355 9.68036C5.39355 10.0504 5.6938 10.3505 6.0642 10.3505H17.9358C18.3062 10.3505 18.6064 10.0505 18.6064 9.68036C18.6064 9.31029 18.3062 9.01027 17.9358 9.01027ZM13.6003 5.40204H6.0642C5.6938 5.40204 5.39355 5.70204 5.39355 6.07213C5.39355 6.44222 5.6938 6.74224 6.0642 6.74224H13.6003C13.9707 6.74224 14.2709 6.44224 14.2709 6.07213C14.2709 5.70206 13.9707 5.40204 13.6003 5.40204Z"
        fill={"url(#history_grad0)"}
      />
    </g>
    <g filter={"url(#history_filter1)"}>
      <path
        d="M18.7 14.5996C16.6759 14.5996 15 16.2755 15 18.2996C15 20.3237 16.6759 21.9996 18.7 21.9996C20.7241 21.9996 22.4 20.3455 22.4 18.2996C22.4 16.2537 20.7459 14.5996 18.7 14.5996ZM20.2888 18.4302C20.3106 18.6261 20.1582 18.7784 19.9841 18.7784H18.8306C18.7653 18.8002 18.6782 18.7784 18.5694 18.7784H18.5476C18.3518 18.7784 18.1994 18.8437 18.1994 18.6478V16.5584C18.1994 16.3626 18.3735 16.2102 18.5476 16.2102C18.7435 16.2102 18.8959 16.3843 18.8959 16.5584V18.0602H19.9406C20.1365 18.0602 20.2671 18.2126 20.2671 18.3867C20.2888 18.4084 20.2888 18.4302 20.2888 18.4302Z"
        fill={"url(#history_grad1)"}
      />
    </g>
  </svg>
);

// VIP右上角icon
export const VipTopRightIcon: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  color = "currentColor",
  className,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default", color }}
    viewBox="0 0 24 24"
    fill="none"
  >
    {/* 圆圈背景带镂空勾勾 */}
    <mask id="vipCheckMask">
      <circle cx="17" cy="19" r="5" fill="white" />
      <path
        d="M14.8 19.2L16.2 20.8L19.5 17.2"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </mask>
    <circle
      cx="17"
      cy="19"
      r="5"
      fill="url(#vipTopRight_grad)"
      mask="url(#vipCheckMask)"
    />
    {/* 顶部标签部分 */}
    <path
      d="M14.7955 1.39623H13.371C13.3852 0.641257 12.7869 0.0144883 12.0177 0.000243503H10.5363C9.76706 -0.0140012 9.14029 0.598523 9.14029 1.36774V1.41047H7.71582V4.23093H14.7812V1.39623H14.7955ZM11.9038 2.6925C11.7471 2.86344 11.5192 2.96315 11.277 2.96315C11.0348 2.96315 10.8069 2.87768 10.6502 2.6925C10.4935 2.52156 10.3938 2.29365 10.4081 2.06573C10.4081 1.58141 10.8069 1.18256 11.3055 1.18256C11.5334 1.18256 11.7471 1.26803 11.918 1.42472C12.0774 1.5982 12.1646 1.82589 12.1619 2.06143C12.1593 2.29697 12.067 2.52264 11.9038 2.6925Z"
      fill="url(#vipTopRight_grad)"
    />
    <path
      d="M10.4651 19.0028V18.3475H6.33413C5.55067 18.3475 4.9239 17.7207 4.90966 16.9373V16.923C4.90966 16.5527 5.0521 16.1965 5.32275 15.9401C5.5934 15.6695 5.94952 15.527 6.31988 15.527H11.4907C12.4451 14.0171 14.012 12.9915 15.7784 12.7066H6.33413C5.55067 12.7066 4.9239 12.0798 4.90966 11.2963V11.2821C4.90966 10.9117 5.0521 10.5414 5.32275 10.285C5.5934 10.0286 5.94952 9.87187 6.31988 9.88612H16.1915C16.5619 9.87187 16.9322 10.0286 17.2029 10.285C17.4735 10.5414 17.6302 10.9117 17.616 11.2821C17.616 11.567 17.5305 11.8519 17.3596 12.0941C17.1886 12.3362 16.9607 12.5072 16.6901 12.6211H16.8468C17.502 12.6211 18.143 12.7208 18.7698 12.9202C19.3681 13.1197 19.9379 13.3903 20.4649 13.7322V5.72665C20.4649 5.3278 20.3794 4.92895 20.1943 4.57283C20.0376 4.23096 19.8097 3.90333 19.5248 3.64692C19.2541 3.39052 18.955 3.17684 18.6131 3.02015C18.2855 2.8777 17.9436 2.79224 17.5875 2.79224H16.1915V5.6127H6.33413V2.82073H4.72447C4.36835 2.82073 4.02648 2.92044 3.72734 3.10562C3.41396 3.2908 3.12906 3.53296 2.8869 3.81786C2.64474 4.10275 2.44531 4.41614 2.30287 4.75801C2.16042 5.0714 2.0892 5.39902 2.07495 5.7409V19.715C2.07495 20.0996 2.17466 20.47 2.37409 20.7976C2.57352 21.1395 2.81568 21.4529 3.11482 21.7235C3.39971 21.9799 3.7131 22.1936 4.06922 22.3503C4.35411 22.507 4.68174 22.5924 5.00937 22.6067H11.6047C10.8497 21.5383 10.4509 20.2848 10.4651 19.0028Z"
      fill="url(#vipTopRight_grad)"
    />
    <defs>
      <linearGradient
        id="vipTopRight_grad"
        x1="12"
        y1="0"
        x2="12"
        y2="24"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-header-start, currentColor)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-header-end, currentColor)" }}
        />
      </linearGradient>
    </defs>
  </svg>
);

// 返回图标SVG组件
export const BackIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 16,
  color = "currentColor",
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <path
      d="M19.9999 8.99971L3.66672 9.0004L9.33324 14.6669L7.99982 16.0003L-1.51667e-05 8.0005L8.00051 -2.29452e-05L9.33324 1.33271L3.66603 6.99992H19.9999V8.99971Z"
      fill={color}
    />
  </svg>
);

// 返回图标SVG组件
export const VipCurrentIcon: React.FC<SvgIconProps> = ({
  width = 76,
  height = 30,
  color = "currentColor",
  className,
  variant,
  gradientStart,
  gradientEnd,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 76 30"
    fill="none"
    className={className}
    width={width}
    height={height}
  >
    <path
      d="M0 12C0 5.37258 5.37258 0 12 0H76C76 0 66.2979 0.98941 66.2979 6.92587C66.2979 9.92777 66.2979 12.5654 66.2979 14.7834C66.2979 19.1883 62.7379 22.7564 58.333 22.7564C46.3208 22.7564 23.5088 22.7564 9.70213 22.7564C2.15603 22.7564 0 30 0 30V12Z"
      fill={
        variant === "golden"
          ? "url(#paint0_linear_6136_4702)"
          : variant === "custom" && gradientStart && gradientEnd
            ? "url(#vip_current_custom)"
            : color
      }
    />
    {variant === "golden" && (
      <defs>
        <linearGradient
          id="paint0_linear_6136_4702"
          x1="14.5532"
          y1="1.97882"
          x2="59.1588"
          y2="21.9906"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFEDBB" />
          <stop offset="1" stopColor="#FFB06C" />
        </linearGradient>
      </defs>
    )}
    {variant === "custom" && gradientStart && gradientEnd && (
      <defs>
        <linearGradient
          id="vip_current_custom"
          x1="13.5981"
          y1="2.26446"
          x2="57.3644"
          y2="21.1413"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={gradientStart} />
          <stop offset="1" stopColor={gradientEnd} />
        </linearGradient>
      </defs>
    )}
  </svg>
);

// 签到日期图标SVG组件
export const SignDayIcon: React.FC<SvgIconProps> = ({
  width = 145,
  height = 58,
  color = "currentColor",
  className,
  variant,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 145 58"
    fill="none"
    className={className}
    width={width}
    height={height}
  >
    <path
      d="M0 7C0 3.13401 3.13401 0 7 0H102.353C102.353 33.35 145 25.1333 145 58H7C3.13401 58 0 54.866 0 51V7Z"
      fill={variant === "golden" ? "url(#paint0_linear_789_10652)" : color}
    />
    {variant === "golden" && (
      <defs>
        <linearGradient
          id="paint0_linear_789_10652"
          x1="14.0248"
          y1="0"
          x2="94.3302"
          y2="21.8333"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E79000" />
          <stop offset="1" stopColor="#D55900" />
        </linearGradient>
      </defs>
    )}
  </svg>
);

export const VipLockedIcon: React.FC<SvgIconProps> = ({
  width = 89,
  height = 32,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width}
    height={height}
    viewBox="0 0 91 32"
    fill="none"
  >
    <path
      d="M-0.5 12C-0.5 5.37258 4.87258 0 11.5 0H89C89 0 78.7247 1.26749 78.7247 7.24936C78.7247 10.6396 78.7247 13.6843 78.7247 16.2265C78.7247 20.6314 75.1661 24.201 70.7612 24.201C55.6569 24.201 23.0911 24.201 8.89873 24.201C1.58861 24.201 -0.5 31.1799 -0.5 31.1799V12Z"
      fill="url(#paint0_linear_797_12196)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_797_12196"
        x1="10"
        y1="13.5"
        x2="57.7272"
        y2="21.2707"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8B8989" />
        <stop offset="1" stopColor="#717171" />
      </linearGradient>
    </defs>
  </svg>
);

export const LockIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 16,
  color = "currentColor",
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 14 15"
    className={className}
    fill="none"
  >
    <path
      d="M5.55086 2H8.54951C8.57074 2.00501 8.59183 2.01042 8.61319 2.01516C8.80982 2.05855 9.01289 2.0844 9.20227 2.14809C10.0293 2.4258 10.7175 3.17415 10.6869 4.16923C10.6678 4.78624 10.6833 5.4043 10.6833 6.02197V6.11968C10.7191 6.12615 10.7484 6.13274 10.7781 6.13683C11.47 6.23296 11.9968 6.80553 11.9981 7.47529C12.0011 8.86557 12.0005 10.2557 11.9965 11.646C11.9961 11.7697 11.9742 11.8973 11.938 12.0164C11.7578 12.6085 11.2094 12.9965 10.5521 12.9978C9.37507 13.0003 8.19788 12.9986 7.02081 12.9986C5.81595 12.9984 4.61096 13.0032 3.40624 12.9961C2.62573 12.9915 2.00283 12.3804 2.0016 11.6297C1.99927 10.25 1.99968 8.87058 2.0016 7.49098C2.00242 6.88346 2.41568 6.3519 3.01982 6.18008C3.14086 6.14566 3.26821 6.13221 3.40322 6.10702V6.02026C3.40322 5.38663 3.39912 4.75301 3.40596 4.11938C3.40774 3.9498 3.42144 3.77494 3.46621 3.61195C3.67818 2.84119 4.21454 2.36409 4.98327 2.11657C5.16567 2.05789 5.36134 2.03785 5.55086 2ZM9.19693 6.1185C9.19925 6.0945 9.20199 6.07867 9.20199 6.06298C9.20076 5.6327 9.20446 5.20241 9.19556 4.77226C9.19022 4.51591 9.16009 4.26087 9.08273 4.01309C8.9688 3.64795 8.72218 3.41468 8.33494 3.3374C8.14064 3.29863 7.93976 3.27609 7.74148 3.27239C7.25045 3.26329 6.75914 3.26685 6.26796 3.27094C6.12419 3.27213 5.97959 3.28505 5.83732 3.30536C5.3052 3.38132 5.00601 3.64175 4.88619 4.1472C4.84141 4.33617 4.81197 4.53173 4.80554 4.72518C4.79075 5.16575 4.79445 5.60685 4.79102 6.04768C4.79089 6.07076 4.79472 6.09397 4.79677 6.1185H9.19693ZM7.69999 9.99831C7.69999 9.65097 7.70027 9.30377 7.69986 8.95643C7.69972 8.78948 7.64289 8.64192 7.52855 8.51665C7.3374 8.30698 7.04149 8.23498 6.77146 8.33019C6.49869 8.42645 6.31877 8.66737 6.31781 8.95089C6.31562 9.65084 6.31699 10.3507 6.3174 11.0506C6.3174 11.0799 6.31959 11.1096 6.32479 11.1383C6.38792 11.4949 6.70683 11.7359 7.07216 11.7043C7.43161 11.673 7.69903 11.384 7.69986 11.0242C7.70068 10.6822 7.69999 10.3402 7.69999 9.99831Z"
      fill={color}
    />
  </svg>
);

export const InProgressIcon: React.FC<SvgIconProps> = ({
  width = 12,
  height = 12,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    className={className}
  >
    <g clipPath="url(#clip0_149_529)">
      <path
        d="M6 0C9.3138 0 12 2.6862 12 6C12 9.3138 9.3138 12 6 12C2.6862 12 0 9.3138 0 6C0 2.6862 2.6862 0 6 0ZM6 1.2C3.3489 1.2 1.2 3.3489 1.2 6C1.2 8.6511 3.3489 10.8 6 10.8C8.6511 10.8 10.8 8.6511 10.8 6C10.8 3.3489 8.6511 1.2 6 1.2ZM6 2.7C6.0394 2.7 6.07841 2.70776 6.11481 2.72284C6.1512 2.73791 6.18427 2.76001 6.21213 2.78787C6.23999 2.81573 6.26209 2.8488 6.27716 2.88519C6.29224 2.92159 6.3 2.9606 6.3 3V6.3H8.7C8.7394 6.3 8.77841 6.30776 8.81481 6.32284C8.8512 6.33791 8.88427 6.36001 8.91213 6.38787C8.93999 6.41573 8.96209 6.4488 8.97716 6.48519C8.99224 6.52159 9 6.5606 9 6.6V7.2C9 7.2394 8.99224 7.27841 8.97716 7.31481C8.96209 7.3512 8.93999 7.38427 8.91213 7.41213C8.88427 7.43999 8.8512 7.46209 8.81481 7.47716C8.77841 7.49224 8.7394 7.5 8.7 7.5H5.4C5.3606 7.5 5.32159 7.49224 5.28519 7.47716C5.2488 7.46209 5.21572 7.43999 5.18787 7.41213C5.16001 7.38427 5.13791 7.3512 5.12284 7.31481C5.10776 7.27841 5.1 7.2394 5.1 7.2V3C5.1 2.9606 5.10776 2.92159 5.12284 2.88519C5.13791 2.8488 5.16001 2.81573 5.18787 2.78787C5.21572 2.76001 5.2488 2.73791 5.28519 2.72284C5.32159 2.70776 5.3606 2.7 5.4 2.7H6Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_149_529">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SucceedIcon: React.FC<SvgIconProps> = ({
  width = 12,
  height = 12,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    className={className}
  >
    <g clipPath="url(#clip0_149_1572)">
      <path
        d="M6 12C2.68617 12 0 9.31383 0 6C0 2.68617 2.68617 0 6 0C9.31383 0 12 2.68617 12 6C12 9.31383 9.31383 12 6 12ZM6 10.9565C8.7373 10.9565 10.9565 8.7373 10.9565 6C10.9565 3.2627 8.7373 1.04348 6 1.04348C3.2627 1.04348 1.04348 3.2627 1.04348 6C1.04348 8.7373 3.2627 10.9565 6 10.9565ZM8.058 4.12226L8.82365 4.88817L5.63009 8.06035L3.54391 5.9713L4.29391 5.22157L5.61574 6.54548L8.058 4.12226Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_149_1572">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FailureIcon: React.FC<SvgIconProps> = ({
  width = 12,
  height = 12,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    className={className}
  >
    <g clipPath="url(#clip0_149_864)">
      <path
        d="M6 10.8C5.36965 10.8 4.74548 10.6758 4.16312 10.4346C3.58076 10.1934 3.05161 9.83983 2.60589 9.39411C2.16017 8.94839 1.8066 8.41924 1.56538 7.83688C1.32416 7.25452 1.2 6.63034 1.2 6C1.2 5.36965 1.32416 4.74548 1.56538 4.16312C1.8066 3.58076 2.16017 3.05161 2.60589 2.60589C3.05161 2.16017 3.58076 1.8066 4.16312 1.56538C4.74548 1.32416 5.36965 1.2 6 1.2C7.27304 1.2 8.49394 1.70571 9.39411 2.60589C10.2943 3.50606 10.8 4.72696 10.8 6C10.8 7.27304 10.2943 8.49394 9.39411 9.39411C8.49394 10.2943 7.27304 10.8 6 10.8ZM6 0C2.6862 0 0 2.6862 0 6C0 9.3138 2.6862 12 6 12C9.3138 12 12 9.3138 12 6C12 4.4087 11.3679 2.88258 10.2426 1.75736C9.11742 0.632141 7.5913 0 6 0ZM7.554 3.6L6 5.154L4.446 3.6L3.6 4.446L5.154 6L3.6 7.554L4.446 8.4L6 6.846L7.554 8.4L8.4 7.554L6.846 6L8.4 4.446L7.554 3.6Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_149_864">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const BetIcon: React.FC<SvgIconProps> = ({
  width = 12,
  height = 12,
  className,
  color = "currentColor",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    className={className}
  >
    <path
      d="M0 0.0042L2.5716 0.534L8.3916 7.137L8.9754 6.5514L9.7824 7.3584L9.1782 7.9626L10.791 9.5754L11.1942 9.1722L12 9.9792L9.984 11.9952L9.1782 11.1888L9.5814 10.7868L7.9674 9.1722L7.3626 9.7782L6.5568 8.9712L7.179 8.349L6.0378 7.3566L4.863 8.391L5.4486 8.9754L4.6416 9.7824L4.0374 9.1782L2.4246 10.791L2.8278 11.1942L2.0208 12L0.0048 9.984L0.8112 9.1782L1.215 9.5802L2.8278 7.9674L2.2218 7.3626L3.0288 6.5568L3.651 7.1772L4.593 6.0972L0.5376 2.5674L0 0.0042ZM11.9958 0L11.466 2.5716L7.8744 5.6892L6.4284 4.0488L9.432 0.5382L11.9958 0Z"
      fill={color}
    />
  </svg>
);

export const NoRecordsIcon: React.FC<SvgIconProps> = ({
  width = 80,
  height = 80,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 80 80"
    fill="none"
    className={className}
  >
    <g opacity="0.4">
      <path
        d="M40.2666 35.4667L14.6666 32.2667L36 27.7334L63.4666 30.1334L40.2666 35.4667Z"
        fill="#050F24"
      />
      <path
        d="M40.2666 35.4667L14.6666 32.2667L36 27.7334L63.4666 30.1334L40.2666 35.4667Z"
        fill="url(#paint0_linear_136_2628)"
      />
      <path
        d="M40.2666 66.1334V35.4292L62.6666 30.4V59.516L40.2666 66.1334Z"
        fill="#050F24"
      />
      <path
        d="M40.2666 66.1334V35.4292L62.6666 30.4V59.516L40.2666 66.1334Z"
        fill="url(#paint1_linear_136_2628)"
      />
      <path
        d="M40.2666 66.1345V35.4303L14.6666 32.2666V61.116L40.2666 66.1345Z"
        fill="#050F24"
      />
      <path
        d="M40.2666 66.1345V35.4303L14.6666 32.2666V61.116L40.2666 66.1345Z"
        fill="url(#paint2_linear_136_2628)"
      />
      <path
        d="M47.6695 46.9333L40.2666 35.4666L63.4666 30.1333L71.2 40.5333L47.6695 46.9333Z"
        fill="#050F24"
      />
      <path
        d="M47.6695 46.9333L40.2666 35.4666L63.4666 30.1333L71.2 40.5333L47.6695 46.9333Z"
        fill="url(#paint3_linear_136_2628)"
      />
      <path
        d="M34.6666 48L40.2666 35.4666L14.6666 32.2666L8.53333 43.4666L34.6666 48Z"
        fill="#050F24"
      />
      <path
        d="M34.6666 48L40.2666 35.4666L14.6666 32.2666L8.53333 43.4666L34.6666 48Z"
        fill="url(#paint4_linear_136_2628)"
      />
      <path
        d="M22.6666 21.6C18.4 21.1733 16.4445 16.8 16 14.6666C19.4666 18.1333 21.0666 17.0666 22.6666 17.3333C25.44 20.1066 30.2222 20.0889 32.2666 19.7333C31.2 20.2666 28 22.1333 22.6666 21.6Z"
        fill="#050F24"
      />
      <path
        d="M22.6666 21.6C18.4 21.1733 16.4445 16.8 16 14.6666C19.4666 18.1333 21.0666 17.0666 22.6666 17.3333C25.44 20.1066 30.2222 20.0889 32.2666 19.7333C31.2 20.2666 28 22.1333 22.6666 21.6Z"
        fill="white"
        fillOpacity="0.7"
      />
      <path
        d="M16.2666 15.4666C15.6266 14.3999 15.1111 11.4666 14.9333 10.1333C18.7733 13.3333 22.4 12.711 23.7333 11.9999C26.4 17.5999 34.1333 19.4666 33.3333 19.4666C27.2 21.8666 22.9333 18.9333 22.4 17.8666C18.6666 18.1333 17.0666 16.7999 16.2666 15.4666Z"
        fill="#050F24"
      />
      <path
        d="M16.2666 15.4666C15.6266 14.3999 15.1111 11.4666 14.9333 10.1333C18.7733 13.3333 22.4 12.711 23.7333 11.9999C26.4 17.5999 34.1333 19.4666 33.3333 19.4666C27.2 21.8666 22.9333 18.9333 22.4 17.8666C18.6666 18.1333 17.0666 16.7999 16.2666 15.4666Z"
        fill="white"
        fillOpacity="0.5"
      />
      <path
        d="M54.4 25.8667C56 22.9334 56.8 19.4667 57.0667 16.8C58.4 16.5334 60 15.4667 60.8 14.4C61.3334 20 59.2 23.7334 58.4 24.2667C57.76 24.6934 55.4667 25.6 54.4 25.8667Z"
        fill="#050F24"
      />
      <path
        d="M54.4 25.8667C56 22.9334 56.8 19.4667 57.0667 16.8C58.4 16.5334 60 15.4667 60.8 14.4C61.3334 20 59.2 23.7334 58.4 24.2667C57.76 24.6934 55.4667 25.6 54.4 25.8667Z"
        fill="white"
        fillOpacity="0.5"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_136_2628"
        x1="39.0666"
        y1="28"
        x2="39.0666"
        y2="35.4667"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.1" />
        <stop offset="1" stopColor="white" stopOpacity="0.05" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_136_2628"
        x1="55.7333"
        y1="33.8667"
        x2="43.7333"
        y2="62.6667"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.021711" stopColor="white" stopOpacity="0.1" />
        <stop offset="1" stopColor="white" stopOpacity="0.2" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_136_2628"
        x1="33.8666"
        y1="36.8"
        x2="38.4"
        y2="63.4666"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.15" />
        <stop offset="1" stopColor="white" stopOpacity="0.25" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_136_2628"
        x1="55.8655"
        y1="31.9999"
        x2="48.362"
        y2="46.3473"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.3" />
        <stop offset="1" stopColor="white" stopOpacity="0.2" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_136_2628"
        x1="24.5333"
        y1="34.1333"
        x2="25.8666"
        y2="45.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.1" />
        <stop offset="1" stopColor="white" stopOpacity="0.3" />
      </linearGradient>
    </defs>
  </svg>
);

export const CheckSuccessIcon: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  className,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5Z"
      fill="#37A71B"
    />
    <path
      d="M11.0478 15.467L16.4598 10.055L15.5405 9.13574L11.0478 13.6285L8.45977 11.0405L7.54053 11.9597L11.0478 15.467Z"
      fill="white"
    />
  </svg>
);

export const InputSearchIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  className,
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.178 13.764L16.821 15.407C16.9165 15.4992 16.9927 15.6096 17.0451 15.7316C17.0975 15.8536 17.1251 15.9848 17.1263 16.1176C17.1274 16.2504 17.1021 16.3821 17.0518 16.505C17.0015 16.6278 16.9273 16.7395 16.8334 16.8334C16.7395 16.9273 16.6278 17.0015 16.505 17.0518C16.3821 17.1021 16.2504 17.1274 16.1176 17.1263C15.9848 17.1251 15.8536 17.0975 15.7316 17.0451C15.6096 16.9927 15.4992 16.9165 15.407 16.821L13.764 15.178C11.1215 17.137 7.373 16.9185 4.977 14.523C2.341 11.887 2.341 7.613 4.977 4.977C7.613 2.341 11.887 2.341 14.523 4.977C16.9185 7.373 17.137 11.1215 15.178 13.764ZM13.4625 13.4625C15.5125 11.4125 15.5125 8.0875 13.4625 6.0375C11.4125 3.9875 8.0875 3.9875 6.0375 6.0375C3.9875 8.0875 3.9875 11.4125 6.0375 13.4625C8.0875 15.5125 11.4125 15.5125 13.4625 13.4625Z"
      fill="#573414"
    />
  </svg>
);

export const DropdownSearchIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  className,
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.64956 15.6252C10.0404 16.2571 10.9596 16.2571 11.3504 15.6252L16.0512 8.02607C16.4633 7.35987 15.9841 6.5 15.2007 6.5H5.79926C5.0159 6.5 4.53672 7.35987 4.94882 8.02607L9.64956 15.6252Z"
      fill="#573414"
    />
  </svg>
);

export const TransactionRecordIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  className,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 18"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0417 3.99996C14.0417 3.8342 14.1076 3.67523 14.2248 3.55802C14.342 3.44081 14.5009 3.37496 14.6667 3.37496C14.8325 3.37496 14.9914 3.44081 15.1086 3.55802C15.2259 3.67523 15.2917 3.8342 15.2917 3.99996V15.0416C15.2917 16.3073 14.2657 17.3333 13 17.3333H3.00004C1.73442 17.3333 0.708374 16.3073 0.708374 15.0416V2.95829C0.708374 1.69267 1.73442 0.666626 3.00004 0.666626H14.6667C14.8325 0.666626 14.9914 0.732474 15.1086 0.849684C15.2259 0.966894 15.2917 1.12587 15.2917 1.29163C15.2917 1.45739 15.2259 1.61636 15.1086 1.73357C14.9914 1.85078 14.8325 1.91663 14.6667 1.91663H3.00004C2.86325 1.91663 2.72779 1.94357 2.60141 1.99592C2.47503 2.04827 2.3602 2.125 2.26347 2.22172C2.16674 2.31845 2.09001 2.43328 2.03767 2.55966C1.98532 2.68604 1.95837 2.8215 1.95837 2.95829V15.0416C1.95837 15.1784 1.98532 15.3139 2.03767 15.4403C2.09001 15.5666 2.16674 15.6815 2.26347 15.7782C2.3602 15.8749 2.47503 15.9517 2.60141 16.004C2.72779 16.0563 2.86325 16.0833 3.00004 16.0833H13C13.1368 16.0833 13.2723 16.0563 13.3987 16.004C13.5251 15.9517 13.6399 15.8749 13.7366 15.7782C13.8333 15.6815 13.9101 15.5666 13.9624 15.4403C14.0148 15.3139 14.0417 15.1784 14.0417 15.0416V3.99996ZM4.66671 7.54163C4.50095 7.54163 4.34198 7.47578 4.22477 7.35857C4.10755 7.24136 4.04171 7.08239 4.04171 6.91663C4.04171 6.75087 4.10755 6.59189 4.22477 6.47468C4.34198 6.35747 4.50095 6.29163 4.66671 6.29163H11.3334C11.4991 6.29163 11.6581 6.35747 11.7753 6.47468C11.8925 6.59189 11.9584 6.75087 11.9584 6.91663C11.9584 7.08239 11.8925 7.24136 11.7753 7.35857C11.6581 7.47578 11.4991 7.54163 11.3334 7.54163H4.66671ZM4.66671 10.875C4.50095 10.875 4.34198 10.8091 4.22477 10.6919C4.10755 10.5747 4.04171 10.4157 4.04171 10.25C4.04171 10.0842 4.10755 9.92523 4.22477 9.80802C4.34198 9.69081 4.50095 9.62496 4.66671 9.62496H8.83337C8.99913 9.62496 9.1581 9.69081 9.27532 9.80802C9.39253 9.92523 9.45837 10.0842 9.45837 10.25C9.45837 10.4157 9.39253 10.5747 9.27532 10.6919C9.1581 10.8091 8.99913 10.875 8.83337 10.875H4.66671Z"
      fill="url(#paint0_linear_transaction_record)"
    />
    <path
      d="M14.0417 3.99996C14.0417 3.8342 14.1076 3.67523 14.2248 3.55802C14.342 3.44081 14.5009 3.37496 14.6667 3.37496C14.8325 3.37496 14.9914 3.44081 15.1086 3.55802C15.2259 3.67523 15.2917 3.8342 15.2917 3.99996V15.0416C15.2917 16.3073 14.2657 17.3333 13 17.3333H3.00004C1.73442 17.3333 0.708374 16.3073 0.708374 15.0416V2.95829C0.708374 1.69267 1.73442 0.666626 3.00004 0.666626H14.6667C14.8325 0.666626 14.9914 0.732474 15.1086 0.849684C15.2259 0.966894 15.2917 1.12587 15.2917 1.29163C15.2917 1.45739 15.2259 1.61636 15.1086 1.73357C14.9914 1.85078 14.8325 1.91663 14.6667 1.91663H3.00004C2.86325 1.91663 2.72779 1.94357 2.60141 1.99592C2.47503 2.04827 2.3602 2.125 2.26347 2.22172C2.16674 2.31845 2.09001 2.43328 2.03767 2.55966C1.98532 2.68604 1.95837 2.8215 1.95837 2.95829V15.0416C1.95837 15.1784 1.98532 15.3139 2.03767 15.4403C2.09001 15.5666 2.16674 15.6815 2.26347 15.7782C2.3602 15.8749 2.47503 15.9517 2.60141 16.004C2.72779 16.0563 2.86325 16.0833 3.00004 16.0833H13C13.1368 16.0833 13.2723 16.0563 13.3987 16.004C13.5251 15.9517 13.6399 15.8749 13.7366 15.7782C13.8333 15.6815 13.9101 15.5666 13.9624 15.4403C14.0148 15.3139 14.0417 15.1784 14.0417 15.0416V3.99996ZM4.66671 7.54163C4.50095 7.54163 4.34198 7.47578 4.22477 7.35857C4.10755 7.24136 4.04171 7.08239 4.04171 6.91663C4.04171 6.75087 4.10755 6.59189 4.22477 6.47468C4.34198 6.35747 4.50095 6.29163 4.66671 6.29163H11.3334C11.4991 6.29163 11.6581 6.35747 11.7753 6.47468C11.8925 6.59189 11.9584 6.75087 11.9584 6.91663C11.9584 7.08239 11.8925 7.24136 11.7753 7.35857C11.6581 7.47578 11.4991 7.54163 11.3334 7.54163H4.66671ZM4.66671 10.875C4.50095 10.875 4.34198 10.8091 4.22477 10.6919C4.10755 10.5747 4.04171 10.4157 4.04171 10.25C4.04171 10.0842 4.10755 9.92523 4.22477 9.80802C4.34198 9.69081 4.50095 9.62496 4.66671 9.62496H8.83337C8.99913 9.62496 9.1581 9.69081 9.27532 9.80802C9.39253 9.92523 9.45837 10.0842 9.45837 10.25C9.45837 10.4157 9.39253 10.5747 9.27532 10.6919C9.1581 10.8091 8.99913 10.875 8.83337 10.875H4.66671Z"
      fill="url(#paint1_linear_transaction_record)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_transaction_record"
        x1="8"
        y1="17"
        x2="8"
        y2="1"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-header-start, currentColor)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-header-end, currentColor)" }}
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_transaction_record"
        x1="8"
        y1="1"
        x2="8"
        y2="17"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-start, currentColor)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-end, currentColor)" }}
        />
      </linearGradient>
    </defs>
  </svg>
);

export const BetRecordIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  className,
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.60238 16.9957C3.57276 16.9916 2.03915 16.6979 2.03013 15.2353C2.02151 13.8391 2.00482 4.09234 2.00455 3.99422C2.00172 3.96681 1.93091 3.15386 2.46698 2.56871C2.81269 2.19157 3.32829 2 3.99911 2C6.098 2 13.2122 2.01497 13.2122 2.01497C13.2301 2.01497 14.9446 2.04639 14.9742 3.62083C15.0039 5.12187 15 5.35208 14.9996 5.3609C14.9738 5.56384 14.8169 5.93148 14.403 5.93148C14.0143 5.92907 13.8641 5.61798 13.8526 5.32748L13.8508 5.28417L13.8547 5.28176L13.8396 4.04702C13.8397 4.0382 13.8547 3.67056 13.6024 3.40773C13.427 3.22511 13.1624 3.13233 12.8166 3.13233H3.94769C3.92022 3.1342 3.15907 3.19142 3.15907 3.87871V14.961C3.16459 14.9832 3.33166 15.8384 4.14464 15.8384H6.40925C6.59866 15.8484 6.94881 15.9838 6.94881 16.4243C6.94881 16.8644 6.61939 16.993 6.44506 16.9996L6.44358 17L3.60238 16.9957Z"
      fill="url(#paint0_linear_bet_record)"
    />
    <path
      d="M14.8697 13.9776C14.8493 13.9417 14.8263 13.9078 14.801 13.8765L13.2372 11.9082C13.2177 11.8849 13.1974 11.8626 13.1763 11.8413C13.1517 11.8179 13.0715 11.7201 13.0715 11.4527L13.0684 9.71936C13.0692 9.54786 13.0235 9.38062 12.9383 9.24242C12.8521 9.09309 12.7098 9.00269 12.5441 9C12.2689 9 12.0348 9.24496 12 9.58226V11.7806C12 11.9355 12.0379 12.0905 12.1106 12.2297C12.1792 12.3566 12.2578 12.4756 12.3452 12.5849C12.5574 12.8459 14.2227 14.8443 14.2401 14.8651C14.2447 14.8707 14.3573 15 14.5245 15C14.6436 15 14.7574 14.9367 14.8632 14.8111C15.119 14.5064 14.953 14.1271 14.8697 13.9776Z"
      fill="url(#paint0_linear_bet_record)"
    />
    <path
      d="M12.7995 18C10.9593 18 9.23949 16.9702 8.31129 15.3134C7.36738 13.6272 7.36673 11.5325 8.3096 9.84629C9.23793 8.1873 10.958 7.15655 12.7987 7.15655L12.8739 7.15696C15.6999 7.19854 17.9991 9.63028 18 12.5777C18.0008 15.5252 15.7026 17.9576 12.8768 17.9996L12.7995 18ZM12.8728 8.35496C11.79 8.35496 10.7727 8.79415 10.0085 9.59223C9.24391 10.3899 8.82292 11.4506 8.82292 12.579C8.82214 13.691 9.25417 14.7797 10.0081 15.5665C10.7729 16.3644 11.7904 16.8036 12.8728 16.8036C15.1063 16.8036 16.9234 14.9089 16.9234 12.5791C16.9235 10.2497 15.1063 8.35496 12.8728 8.35496ZM5.48267 9.40872C5.34918 9.40872 5.23244 9.35888 5.14414 9.26923C5.09898 9.22388 5.06296 9.16957 5.03821 9.1095C5.01346 9.04943 5.00047 8.9848 5 8.91942V8.69068C5 8.41549 5.21218 8.19976 5.48319 8.19976H6.86731C7.13819 8.19976 7.3505 8.41549 7.3505 8.69068V8.91847C7.35023 8.98416 7.33728 9.04911 7.31243 9.10947C7.28758 9.16982 7.25133 9.22434 7.20584 9.26977C7.11797 9.35927 6.99987 9.40913 6.87705 9.40859C6.87718 9.40872 5.48293 9.40872 5.48267 9.40872ZM5.48488 6.15601C5.20491 6.15601 5.00182 5.96194 5.00182 5.69502V5.46723C5.00182 5.20098 5.20946 5 5.48488 5H12.0276C12.3029 5 12.5107 5.20098 12.5107 5.46723V5.69502C12.5079 5.96249 12.3037 6.15601 12.025 6.15601H5.48488Z"
      fill="url(#paint0_linear_bet_record)"
    />
    <path
      d="M3.60238 16.9957C3.57276 16.9916 2.03915 16.6979 2.03013 15.2353C2.02151 13.8391 2.00482 4.09234 2.00455 3.99422C2.00172 3.96681 1.93091 3.15386 2.46698 2.56871C2.81269 2.19157 3.32829 2 3.99911 2C6.098 2 13.2122 2.01497 13.2122 2.01497C13.2301 2.01497 14.9446 2.04639 14.9742 3.62083C15.0039 5.12187 15 5.35208 14.9996 5.3609C14.9738 5.56384 14.8169 5.93148 14.403 5.93148C14.0143 5.92907 13.8641 5.61798 13.8526 5.32748L13.8508 5.28417L13.8547 5.28176L13.8396 4.04702C13.8397 4.0382 13.8547 3.67056 13.6024 3.40773C13.427 3.22511 13.1624 3.13233 12.8166 3.13233H3.94769C3.92022 3.1342 3.15907 3.19142 3.15907 3.87871V14.961C3.16459 14.9832 3.33166 15.8384 4.14464 15.8384H6.40925C6.59866 15.8484 6.94881 15.9838 6.94881 16.4243C6.94881 16.8644 6.61939 16.993 6.44506 16.9996L6.44358 17L3.60238 16.9957Z"
      fill="url(#paint1_linear_bet_record)"
    />
    <path
      d="M14.8697 13.9776C14.8493 13.9417 14.8263 13.9078 14.801 13.8765L13.2372 11.9082C13.2177 11.8849 13.1974 11.8626 13.1763 11.8413C13.1517 11.8179 13.0715 11.7201 13.0715 11.4527L13.0684 9.71936C13.0692 9.54786 13.0235 9.38062 12.9383 9.24242C12.8521 9.09309 12.7098 9.00269 12.5441 9C12.2689 9 12.0348 9.24496 12 9.58226V11.7806C12 11.9355 12.0379 12.0905 12.1106 12.2297C12.1792 12.3566 12.2578 12.4756 12.3452 12.5849C12.5574 12.8459 14.2227 14.8443 14.2401 14.8651C14.2447 14.8707 14.3573 15 14.5245 15C14.6436 15 14.7574 14.9367 14.8632 14.8111C15.119 14.5064 14.953 14.1271 14.8697 13.9776Z"
      fill="url(#paint1_linear_bet_record)"
    />
    <path
      d="M12.7995 18C10.9593 18 9.23949 16.9702 8.31129 15.3134C7.36738 13.6272 7.36673 11.5325 8.3096 9.84629C9.23793 8.1873 10.958 7.15655 12.7987 7.15655L12.8739 7.15696C15.6999 7.19854 17.9991 9.63028 18 12.5777C18.0008 15.5252 15.7026 17.9576 12.8768 17.9996L12.7995 18ZM12.8728 8.35496C11.79 8.35496 10.7727 8.79415 10.0085 9.59223C9.24391 10.3899 8.82292 11.4506 8.82292 12.579C8.82214 13.691 9.25417 14.7797 10.0081 15.5665C10.7729 16.3644 11.7904 16.8036 12.8728 16.8036C15.1063 16.8036 16.9234 14.9089 16.9234 12.5791C16.9235 10.2497 15.1063 8.35496 12.8728 8.35496ZM5.48267 9.40872C5.34918 9.40872 5.23244 9.35888 5.14414 9.26923C5.09898 9.22388 5.06296 9.16957 5.03821 9.1095C5.01346 9.04943 5.00047 8.9848 5 8.91942V8.69068C5 8.41549 5.21218 8.19976 5.48319 8.19976H6.86731C7.13819 8.19976 7.3505 8.41549 7.3505 8.69068V8.91847C7.35023 8.98416 7.33728 9.04911 7.31243 9.10947C7.28758 9.16982 7.25133 9.22434 7.20584 9.26977C7.11797 9.35927 6.99987 9.40913 6.87705 9.40859C6.87718 9.40872 5.48293 9.40872 5.48267 9.40872ZM5.48488 6.15601C5.20491 6.15601 5.00182 5.96194 5.00182 5.69502V5.46723C5.00182 5.20098 5.20946 5 5.48488 5H12.0276C12.3029 5 12.5107 5.20098 12.5107 5.46723V5.69502C12.5079 5.96249 12.3037 6.15601 12.025 6.15601H5.48488Z"
      fill="url(#paint1_linear_bet_record)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_bet_record"
        x1="10"
        y1="18"
        x2="10"
        y2="2"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-header-start, currentColor)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-header-end, currentColor)" }}
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_bet_record"
        x1="10"
        y1="2"
        x2="10"
        y2="18"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-start, currentColor)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-end, currentColor)" }}
        />
      </linearGradient>
    </defs>
  </svg>
);

export const BonusRecordIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  className,
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5871 4.50723L11.4807 1.55898C10.565 1.03047 9.42754 1.03047 8.51191 1.55898L3.40527 4.50723C2.48965 5.03594 1.9209 6.02109 1.9209 7.07832V12.9748C1.9209 14.032 2.48965 15.0172 3.40527 15.5459L8.51172 18.4941C8.96953 18.7584 9.48281 18.8906 9.99609 18.8906C10.5094 18.8906 11.0227 18.7584 11.4805 18.4941L16.5869 15.5459C17.5025 15.0172 18.0713 14.0322 18.0713 12.9748V7.07812C18.0715 6.0209 17.5027 5.03574 16.5871 4.50723ZM16.8215 12.9746C16.8215 13.5867 16.4922 14.157 15.9621 14.4631L10.8557 17.4113C10.3256 17.7174 9.66699 17.7174 9.13691 17.4113L4.03027 14.4631C3.5002 14.157 3.1709 13.5867 3.1709 12.9746V7.07812C3.1709 6.46602 3.5002 5.8957 4.03027 5.58965L9.13672 2.64141C9.40176 2.48848 9.69902 2.41191 9.99609 2.41191C10.2932 2.41191 10.5904 2.48848 10.8555 2.64141L15.9619 5.58965C16.492 5.8957 16.8213 6.46602 16.8213 7.07812V12.9746H16.8215Z"
      fill="url(#paint0_linear_bonus_record)"
    />
    <path
      d="M10.5947 9.4668V6.93535C11.1681 7.01758 11.6742 7.26211 11.9566 7.60332C12.1767 7.86934 12.5707 7.90645 12.8365 7.68633C13.1025 7.46621 13.1396 7.07227 12.9195 6.80645C12.4056 6.18555 11.5486 5.77227 10.5947 5.67637V5.02441C10.5947 4.6793 10.3148 4.39941 9.9697 4.39941C9.62458 4.39941 9.3447 4.6793 9.3447 5.02441V5.73359C8.88864 5.82305 8.4613 5.98711 8.09177 6.21895C7.39411 6.65664 6.97575 7.28301 6.91384 7.98262C6.86442 8.54102 7.05759 9.10059 7.45798 9.5582C7.90759 10.0721 8.57536 10.4289 9.3447 10.5785V13.1121C8.79431 13.0219 8.31247 12.782 8.03981 12.4516C7.82009 12.1854 7.42614 12.1475 7.15993 12.3672C6.89372 12.5869 6.85583 12.9809 7.07556 13.2471C7.57868 13.857 8.41227 14.2674 9.3447 14.374V15.0217C9.3447 15.3668 9.62458 15.6467 9.9697 15.6467C10.3148 15.6467 10.5947 15.3668 10.5947 15.0217V14.3338C11.0724 14.2471 11.5207 14.0789 11.9056 13.8373C12.6033 13.3996 13.0216 12.7732 13.0836 12.0736C13.133 11.5152 12.9398 10.9557 12.5394 10.498C12.0785 9.97129 11.3884 9.60938 10.5947 9.4668ZM8.3986 8.73535C8.21989 8.53105 8.13923 8.31504 8.15895 8.09316C8.18552 7.79238 8.39763 7.50293 8.75622 7.27793C8.92985 7.16895 9.12966 7.08242 9.3447 7.01992V9.29375C8.95212 9.18027 8.61872 8.98691 8.3986 8.73535ZM11.8384 11.9633C11.8119 12.2641 11.5998 12.5535 11.2412 12.7785C11.0521 12.8973 10.8318 12.9895 10.5947 13.0527V10.7467C11.0125 10.8574 11.3679 11.0572 11.5988 11.3211C11.7773 11.5254 11.858 11.7416 11.8384 11.9633Z"
      fill="url(#paint0_linear_bonus_record)"
    />
    <path
      d="M16.5871 4.50723L11.4807 1.55898C10.565 1.03047 9.42754 1.03047 8.51191 1.55898L3.40527 4.50723C2.48965 5.03594 1.9209 6.02109 1.9209 7.07832V12.9748C1.9209 14.032 2.48965 15.0172 3.40527 15.5459L8.51172 18.4941C8.96953 18.7584 9.48281 18.8906 9.99609 18.8906C10.5094 18.8906 11.0227 18.7584 11.4805 18.4941L16.5869 15.5459C17.5025 15.0172 18.0713 14.0322 18.0713 12.9748V7.07812C18.0715 6.0209 17.5027 5.03574 16.5871 4.50723ZM16.8215 12.9746C16.8215 13.5867 16.4922 14.157 15.9621 14.4631L10.8557 17.4113C10.3256 17.7174 9.66699 17.7174 9.13691 17.4113L4.03027 14.4631C3.5002 14.157 3.1709 13.5867 3.1709 12.9746V7.07812C3.1709 6.46602 3.5002 5.8957 4.03027 5.58965L9.13672 2.64141C9.40176 2.48848 9.69902 2.41191 9.99609 2.41191C10.2932 2.41191 10.5904 2.48848 10.8555 2.64141L15.9619 5.58965C16.492 5.8957 16.8213 6.46602 16.8213 7.07812V12.9746H16.8215Z"
      fill="url(#paint1_linear_bonus_record)"
    />
    <path
      d="M10.5947 9.4668V6.93535C11.1681 7.01758 11.6742 7.26211 11.9566 7.60332C12.1767 7.86934 12.5707 7.90645 12.8365 7.68633C13.1025 7.46621 13.1396 7.07227 12.9195 6.80645C12.4056 6.18555 11.5486 5.77227 10.5947 5.67637V5.02441C10.5947 4.6793 10.3148 4.39941 9.9697 4.39941C9.62458 4.39941 9.3447 4.6793 9.3447 5.02441V5.73359C8.88864 5.82305 8.4613 5.98711 8.09177 6.21895C7.39411 6.65664 6.97575 7.28301 6.91384 7.98262C6.86442 8.54102 7.05759 9.10059 7.45798 9.5582C7.90759 10.0721 8.57536 10.4289 9.3447 10.5785V13.1121C8.79431 13.0219 8.31247 12.782 8.03981 12.4516C7.82009 12.1854 7.42614 12.1475 7.15993 12.3672C6.89372 12.5869 6.85583 12.9809 7.07556 13.2471C7.57868 13.857 8.41227 14.2674 9.3447 14.374V15.0217C9.3447 15.3668 9.62458 15.6467 9.9697 15.6467C10.3148 15.6467 10.5947 15.3668 10.5947 15.0217V14.3338C11.0724 14.2471 11.5207 14.0789 11.9056 13.8373C12.6033 13.3996 13.0216 12.7732 13.0836 12.0736C13.133 11.5152 12.9398 10.9557 12.5394 10.498C12.0785 9.97129 11.3884 9.60938 10.5947 9.4668ZM8.3986 8.73535C8.21989 8.53105 8.13923 8.31504 8.15895 8.09316C8.18552 7.79238 8.39763 7.50293 8.75622 7.27793C8.92985 7.16895 9.12966 7.08242 9.3447 7.01992V9.29375C8.95212 9.18027 8.61872 8.98691 8.3986 8.73535ZM11.8384 11.9633C11.8119 12.2641 11.5998 12.5535 11.2412 12.7785C11.0521 12.8973 10.8318 12.9895 10.5947 13.0527V10.7467C11.0125 10.8574 11.3679 11.0572 11.5988 11.3211C11.7773 11.5254 11.858 11.7416 11.8384 11.9633Z"
      fill="url(#paint1_linear_bonus_record)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_bonus_record"
        x1="10"
        y1="18"
        x2="10"
        y2="2"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-header-start, currentColor)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-header-end, currentColor)" }}
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_bonus_record"
        x1="10"
        y1="2"
        x2="10"
        y2="18"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-start, currentColor)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-end, currentColor)" }}
        />
      </linearGradient>
    </defs>
  </svg>
);

export const RedeemTwowayIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  className,
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.012 18.6C8.33082 18.6 6.68744 18.1015 5.28962 17.1675C3.8918 16.2335 2.80234 14.906 2.15899 13.3528C1.51565 11.7996 1.34732 10.0906 1.67529 8.44171C2.00327 6.79287 2.81281 5.27832 4.00156 4.08957C5.19031 2.90083 6.70486 2.09128 8.3537 1.7633C10.0025 1.43533 11.7116 1.60366 13.2648 2.247C14.8179 2.89035 16.1455 3.97981 17.0795 5.37763C18.0135 6.77545 18.512 8.41884 18.512 10.1C18.5091 12.3534 17.6126 14.5137 16.0192 16.1072C14.4257 17.7006 12.2654 18.5971 10.012 18.6ZM10.012 2.79998C8.56816 2.79998 7.15678 3.22812 5.9563 4.03025C4.75583 4.83239 3.82017 5.97249 3.26765 7.30639C2.71513 8.64029 2.57056 10.1081 2.85223 11.5241C3.13391 12.9402 3.82916 14.2409 4.85009 15.2619C5.87101 16.2828 7.17175 16.978 8.58781 17.2597C10.0039 17.5414 11.4717 17.3968 12.8056 16.8443C14.1395 16.2918 15.2796 15.3561 16.0817 14.1556C16.8838 12.9552 17.312 11.5438 17.312 10.1C17.3096 8.16463 16.5397 6.30923 15.1712 4.94073C13.8027 3.57223 11.9473 2.80236 10.012 2.79998Z"
      fill="url(#paint0_linear_redeem_twoway)"
    />
    <path
      d="M12.732 9.28799H7.29199C7.13286 9.28799 6.98025 9.22478 6.86773 9.11226C6.7552 8.99974 6.69199 8.84712 6.69199 8.68799C6.69199 8.52886 6.7552 8.37625 6.86773 8.26373C6.98025 8.15121 7.13286 8.08799 7.29199 8.08799H11.484L11.065 7.56399C10.9763 7.43915 10.9387 7.28511 10.9599 7.13344C10.981 6.98176 11.0594 6.84393 11.179 6.74818C11.2985 6.65243 11.4501 6.60601 11.6028 6.61843C11.7554 6.63086 11.8975 6.70118 12 6.81499L13.2 8.31499C13.2704 8.40329 13.3144 8.50965 13.327 8.62186C13.3397 8.73407 13.3204 8.84756 13.2714 8.9493C13.2224 9.05104 13.1457 9.13688 13.0501 9.19697C12.9545 9.25707 12.8439 9.28896 12.731 9.28899L12.732 9.28799ZM8.49099 13.614C8.40086 13.614 8.31189 13.5936 8.2307 13.5545C8.14951 13.5154 8.07817 13.4585 8.02199 13.388L6.82199 11.888C6.75166 11.7998 6.70763 11.6935 6.69496 11.5814C6.68229 11.4693 6.70149 11.3558 6.75035 11.2541C6.79922 11.1524 6.87577 11.0666 6.97122 11.0064C7.06668 10.9462 7.17716 10.9142 7.28999 10.914H12.73C12.8891 10.914 13.0417 10.9772 13.1543 11.0897C13.2668 11.2023 13.33 11.3549 13.33 11.514C13.33 11.6731 13.2668 11.8257 13.1543 11.9383C13.0417 12.0508 12.8891 12.114 12.73 12.114H8.53999L8.95899 12.638C9.02962 12.7262 9.0739 12.8326 9.08673 12.9449C9.09957 13.0571 9.08043 13.1708 9.03153 13.2726C8.98263 13.3745 8.90595 13.4605 8.81032 13.5207C8.71469 13.5809 8.604 13.6129 8.49099 13.613V13.614Z"
      fill="url(#paint0_linear_redeem_twoway)"
    />
    <path
      d="M10.012 18.6C8.33082 18.6 6.68744 18.1015 5.28962 17.1675C3.8918 16.2335 2.80234 14.906 2.15899 13.3528C1.51565 11.7996 1.34732 10.0906 1.67529 8.44171C2.00327 6.79287 2.81281 5.27832 4.00156 4.08957C5.19031 2.90083 6.70486 2.09128 8.3537 1.7633C10.0025 1.43533 11.7116 1.60366 13.2648 2.247C14.8179 2.89035 16.1455 3.97981 17.0795 5.37763C18.0135 6.77545 18.512 8.41884 18.512 10.1C18.5091 12.3534 17.6126 14.5137 16.0192 16.1072C14.4257 17.7006 12.2654 18.5971 10.012 18.6ZM10.012 2.79998C8.56816 2.79998 7.15678 3.22812 5.9563 4.03025C4.75583 4.83239 3.82017 5.97249 3.26765 7.30639C2.71513 8.64029 2.57056 10.1081 2.85223 11.5241C3.13391 12.9402 3.82916 14.2409 4.85009 15.2619C5.87101 16.2828 7.17175 16.978 8.58781 17.2597C10.0039 17.5414 11.4717 17.3968 12.8056 16.8443C14.1395 16.2918 15.2796 15.3561 16.0817 14.1556C16.8838 12.9552 17.312 11.5438 17.312 10.1C17.3096 8.16463 16.5397 6.30923 15.1712 4.94073C13.8027 3.57223 11.9473 2.80236 10.012 2.79998Z"
      fill="url(#paint1_linear_redeem_twoway)"
    />
    <path
      d="M12.732 9.28799H7.29199C7.13286 9.28799 6.98025 9.22478 6.86773 9.11226C6.7552 8.99974 6.69199 8.84712 6.69199 8.68799C6.69199 8.52886 6.7552 8.37625 6.86773 8.26373C6.98025 8.15121 7.13286 8.08799 7.29199 8.08799H11.484L11.065 7.56399C10.9763 7.43915 10.9387 7.28511 10.9599 7.13344C10.981 6.98176 11.0594 6.84393 11.179 6.74818C11.2985 6.65243 11.4501 6.60601 11.6028 6.61843C11.7554 6.63086 11.8975 6.70118 12 6.81499L13.2 8.31499C13.2704 8.40329 13.3144 8.50965 13.327 8.62186C13.3397 8.73407 13.3204 8.84756 13.2714 8.9493C13.2224 9.05104 13.1457 9.13688 13.0501 9.19697C12.9545 9.25707 12.8439 9.28896 12.731 9.28899L12.732 9.28799ZM8.49099 13.614C8.40086 13.614 8.31189 13.5936 8.2307 13.5545C8.14951 13.5154 8.07817 13.4585 8.02199 13.388L6.82199 11.888C6.75166 11.7998 6.70763 11.6935 6.69496 11.5814C6.68229 11.4693 6.70149 11.3558 6.75035 11.2541C6.79922 11.1524 6.87577 11.0666 6.97122 11.0064C7.06668 10.9462 7.17716 10.9142 7.28999 10.914H12.73C12.8891 10.914 13.0417 10.9772 13.1543 11.0897C13.2668 11.2023 13.33 11.3549 13.33 11.514C13.33 11.6731 13.2668 11.8257 13.1543 11.9383C13.0417 12.0508 12.8891 12.114 12.73 12.114H8.53999L8.95899 12.638C9.02962 12.7262 9.0739 12.8326 9.08673 12.9449C9.09957 13.0571 9.08043 13.1708 9.03153 13.2726C8.98263 13.3745 8.90595 13.4605 8.81032 13.5207C8.71469 13.5809 8.604 13.6129 8.49099 13.613V13.614Z"
      fill="url(#paint1_linear_redeem_twoway)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_redeem_twoway"
        x1="10"
        y1="18"
        x2="10"
        y2="2"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-header-start, currentColor)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-header-end, currentColor)" }}
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_redeem_twoway"
        x1="10"
        y1="2"
        x2="10"
        y2="18"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-start, currentColor)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-end, currentColor)" }}
        />
      </linearGradient>
    </defs>
  </svg>
);

export const SupportServiceIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  className,
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    preserveAspectRatio="xMidYMid meet"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.9774 9.94313C17.9774 8.96353 17.2378 8.14721 16.3035 8.10639V7.69823C16.3035 4.02476 13.4616 1.04517 9.95795 1.04517C6.4543 1.04517 3.65138 4.06557 3.65138 7.69823V8.10639C2.71708 8.14721 1.97742 8.96353 1.97742 9.94313C1.97742 10.9227 2.71708 11.739 3.65138 11.7799V11.8207H4.93605V7.73904C4.97498 4.80027 7.23289 2.43292 9.99688 2.43292C12.7609 2.43292 15.0188 4.80027 15.0188 7.69823V11.7799C15.0188 14.2697 13.3837 16.3513 11.2037 16.9227C10.9701 16.637 10.6198 16.4329 10.1915 16.4329C9.4908 16.4329 8.90686 17.0043 8.90686 17.739C8.90686 18.4737 9.4908 19.0452 10.1915 19.0452C10.7365 19.0452 11.1648 18.7186 11.3594 18.2697C14.2013 17.6166 16.3035 14.9635 16.3035 11.7799V11.739C17.2378 11.6982 17.9774 10.9227 17.9774 9.94313Z"
      fill="url(#paint0_linear_support_service)"
    />
    <path
      d="M6.97742 9.04517C6.97742 9.17649 7.00328 9.30652 7.05354 9.42785C7.10379 9.54918 7.17745 9.65941 7.27031 9.75227C7.36317 9.84513 7.47341 9.91879 7.59473 9.96905C7.71606 10.0193 7.8461 10.0452 7.97742 10.0452C8.10874 10.0452 8.23878 10.0193 8.3601 9.96905C8.48143 9.91879 8.59167 9.84513 8.68452 9.75227C8.77738 9.65941 8.85104 9.54918 8.9013 9.42785C8.95155 9.30652 8.97742 9.17649 8.97742 9.04517C8.97742 8.91384 8.95155 8.78381 8.9013 8.66248C8.85104 8.54116 8.77738 8.43092 8.68452 8.33806C8.59167 8.2452 8.48143 8.17154 8.3601 8.12129C8.23878 8.07103 8.10874 8.04517 7.97742 8.04517C7.8461 8.04517 7.71606 8.07103 7.59473 8.12129C7.47341 8.17154 7.36317 8.2452 7.27031 8.33806C7.17745 8.43092 7.10379 8.54116 7.05354 8.66248C7.00328 8.78381 6.97742 8.91384 6.97742 9.04517Z"
      fill="url(#paint0_linear_support_service)"
    />
    <path
      d="M10.9774 9.04517C10.9774 9.31038 11.0828 9.56474 11.2703 9.75227C11.4578 9.93981 11.7122 10.0452 11.9774 10.0452C12.2426 10.0452 12.497 9.93981 12.6845 9.75227C12.8721 9.56474 12.9774 9.31038 12.9774 9.04517C12.9774 8.77995 12.8721 8.5256 12.6845 8.33806C12.497 8.15052 12.2426 8.04517 11.9774 8.04517C11.7122 8.04517 11.4578 8.15052 11.2703 8.33806C11.0828 8.5256 10.9774 8.77995 10.9774 9.04517Z"
      fill="url(#paint0_linear_support_service)"
    />
    <path
      d="M17.9774 9.94313C17.9774 8.96353 17.2378 8.14721 16.3035 8.10639V7.69823C16.3035 4.02476 13.4616 1.04517 9.95795 1.04517C6.4543 1.04517 3.65138 4.06557 3.65138 7.69823V8.10639C2.71708 8.14721 1.97742 8.96353 1.97742 9.94313C1.97742 10.9227 2.71708 11.739 3.65138 11.7799V11.8207H4.93605V7.73904C4.97498 4.80027 7.23289 2.43292 9.99688 2.43292C12.7609 2.43292 15.0188 4.80027 15.0188 7.69823V11.7799C15.0188 14.2697 13.3837 16.3513 11.2037 16.9227C10.9701 16.637 10.6198 16.4329 10.1915 16.4329C9.4908 16.4329 8.90686 17.0043 8.90686 17.739C8.90686 18.4737 9.4908 19.0452 10.1915 19.0452C10.7365 19.0452 11.1648 18.7186 11.3594 18.2697C14.2013 17.6166 16.3035 14.9635 16.3035 11.7799V11.739C17.2378 11.6982 17.9774 10.9227 17.9774 9.94313Z"
      fill="url(#paint1_linear_support_service)"
    />
    <path
      d="M6.97742 9.04517C6.97742 9.17649 7.00328 9.30652 7.05354 9.42785C7.10379 9.54918 7.17745 9.65941 7.27031 9.75227C7.36317 9.84513 7.47341 9.91879 7.59473 9.96905C7.71606 10.0193 7.8461 10.0452 7.97742 10.0452C8.10874 10.0452 8.23878 10.0193 8.3601 9.96905C8.48143 9.91879 8.59167 9.84513 8.68452 9.75227C8.77738 9.65941 8.85104 9.54918 8.9013 9.42785C8.95155 9.30652 8.97742 9.17649 8.97742 9.04517C8.97742 8.91384 8.95155 8.78381 8.9013 8.66248C8.85104 8.54116 8.77738 8.43092 8.68452 8.33806C8.59167 8.2452 8.48143 8.17154 8.3601 8.12129C8.23878 8.07103 8.10874 8.04517 7.97742 8.04517C7.8461 8.04517 7.71606 8.07103 7.59473 8.12129C7.47341 8.17154 7.36317 8.2452 7.27031 8.33806C7.17745 8.43092 7.10379 8.54116 7.05354 8.66248C7.00328 8.78381 6.97742 8.91384 6.97742 9.04517Z"
      fill="url(#paint1_linear_support_service)"
    />
    <path
      d="M10.9774 9.04517C10.9774 9.31038 11.0828 9.56474 11.2703 9.75227C11.4578 9.93981 11.7122 10.0452 11.9774 10.0452C12.2426 10.0452 12.497 9.93981 12.6845 9.75227C12.8721 9.56474 12.9774 9.31038 12.9774 9.04517C12.9774 8.77995 12.8721 8.5256 12.6845 8.33806C12.497 8.15052 12.2426 8.04517 11.9774 8.04517C11.7122 8.04517 11.4578 8.15052 11.2703 8.33806C11.0828 8.5256 10.9774 8.77995 10.9774 9.04517Z"
      fill="url(#paint1_linear_support_service)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_support_service"
        x1="10"
        y1="18"
        x2="10"
        y2="2"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-header-start, currentColor)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-header-end, currentColor)" }}
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_support_service"
        x1="10"
        y1="2"
        x2="10"
        y2="18"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-start, currentColor)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-end, currentColor)" }}
        />
      </linearGradient>
    </defs>
  </svg>
);

export const LogoutIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  className,
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0184 15.3286H14.3503H14.6149C14.8404 15.3163 15.0184 15.1405 15.0184 14.9245V15.3286ZM3.86584 15.3286H4.53399H4.26934C4.04391 15.3163 3.86584 15.1405 3.86584 14.9245V15.3286ZM15.0184 4.82129H14.3503H14.6149C14.8404 4.83363 15.0184 5.00944 15.0184 5.22536V4.82129ZM3.86584 4.82129H4.53399H4.26934C4.04391 4.83363 3.86584 5.00944 3.86584 5.22536V4.82129ZM6.68217 10.0125C6.68217 10.361 6.98112 10.6448 7.35195 10.6448H16.3302C16.6994 10.6448 17 10.3626 17 10.0125C17 9.66394 16.7011 9.38017 16.3302 9.38017H7.35032C6.98112 9.38017 6.68217 9.66394 6.68217 10.0125Z"
      fill="url(#paint0_linear_logout)"
    />
    <path
      d="M13.6623 6.77862C13.4426 7.0531 13.4426 7.49743 13.6623 7.77192L16.0403 10.7449C16.26 11.0194 16.6156 11.0194 16.8352 10.7449C17.0549 10.4705 17.0549 10.0261 16.8352 9.75165L14.4573 6.77862C14.2376 6.50413 13.8806 6.50413 13.6623 6.77862Z"
      fill="url(#paint0_linear_logout)"
    />
    <path
      d="M13.6623 13.3718C13.882 13.6464 14.2376 13.6464 14.4573 13.3718L16.8352 10.3993C17.0549 10.1247 17.0549 9.68025 16.8352 9.40565C16.6156 9.13106 16.26 9.13106 16.0403 9.40565L13.6623 12.3781C13.4426 12.6527 13.4426 13.0972 13.6623 13.3718Z"
      fill="url(#paint0_linear_logout)"
    />
    <path
      d="M16.3195 13.6096C15.9454 13.6096 15.6407 13.9132 15.6407 14.2897V15.7197H4.34618V4.42899H15.6424V5.85899C15.6424 6.23392 15.9454 6.53916 16.3212 6.53916C16.697 6.53916 17 6.23557 17 5.85899V5.10749H16.9934V4.2266V4.20337C16.9934 3.57961 16.4884 3.07363 15.8659 3.07363H15.8576V3.07197H14.9619V3.07031H5.0167V3.07197H4.12102V3.07363H4.11274C3.52334 3.07363 3.03825 3.52818 2.99023 4.10715V16.0565C3.04818 16.6255 3.52831 17.0718 4.11108 17.0718H4.11936V17.0734H5.01504V17.0801H14.9603V17.0734H15.856V17.0718H15.8643C16.4868 17.0718 16.9917 16.5658 16.9917 15.942V15.0379H16.9967V14.2914C16.9983 13.9148 16.6937 13.6096 16.3195 13.6096Z"
      fill="url(#paint0_linear_logout)"
    />
    <path
      d="M15.0184 15.3286H14.3503H14.6149C14.8404 15.3163 15.0184 15.1405 15.0184 14.9245V15.3286ZM3.86584 15.3286H4.53399H4.26934C4.04391 15.3163 3.86584 15.1405 3.86584 14.9245V15.3286ZM15.0184 4.82129H14.3503H14.6149C14.8404 4.83363 15.0184 5.00944 15.0184 5.22536V4.82129ZM3.86584 4.82129H4.53399H4.26934C4.04391 4.83363 3.86584 5.00944 3.86584 5.22536V4.82129ZM6.68217 10.0125C6.68217 10.361 6.98112 10.6448 7.35195 10.6448H16.3302C16.6994 10.6448 17 10.3626 17 10.0125C17 9.66394 16.7011 9.38017 16.3302 9.38017H7.35032C6.98112 9.38017 6.68217 9.66394 6.68217 10.0125Z"
      fill="url(#paint1_linear_logout)"
    />
    <path
      d="M13.6623 6.77862C13.4426 7.0531 13.4426 7.49743 13.6623 7.77192L16.0403 10.7449C16.26 11.0194 16.6156 11.0194 16.8352 10.7449C17.0549 10.4705 17.0549 10.0261 16.8352 9.75165L14.4573 6.77862C14.2376 6.50413 13.8806 6.50413 13.6623 6.77862Z"
      fill="url(#paint1_linear_logout)"
    />
    <path
      d="M13.6623 13.3718C13.882 13.6464 14.2376 13.6464 14.4573 13.3718L16.8352 10.3993C17.0549 10.1247 17.0549 9.68025 16.8352 9.40565C16.6156 9.13106 16.26 9.13106 16.0403 9.40565L13.6623 12.3781C13.4426 12.6527 13.4426 13.0972 13.6623 13.3718Z"
      fill="url(#paint1_linear_logout)"
    />
    <path
      d="M16.3195 13.6096C15.9454 13.6096 15.6407 13.9132 15.6407 14.2897V15.7197H4.34618V4.42899H15.6424V5.85899C15.6424 6.23392 15.9454 6.53916 16.3212 6.53916C16.697 6.53916 17 6.23557 17 5.85899V5.10749H16.9934V4.2266V4.20337C16.9934 3.57961 16.4884 3.07363 15.8659 3.07363H15.8576V3.07197H14.9619V3.07031H5.0167V3.07197H4.12102V3.07363H4.11274C3.52334 3.07363 3.03825 3.52818 2.99023 4.10715V16.0565C3.04818 16.6255 3.52831 17.0718 4.11108 17.0718H4.11936V17.0734H5.01504V17.0801H14.9603V17.0734H15.856V17.0718H15.8643C16.4868 17.0718 16.9917 16.5658 16.9917 15.942V15.0379H16.9967V14.2914C16.9983 13.9148 16.6937 13.6096 16.3195 13.6096Z"
      fill="url(#paint1_linear_logout)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_logout"
        x1="10"
        y1="18"
        x2="10"
        y2="2"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-header-start, currentColor)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-header-end, currentColor)" }}
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_logout"
        x1="10"
        y1="2"
        x2="10"
        y2="18"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-start, currentColor)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-end, currentColor)" }}
        />
      </linearGradient>
    </defs>
  </svg>
);

// list向右跳转箭头
export const RightArrowIcon: React.FC<SvgIconProps> = ({
  width = 45,
  height = 20,
  className,
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="8" width="30" height="8" fill="#FFBF71" />
    <path
      d="M43.735 11.1653C44.334 11.5606 44.334 12.4394 43.735 12.8347L30.8007 21.3691C30.1359 21.8078 29.25 21.3309 29.25 20.5344L29.25 3.4656C29.25 2.66905 30.1359 2.19223 30.8007 2.63092L43.735 11.1653Z"
      fill="#FFBF71"
    />
  </svg>
);

// 右箭头【>】
export const RightArrowOutlineIcon: React.FC<SvgIconProps> = ({
  width = 16,
  height = 16,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.403 7.95658L6.00865 3.56227L6.61963 2.95129L11.6249 7.95658L6.61963 12.9619L6.00865 12.3509L10.403 7.95658Z"
      fill="white"
    />
  </svg>
);

// list向右跳转箭头
export const MessageTipsIcon: React.FC<SvgIconProps> = ({
  width = 25,
  height = 25,
  className,
  variant,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <path
      d="M10.8736 15.0463L1.88354 9.34863V18.3231C1.88354 19.7967 3.08136 20.9996 4.5584 20.9996H20.6714C22.1467 20.9996 23.3462 19.8008 23.3462 18.3231V9.49677L14.9332 15.0168C13.7872 15.7685 12.0302 15.7792 10.8736 15.0463Z"
      fill={variant === "golden" ? "#FFF9C7" : "#FFF9C7"}
    />
    <path
      d="M20.6715 4.45581H4.5584C3.08311 4.45581 1.88354 5.65456 1.88354 7.1323V7.15285L11.9908 13.5587C12.4658 13.8598 13.3195 13.8541 13.7905 13.5455L23.347 7.27554V7.1323C23.3463 5.65946 22.1485 4.45581 20.6715 4.45581Z"
      fill={variant === "golden" ? "#FFF9C7" : "#FFF9C7"}
    />
  </svg>
);

// KYC 配置图标（身份证卡片）
export const KycConfigIcon: React.FC<SvgIconProps> = ({
  width = 28,
  height = 28,
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <defs>
      <linearGradient
        id="paint0_linear_kyc_config"
        x1="10"
        y1="18"
        x2="10"
        y2="2"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-header-start, currentColor)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-header-end, currentColor)" }}
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_kyc_config"
        x1="10"
        y1="2"
        x2="10"
        y2="18"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-start, currentColor)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-end, currentColor)" }}
        />
      </linearGradient>
    </defs>
    <path
      d="M12.5471 9.60303H16.0561C16.4335 9.60303 16.6222 9.79173 16.6222 10.1691C16.6222 10.5465 16.4335 10.7352 16.0561 10.7352H12.5471C12.1697 10.7352 11.981 10.5465 11.981 10.1691C11.981 9.79173 12.1697 9.60303 12.5471 9.60303Z"
      fill="url(#paint0_linear_kyc_config)"
    />
    <path
      d="M12.5471 12.207H16.0561C16.4335 12.207 16.6222 12.3957 16.6222 12.7731C16.6222 13.1505 16.4335 13.3392 16.0561 13.3392H12.5471C12.1697 13.3392 11.981 13.1505 11.981 12.7731C11.981 12.3957 12.1697 12.207 12.5471 12.207Z"
      fill="url(#paint0_linear_kyc_config)"
    />
    <path
      d="M10.7079 7H16.0557C16.4331 7 16.6218 7.1887 16.6218 7.5661C16.6218 7.9435 16.4331 8.1322 16.0557 8.1322H10.7079C10.3305 8.1322 10.1418 7.9435 10.1418 7.5661C10.1418 7.1887 10.3305 7 10.7079 7Z"
      fill="url(#paint0_linear_kyc_config)"
    />
    <path
      d="M8.54381 10.0664C8.77272 9.85626 8.95385 9.59944 9.07496 9.31329C9.19606 9.02713 9.25433 8.71831 9.24581 8.4077C9.25194 8.09375 9.1954 7.78173 9.07949 7.48989C8.96359 7.19806 8.79064 6.93227 8.57078 6.70807C8.35092 6.48388 8.08856 6.30578 7.79904 6.1842C7.50953 6.06262 7.19867 6 6.88466 6C6.57065 6 6.2598 6.06262 5.97028 6.1842C5.68077 6.30578 5.4184 6.48388 5.19854 6.70807C4.97868 6.93227 4.80574 7.19806 4.68984 7.48989C4.57393 7.78173 4.51739 8.09375 4.52352 8.4077C4.51465 8.71819 4.57258 9.02696 4.69338 9.31313C4.81418 9.59929 4.99504 9.85618 5.22372 10.0664C4.62027 10.3834 4.11454 10.8588 3.7608 11.4415C3.40706 12.0242 3.21866 12.6922 3.21582 13.3739C3.21696 13.4797 3.24918 13.5829 3.30848 13.6706C3.36778 13.7583 3.45154 13.8266 3.54935 13.8671C3.64716 13.9075 3.7547 13.9184 3.85862 13.8982C3.96253 13.878 4.05823 13.8278 4.13382 13.7537C4.23528 13.6525 4.29283 13.5154 4.29402 13.3721C4.29402 11.9609 5.48022 10.7684 6.88511 10.7684C8.29001 10.7684 9.47261 11.9609 9.47261 13.3739C9.47369 13.5167 9.53129 13.6532 9.63281 13.7537C9.73382 13.8525 9.86953 13.9077 10.0108 13.9076C10.1519 13.9082 10.2875 13.8528 10.3879 13.7537C10.4384 13.7037 10.4785 13.6443 10.506 13.5788C10.5335 13.5134 10.5478 13.4431 10.5481 13.3721C10.5453 12.6911 10.3573 12.0237 10.0042 11.4414C9.65114 10.8591 9.14632 10.3838 8.54381 10.0664ZM6.88781 9.70639C6.63103 9.70675 6.37991 9.63097 6.16618 9.48865C5.95245 9.34632 5.78572 9.14383 5.68704 8.90676C5.58836 8.6697 5.56218 8.4087 5.61179 8.15676C5.66141 7.90482 5.7846 7.67324 5.96579 7.49129C6.14699 7.30934 6.37805 7.18519 6.62979 7.13453C6.88152 7.08386 7.14262 7.10897 7.3801 7.20666C7.61757 7.30435 7.82075 7.47024 7.96397 7.68338C8.10718 7.89651 8.184 8.14732 8.18471 8.4041C8.18376 8.74793 8.04688 9.07744 7.80392 9.32073C7.56096 9.56403 7.23164 9.70137 6.88781 9.70279V9.70639Z"
      fill="url(#paint0_linear_kyc_config)"
    />
    <path
      d="M19 5.19108C19.0011 4.90302 18.9491 4.61759 18.8471 4.35124C18.745 4.08488 18.595 3.84289 18.4056 3.6392C18.2162 3.43551 17.9911 3.27416 17.7434 3.16446C17.4957 3.05475 17.2303 2.99887 16.9624 3.00002H3.03761C2.76973 2.99887 2.50429 3.05475 2.25659 3.16446C2.0089 3.27416 1.78385 3.43551 1.59443 3.6392C1.405 3.84289 1.25496 4.08488 1.15294 4.35124C1.05092 4.61759 0.998945 4.90302 1.00002 5.19108V14.8089C0.998945 15.097 1.05092 15.3824 1.15294 15.6488C1.25496 15.9151 1.405 16.1571 1.59443 16.3608C1.78385 16.5645 2.0089 16.7258 2.25659 16.8355C2.50429 16.9452 2.76973 17.0011 3.03761 17H16.9624C17.2303 17.0011 17.4957 16.9452 17.7434 16.8355C17.9911 16.7258 18.2162 16.5645 18.4056 16.3608C18.595 16.1571 18.745 15.9151 18.8471 15.6488C18.9491 15.3824 19.0011 15.097 19 14.8089V5.19108ZM17.8678 14.8089C17.8695 14.9373 17.8472 15.0647 17.8023 15.1836C17.7574 15.3026 17.6908 15.4106 17.6064 15.5014C17.522 15.5922 17.4215 15.6638 17.3109 15.7121C17.2003 15.7604 17.0818 15.7843 16.9624 15.7825H3.03761C2.91824 15.7843 2.79975 15.7604 2.68913 15.7121C2.57852 15.6638 2.47803 15.5922 2.39362 15.5014C2.3092 15.4106 2.24258 15.3026 2.19768 15.1836C2.15278 15.0647 2.13052 14.9373 2.13221 14.8089V5.19108C2.13052 5.06272 2.15278 4.9353 2.19768 4.81636C2.24258 4.69741 2.3092 4.58935 2.39362 4.49858C2.47803 4.40781 2.57852 4.33616 2.68913 4.28788C2.79975 4.2396 2.91824 4.21567 3.03761 4.21749H16.9624C17.0818 4.21567 17.2003 4.2396 17.3109 4.28788C17.4215 4.33616 17.522 4.40781 17.6064 4.49858C17.6908 4.58935 17.7574 4.69741 17.8023 4.81636C17.8472 4.9353 17.8695 5.06272 17.8678 5.19108V14.8089Z"
      fill="url(#paint0_linear_kyc_config)"
    />
    <path
      d="M12.5471 9.60303H16.0561C16.4335 9.60303 16.6222 9.79173 16.6222 10.1691C16.6222 10.5465 16.4335 10.7352 16.0561 10.7352H12.5471C12.1697 10.7352 11.981 10.5465 11.981 10.1691C11.981 9.79173 12.1697 9.60303 12.5471 9.60303Z"
      fill="url(#paint1_linear_kyc_config)"
    />
    <path
      d="M12.5471 12.207H16.0561C16.4335 12.207 16.6222 12.3957 16.6222 12.7731C16.6222 13.1505 16.4335 13.3392 16.0561 13.3392H12.5471C12.1697 13.3392 11.981 13.1505 11.981 12.7731C11.981 12.3957 12.1697 12.207 12.5471 12.207Z"
      fill="url(#paint1_linear_kyc_config)"
    />
    <path
      d="M10.7079 7H16.0557C16.4331 7 16.6218 7.1887 16.6218 7.5661C16.6218 7.9435 16.4331 8.1322 16.0557 8.1322H10.7079C10.3305 8.1322 10.1418 7.9435 10.1418 7.5661C10.1418 7.1887 10.3305 7 10.7079 7Z"
      fill="url(#paint1_linear_kyc_config)"
    />
    <path
      d="M8.54381 10.0664C8.77272 9.85626 8.95385 9.59944 9.07496 9.31329C9.19606 9.02713 9.25433 8.71831 9.24581 8.4077C9.25194 8.09375 9.1954 7.78173 9.07949 7.48989C8.96359 7.19806 8.79064 6.93227 8.57078 6.70807C8.35092 6.48388 8.08856 6.30578 7.79904 6.1842C7.50953 6.06262 7.19867 6 6.88466 6C6.57065 6 6.2598 6.06262 5.97028 6.1842C5.68077 6.30578 5.4184 6.48388 5.19854 6.70807C4.97868 6.93227 4.80574 7.19806 4.68984 7.48989C4.57393 7.78173 4.51739 8.09375 4.52352 8.4077C4.51465 8.71819 4.57258 9.02696 4.69338 9.31313C4.81418 9.59929 4.99504 9.85618 5.22372 10.0664C4.62027 10.3834 4.11454 10.8588 3.7608 11.4415C3.40706 12.0242 3.21866 12.6922 3.21582 13.3739C3.21696 13.4797 3.24918 13.5829 3.30848 13.6706C3.36778 13.7583 3.45154 13.8266 3.54935 13.8671C3.64716 13.9075 3.7547 13.9184 3.85862 13.8982C3.96253 13.878 4.05823 13.8278 4.13382 13.7537C4.23528 13.6525 4.29283 13.5154 4.29402 13.3721C4.29402 11.9609 5.48022 10.7684 6.88511 10.7684C8.29001 10.7684 9.47261 11.9609 9.47261 13.3739C9.47369 13.5167 9.53129 13.6532 9.63281 13.7537C9.73382 13.8525 9.86953 13.9077 10.0108 13.9076C10.1519 13.9082 10.2875 13.8528 10.3879 13.7537C10.4384 13.7037 10.4785 13.6443 10.506 13.5788C10.5335 13.5134 10.5478 13.4431 10.5481 13.3721C10.5453 12.6911 10.3573 12.0237 10.0042 11.4414C9.65114 10.8591 9.14632 10.3838 8.54381 10.0664ZM6.88781 9.70639C6.63103 9.70675 6.37991 9.63097 6.16618 9.48865C5.95245 9.34632 5.78572 9.14383 5.68704 8.90676C5.58836 8.6697 5.56218 8.4087 5.61179 8.15676C5.66141 7.90482 5.7846 7.67324 5.96579 7.49129C6.14699 7.30934 6.37805 7.18519 6.62979 7.13453C6.88152 7.08386 7.14262 7.10897 7.3801 7.20666C7.61757 7.30435 7.82075 7.47024 7.96397 7.68338C8.10718 7.89651 8.184 8.14732 8.18471 8.4041C8.18376 8.74793 8.04688 9.07744 7.80392 9.32073C7.56096 9.56403 7.23164 9.70137 6.88781 9.70279V9.70639Z"
      fill="url(#paint1_linear_kyc_config)"
    />
    <path
      d="M19 5.19108C19.0011 4.90302 18.9491 4.61759 18.8471 4.35124C18.745 4.08488 18.595 3.84289 18.4056 3.6392C18.2162 3.43551 17.9911 3.27416 17.7434 3.16446C17.4957 3.05475 17.2303 2.99887 16.9624 3.00002H3.03761C2.76973 2.99887 2.50429 3.05475 2.25659 3.16446C2.0089 3.27416 1.78385 3.43551 1.59443 3.6392C1.405 3.84289 1.25496 4.08488 1.15294 4.35124C1.05092 4.61759 0.998945 4.90302 1.00002 5.19108V14.8089C0.998945 15.097 1.05092 15.3824 1.15294 15.6488C1.25496 15.9151 1.405 16.1571 1.59443 16.3608C1.78385 16.5645 2.0089 16.7258 2.25659 16.8355C2.50429 16.9452 2.76973 17.0011 3.03761 17H16.9624C17.2303 17.0011 17.4957 16.9452 17.7434 16.8355C17.9911 16.7258 18.2162 16.5645 18.4056 16.3608C18.595 16.1571 18.745 15.9151 18.8471 15.6488C18.9491 15.3824 19.0011 15.097 19 14.8089V5.19108ZM17.8678 14.8089C17.8695 14.9373 17.8472 15.0647 17.8023 15.1836C17.7574 15.3026 17.6908 15.4106 17.6064 15.5014C17.522 15.5922 17.4215 15.6638 17.3109 15.7121C17.2003 15.7604 17.0818 15.7843 16.9624 15.7825H3.03761C2.91824 15.7843 2.79975 15.7604 2.68913 15.7121C2.57852 15.6638 2.47803 15.5922 2.39362 15.5014C2.3092 15.4106 2.24258 15.3026 2.19768 15.1836C2.15278 15.0647 2.13052 14.9373 2.13221 14.8089V5.19108C2.13052 5.06272 2.15278 4.9353 2.19768 4.81636C2.24258 4.69741 2.3092 4.58935 2.39362 4.49858C2.47803 4.40781 2.57852 4.33616 2.68913 4.28788C2.79975 4.2396 2.91824 4.21567 3.03761 4.21749H16.9624C17.0818 4.21567 17.2003 4.2396 17.3109 4.28788C17.4215 4.33616 17.522 4.40781 17.6064 4.49858C17.6908 4.58935 17.7574 4.69741 17.8023 4.81636C17.8472 4.9353 17.8695 5.06272 17.8678 5.19108V14.8089Z"
      fill="url(#paint1_linear_kyc_config)"
    />
  </svg>
);

// Event 事件图标
export const EventIcon: React.FC<SvgIconProps> = ({
  width = 38,
  height = 38,
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <defs>
      <filter
        id="filter0_d_874_1967"
        x="-1"
        y="-0.999817"
        width="40"
        height="40"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.36295 0 0 0 0 0.500978 0 0 0 0 1 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_874_1967"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_874_1967"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_874_1967"
        x1="18.9988"
        y1="8.87146"
        x2="18.9988"
        y2="29.3596"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEF2AD" />
        <stop offset="0.490385" stopColor="#F1CB43" />
        <stop offset="1" stopColor="#D09020" />
      </linearGradient>
    </defs>
    <g filter="url(#filter0_d_874_1967)">
      <path
        d="M19.8062 13.2416H18.175V17.9057H8.4953V14.1627C8.4953 13.5721 8.96639 13.101 9.55936 13.101H13.9703C12.7844 12.8549 11.8984 12.3463 11.8633 11.4088C11.8305 10.3072 13.075 8.52365 14.8891 8.93146C16.7641 9.35333 18.0742 10.8041 19.0773 12.0463C20.0898 10.7807 21.5242 9.14708 23.4789 8.88927C25.1148 8.68302 26.4648 10.3143 26.2914 11.3924C26.1437 12.3369 25.2391 12.8502 24.0836 13.0986H28.4383C29.0289 13.0986 29.5023 13.5721 29.5023 14.1604V17.9033H19.8273M15.0906 9.91115C14.1859 9.5549 13.6562 9.93693 13.2742 10.5674C13.0656 10.9236 12.8453 11.3971 13.1758 11.7416C14.0453 12.6369 16.4336 12.5713 18.0367 12.4049C17.2773 11.4627 16.3492 10.408 15.0906 9.91115ZM24.9836 11.7346C25.607 10.9377 24.3859 9.28302 23.0758 9.8924C21.8219 10.483 20.9195 11.4416 20.1414 12.3885C20.8117 12.4471 21.4914 12.4611 22.1664 12.4283C22.9867 12.3955 24.5031 12.3393 24.9836 11.7346ZM9.63671 18.7635V25.544C9.63671 27.6416 11.3547 29.3596 13.4523 29.3596H18.1867V18.7635H9.63671ZM19.8133 18.7635V29.3596H24.55C26.6476 29.3596 28.3656 27.6416 28.3656 25.544V18.7635H19.8133Z"
        fill="url(#paint0_linear_874_1967)"
      />
    </g>
  </svg>
);

// Profile 用户资料图标
export const ProfileIcon: React.FC<SvgIconProps> = ({
  width = 38,
  height = 38,
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <defs>
      <filter
        id="filter0_d_874_1961"
        x="-1"
        y="-1"
        width="40"
        height="40"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.36295 0 0 0 0 0.500978 0 0 0 0 1 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_874_1961"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_874_1961"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_874_1961"
        x1="19"
        y1="8"
        x2="19"
        y2="30"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEF2AD" />
        <stop offset="0.490385" stopColor="#F1CB43" />
        <stop offset="1" stopColor="#D09020" />
      </linearGradient>
    </defs>
    <g filter="url(#filter0_d_874_1961)">
      <path
        d="M29.9991 29.1602C29.9991 29.1611 29.9996 29.162 29.9996 29.163C29.9996 29.7571 29.6527 30 29.0833 30H8.91668C8.34734 30 8.00042 29.7571 8.00042 29.163C8.00042 29.162 8.00089 29.1611 8.00089 29.1602H8C8 29.1602 8 25.2383 10.7459 23.8127C12.483 22.9102 11.8143 23.6427 13.9471 22.7196C16.0803 21.7976 16.5856 21.4753 16.5856 21.4753L16.6054 19.3508C16.6054 19.3508 15.8068 18.7128 15.5585 16.7135C15.0585 16.8639 14.8933 16.1006 14.8642 15.6148C14.8374 15.1459 14.5747 13.6791 15.1847 13.8118C15.0598 12.8327 14.9703 11.9499 15.0142 11.4818C15.1673 9.84038 16.6824 8.12518 19.0161 8C21.7616 8.12427 22.8493 9.83951 23.0014 11.4809C23.0462 11.949 22.9482 12.8318 22.8233 13.809C23.4334 13.6791 23.1684 15.1431 23.1384 15.6121C23.1116 16.0979 22.9428 16.8583 22.4442 16.7079C22.1949 18.7081 21.3959 19.3405 21.3959 19.3405L21.4147 21.4547C21.4147 21.4547 21.9201 21.7554 24.0529 22.6776C26.1861 23.6006 25.517 22.9102 27.2545 23.8127C30 25.2383 30 29.1601 30 29.1601L29.9991 29.1602Z"
        fill="url(#paint0_linear_874_1961)"
      />
    </g>
  </svg>
);

// Reword 奖励图标
export const RewardIcon: React.FC<SvgIconProps> = ({
  width = 34,
  height = 36,
  className,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    onClick={onClick}
    viewBox="0 0 34 36"
    fill="none"
  >
    <g filter="url(#filter0_d_1513_1435)">
      <path
        d="M21.1318 13.9833C20.8864 13.8577 20.8455 13.5649 21.0091 13.3556C21.1318 13.1883 21.2545 13.0209 21.3364 12.8536C22.1136 11.4728 22.0727 9.88284 21.1727 9.38075C20.9682 9.25523 20.7636 9.21339 20.5182 9.21339C20.2727 9.21339 20.0682 9.25523 19.8227 9.38075C19.7818 9.42259 19.7 9.42259 19.6591 9.42259C19.5364 9.42259 19.4136 9.38075 19.3318 9.25523C18.8 8.50209 17.9409 8 16.9591 8C15.9773 8 15.1182 8.50209 14.5864 9.25523C14.5045 9.38075 14.3818 9.42259 14.2591 9.42259C14.2182 9.42259 14.1364 9.42259 14.0955 9.38075C13.8909 9.21339 13.6455 9.17155 13.4409 9.17155C13.1955 9.17155 12.9909 9.21339 12.7864 9.33891C11.9273 9.841 11.8455 11.431 12.6227 12.8117C12.7455 12.9791 12.8273 13.1883 12.95 13.3138C13.1136 13.523 13.0727 13.8159 12.8273 13.9414C9.96364 15.4895 8 18.5858 8 22.1423C8 23.9414 8.57273 25.6151 9.51364 26.9958C9.96364 27.6234 10.7 28 11.4773 28H22.5227C23.3 28 24.0364 27.6234 24.4864 26.9958C25.4273 25.6151 26 23.9414 26 22.1423C26 18.5858 24.0364 15.4895 21.1318 13.9833ZM17 25.0711C17 22.7699 15.1591 20.887 12.9091 20.887C15.1591 20.887 17 19.0042 17 16.7029C17 19.0042 18.8409 20.887 21.0909 20.887C18.8409 20.887 17 22.7699 17 25.0711Z"
        fill="url(#paint0_linear_1513_1435)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1513_1435"
        x="0"
        y="0"
        width="34"
        height="36"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.36295 0 0 0 0 0.500978 0 0 0 0 1 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1513_1435"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1513_1435"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1513_1435"
        x1="17"
        y1="8"
        x2="17"
        y2="28"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEF2AD" />
        <stop offset="0.490385" stopColor="#F1CB43" />
        <stop offset="1" stopColor="#D09020" />
      </linearGradient>
    </defs>
  </svg>
);

export const InviteIcon: React.FC<SvgIconProps> = ({
  width = 22,
  height = 21,
  className,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 38 37"
    fill="none"
    className={className}
    onClick={onClick}
  >
    <g filter="url(#filter0_d_193_271511)">
      <path
        d="M29.2609 18.0648C29.4562 18.3725 29.56 18.7295 29.5599 19.0939V25.68C29.5599 26.4438 29.2565 27.1764 28.7164 27.7165C28.1763 28.2566 27.4438 28.56 26.6799 28.56H11.3199C10.5561 28.56 9.82358 28.2566 9.28347 27.7165C8.74337 27.1764 8.43994 26.4438 8.43994 25.68V19.1011C8.43995 18.757 8.53246 18.4191 8.70781 18.123C8.88316 17.8268 9.13489 17.5832 9.43665 17.4177C9.73842 17.2522 10.0791 17.1709 10.4231 17.1822C10.7671 17.1935 11.1017 17.2971 11.3919 17.4821L18.9798 22.32L26.6103 17.4735C26.8232 17.3382 27.0606 17.2462 27.309 17.2027C27.5574 17.1593 27.812 17.1652 28.0581 17.2201C28.3043 17.275 28.5372 17.3779 28.7435 17.5228C28.9499 17.6677 29.1257 17.8519 29.2609 18.0648ZM23.7999 8.40002C24.5638 8.40002 25.2963 8.70345 25.8364 9.24356C26.3765 9.78366 26.6799 10.5162 26.6799 11.28V16.08L19.0158 20.88L11.3199 16.08V11.28C11.3199 10.5162 11.6234 9.78366 12.1635 9.24356C12.7036 8.70345 13.4361 8.40002 14.1999 8.40002H23.7999Z"
        fill="url(#paint0_linear_193_271511)"
      />
      <path
        d="M19.5967 16.7942C19.438 16.9516 19.2235 17.0399 19 17.0399C18.7765 17.0399 18.5621 16.9516 18.4034 16.7942L16.2165 14.6198L16.1858 14.5891C15.8305 14.2204 15.6345 13.7267 15.6403 13.2148C15.646 12.7028 15.853 12.2136 16.2165 11.8531C16.5867 11.486 17.0869 11.28 17.6083 11.28C18.1296 11.28 18.6298 11.486 19 11.8531C19.3702 11.486 19.8705 11.28 20.3918 11.28C20.9131 11.28 21.4134 11.486 21.7836 11.8531C22.1462 12.2129 22.3531 12.7007 22.3596 13.2115C22.3662 13.7223 22.1719 14.2153 21.8186 14.5843L21.7836 14.6203L19.5967 16.7947V16.7942Z"
        fill="#273870"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_193_271511"
        x="-1"
        y="-2"
        width="40"
        height="40"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.36295 0 0 0 0 0.500978 0 0 0 0 1 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_193_271511"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_193_271511"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_193_271511"
        x1="18.9999"
        y1="8.40002"
        x2="18.9999"
        y2="28.56"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEF2AD" />
        <stop offset="0.490385" stopColor="#F1CB43" />
        <stop offset="1" stopColor="#D09020" />
      </linearGradient>
    </defs>
  </svg>
);

export const InputRightArrowIcon: React.FC<SvgIconProps> = ({
  width = 7,
  height = 12,
  className,
}) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 7 12"
    fill="none"
    className={className}
  >
    <path
      d="M4.78785 6L0.251086 1.46323C-0.0836487 1.1285 -0.0836487 0.585786 0.251086 0.251051C0.585822 -0.0836838 1.12853 -0.0836838 1.46327 0.251051L6.60613 5.39391C6.94086 5.72864 6.94086 6.27136 6.60613 6.60609L1.46327 11.7489C1.12853 12.0837 0.585822 12.0837 0.251086 11.7489C-0.0836487 11.4142 -0.0836487 10.8715 0.251086 10.5368L4.78785 6Z"
      fill="currentColor"
    />
  </svg>
);

export const MessageCloseIcon: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_1513_1294)">
      <path
        d="M22.2061 7.68283C21.6481 6.36471 20.8495 5.18107 19.8324 4.16478C18.8153 3.14849 17.6308 2.35051 16.3116 1.79298C14.9454 1.21561 13.4946 0.922852 12.0006 0.922852C10.5055 0.922852 9.05464 1.21561 7.68849 1.79298C6.36929 2.35051 5.18472 3.14849 4.16762 4.16478C3.15053 5.18107 2.35191 6.36468 1.79393 7.68283C1.21608 9.04792 0.923096 10.4976 0.923096 11.9921C0.923096 13.486 1.21608 14.9357 1.79393 16.3008C2.35191 17.6189 3.15053 18.8026 4.16762 19.8188C5.18472 20.8351 6.36929 21.6331 7.68849 22.1906C9.05467 22.768 10.5055 23.0608 12.0006 23.0608C13.4946 23.0608 14.9454 22.768 16.3116 22.1906C17.6308 21.6331 18.8153 20.8351 19.8324 19.8188C20.8495 18.8026 21.6481 17.6189 22.2061 16.3008C22.784 14.9357 23.0769 13.486 23.0769 11.9921C23.0769 10.4976 22.7839 9.04795 22.2061 7.68283ZM12.0006 21.5356C6.73405 21.5356 2.44941 17.2545 2.44941 11.9921C2.44941 6.72915 6.73405 2.44793 12.0006 2.44793C17.266 2.44793 21.5506 6.72915 21.5506 11.9921C21.5506 17.2545 17.266 21.5356 12.0006 21.5356ZM15.4511 7.34884C15.4509 7.34901 15.4507 7.3492 15.4506 7.34936L11.9012 10.9027L8.34508 7.35615C8.03715 7.04906 7.5385 7.04936 7.23135 7.35625C7.23116 7.35644 7.23097 7.35665 7.23081 7.35679C6.9233 7.66464 6.9238 8.16329 7.23187 8.47055L10.788 12.0172L7.23864 15.5704C6.93114 15.8783 6.93163 16.3769 7.24013 16.6846C7.54806 16.9917 8.04666 16.9914 8.35421 16.684C8.35438 16.6839 8.35459 16.6837 8.35476 16.6835L11.9041 13.1302L15.4602 16.6768C15.7681 16.9839 16.2668 16.9836 16.5743 16.6763C16.5745 16.6761 16.5747 16.6759 16.5749 16.6757C16.882 16.3683 16.8815 15.8697 16.5734 15.5624L13.0173 12.0158L16.5667 8.46251C16.8742 8.15466 16.8737 7.65601 16.5656 7.34872C16.2573 7.04123 15.7587 7.04151 15.4511 7.34884Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1513_1294">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const HelpIcon: React.FC<SvgIconProps> = ({
  width = 14,
  height = 14,
  className,
  onClick,
  gradientStart = "#FFF9C7",
  gradientEnd = "#FFDE71",
}) => {
  const uid = React.useId().replace(/:/g, "");
  const gradientId0 = `paint0_${uid}`;
  const gradientId1 = `paint1_${uid}`;
  const clipId = `clip0_${uid}`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      className={className}
      onClick={onClick}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M7 0C3.1339 0 0 3.1339 0 7C0 10.8661 3.1339 14 7 14C10.8661 14 14 10.8661 14 7C14 3.1339 10.8661 0 7 0ZM7 1.4C10.0929 1.4 12.6 3.90705 12.6 7C12.6 10.0929 10.0929 12.6 7 12.6C3.90705 12.6 1.4 10.0929 1.4 7C1.4 3.90705 3.90705 1.4 7 1.4Z"
          fill="#FFF1B2"
        />
        <path
          d="M7 0C3.1339 0 0 3.1339 0 7C0 10.8661 3.1339 14 7 14C10.8661 14 14 10.8661 14 7C14 3.1339 10.8661 0 7 0ZM7 1.4C10.0929 1.4 12.6 3.90705 12.6 7C12.6 10.0929 10.0929 12.6 7 12.6C3.90705 12.6 1.4 10.0929 1.4 7C1.4 3.90705 3.90705 1.4 7 1.4Z"
          fill={`url(#${gradientId0})`}
        />
        <path
          d="M6.99049 2.80005C9.10039 2.80005 10.5285 5.00616 9.40747 6.53593C9.22315 6.78707 9.02485 6.99699 8.74685 7.25005L8.34572 7.60615C7.91097 7.99318 7.76631 8.1989 7.75158 8.47142L7.75045 8.52028L7.75271 8.90196L6.24186 8.91188L6.2396 8.52524C6.2396 7.70692 6.56216 7.17982 7.25375 6.54432L7.45205 6.36761L7.64091 6.20119C7.9038 5.96761 8.06319 5.80425 8.19312 5.62715C8.51154 5.19318 7.95063 4.32677 6.99049 4.32677C6.13157 4.32677 5.73988 4.70921 5.71231 5.22982L5.7108 5.28631V5.46379H4.19995V5.28364C4.20373 3.90692 5.25188 2.80005 6.99049 2.80005ZM7.75309 9.67028V11.2H6.24224V9.67028H7.75309Z"
          fill="#FFF1B2"
        />
        <path
          d="M6.99049 2.80005C9.10039 2.80005 10.5285 5.00616 9.40747 6.53593C9.22315 6.78707 9.02485 6.99699 8.74685 7.25005L8.34572 7.60615C7.91097 7.99318 7.76631 8.1989 7.75158 8.47142L7.75045 8.52028L7.75271 8.90196L6.24186 8.91188L6.2396 8.52524C6.2396 7.70692 6.56216 7.17982 7.25375 6.54432L7.45205 6.36761L7.64091 6.20119C7.9038 5.96761 8.06319 5.80425 8.19312 5.62715C8.51154 5.19318 7.95063 4.32677 6.99049 4.32677C6.13157 4.32677 5.73988 4.70921 5.71231 5.22982L5.7108 5.28631V5.46379H4.19995V5.28364C4.20373 3.90692 5.25188 2.80005 6.99049 2.80005ZM7.75309 9.67028V11.2H6.24224V9.67028H7.75309Z"
          fill={`url(#${gradientId1})`}
        />
      </g>
      <defs>
        <linearGradient
          id={gradientId0}
          x1="7"
          y1="2.45"
          x2="7"
          y2="11.2"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={gradientStart} />
          <stop offset="1" stopColor={gradientEnd} />
        </linearGradient>
        <linearGradient
          id={gradientId1}
          x1="6.99995"
          y1="4.27005"
          x2="6.99995"
          y2="9.52005"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={gradientStart} />
          <stop offset="1" stopColor={gradientEnd} />
        </linearGradient>
        <clipPath id={clipId}>
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TagCloseIcon: React.FC<SvgIconProps> = ({
  width = 18,
  height = 18,
  className,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    className={className}
    onClick={onClick}
  >
    <g clipPath="url(#clip0_381_1663)">
      <path
        d="M9 0C4.02959 0 0 4.02959 0 9C0 13.9704 4.02959 18 9 18C13.9704 18 18 13.9704 18 9C18 4.02959 13.9704 0 9 0ZM13.3494 12.2616L12.2616 13.3494L9 10.0878L5.7384 13.3494L4.65059 12.2616L7.9122 9L4.65059 5.7384L5.7378 4.65059L9 7.9122L12.2616 4.65059L13.3494 5.7384L10.0878 9L13.3494 12.2616Z"
        fill="white"
        fillOpacity="0.2"
      />
    </g>
    <defs>
      <clipPath id="clip0_381_1663">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const GoldLightIcon: React.FC<SvgIconProps> = ({
  width = 110,
  height = 14,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    className={className}
  >
    <g filter="url(#filter0_f_789_10244)">
      <path
        d="M106 6.99999C87.2383 8.12436 78.0033 9.99999 55.5285 9.99999C33.0537 9.99999 25.4041 7.74936 4 6.99999C25.4041 6.24936 33.0537 3.99999 55.5285 3.99999C78.0033 3.99999 85.1244 6.24936 106 6.99999Z"
        fill="#FFF2AB"
      />
    </g>
    <g filter="url(#filter1_f_789_10244)">
      <path
        d="M76 7.50009C69.4715 8.62509 64.472 9.00009 55.2176 9.00009C45.9633 9.00009 40.5285 8.06259 34 7.50009C40.7461 6.75009 45.9633 6.00009 55.2176 6.00009C64.472 6.00009 69.4715 6.75009 76 7.50009Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_789_10244"
        x="0"
        y="0"
        width="110"
        height="14"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="2"
          result="effect1_foregroundBlur_789_10244"
        />
      </filter>
      <filter
        id="filter1_f_789_10244"
        x="32"
        y="4.00009"
        width="46"
        height="7"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="1"
          result="effect1_foregroundBlur_789_10244"
        />
      </filter>
    </defs>
  </svg>
);

// ShareAppBar 关闭图标
export const ShareAppBarCloseIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  className,
  bgColor,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle
      cx="10"
      cy="10"
      r="10"
      fill={bgColor ?? "var(--icon-bg-color, black)"}
      fillOpacity="0.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1178 5.32238C13.5483 4.89254 14.2468 4.89254 14.6773 5.32238C15.1076 5.75216 15.1075 6.44923 14.6773 6.87902L11.5504 9.99914L14.6773 13.1212C15.1077 13.551 15.1077 14.248 14.6773 14.6778C14.2468 15.1077 13.5483 15.1077 13.1178 14.6778L9.9918 11.5558L6.88145 14.6622C6.45098 15.0917 5.75328 15.0918 5.32286 14.6622C4.89236 14.2324 4.8924 13.5354 5.32286 13.1056L8.43223 10.0001L5.32286 6.89465C4.89257 6.46479 4.89242 5.76777 5.32286 5.338C5.75338 4.90829 6.45196 4.90821 6.88243 5.338L9.9918 8.4425L13.1178 5.32238Z"
      fill="white"
      fillOpacity="0.75"
    />
  </svg>

  // <svg
  //   xmlns="http://www.w3.org/2000/svg"
  //   viewBox="0 0 20 20"
  //   width={width}
  //   height={height}
  //   fill="none"
  //   className={className}
  // >
  //   <path
  //     fillRule="evenodd"
  //     clipRule="evenodd"
  //     d="M9.23395 10L3.78363 4.54972L4.54966 3.78369L9.99998 9.23401L15.4503 3.78369L16.2163 4.54972L10.766 10L16.2163 15.4504L15.4503 16.2164L9.99998 10.7661L4.54966 16.2164L3.78363 15.4504L9.23395 10Z"
  //     fill="white"
  //   />
  // </svg>
);

export const VipRewardIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  color = "currentColor",
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    className={className}
  >
    <path
      d="M10.0042 18.3356C5.40187 18.3356 1.6709 14.6047 1.6709 10.0022C1.6709 5.3999 5.40187 1.66895 10.0042 1.66895C14.6066 1.66895 18.3376 5.3999 18.3376 10.0022C18.3376 14.6047 14.6066 18.3356 10.0042 18.3356ZM7.08757 11.6689V13.3356H9.17092V15.0022H10.8376V13.3356H11.6709C12.8215 13.3356 13.7542 12.4029 13.7542 11.2522C13.7542 10.1017 12.8215 9.1689 11.6709 9.1689H8.33758C8.10745 9.1689 7.9209 8.9824 7.9209 8.75224C7.9209 8.52215 8.10745 8.33557 8.33758 8.33557H12.9209V6.66895H10.8376V5.00228H9.17092V6.66895H8.33758C7.18697 6.66895 6.25423 7.60168 6.25423 8.75224C6.25423 9.9029 7.18697 10.8356 8.33758 10.8356H11.6709C11.901 10.8356 12.0876 11.0222 12.0876 11.2522C12.0876 11.4824 11.901 11.6689 11.6709 11.6689H7.08757Z"
      fill={color}
    />
  </svg>
);

export const VipRebateIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  color = "currentColor",
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    className={className}
  >
    <path
      d="M7.00142 8.62672L8.62892 8.6271C10.4929 8.6271 12.0039 10.1381 12.0039 12.0021H6.75316L6.75391 12.7521L12.7539 12.7515V12.0021C12.7539 11.1903 12.5153 10.4248 12.0893 9.7515L14.2539 9.7521C15.7481 9.7521 17.0382 10.6261 17.641 11.8906C15.8674 14.2311 12.9953 15.7521 9.75392 15.7521C7.68295 15.7521 5.92858 15.3091 4.50367 14.5335L4.50469 7.55535C5.43885 7.68915 6.29366 8.06887 7.00142 8.62672ZM3.75391 14.2521C3.75391 14.6663 3.41812 15.0021 3.00391 15.0021H1.50391C1.0897 15.0021 0.753906 14.6663 0.753906 14.2521V7.5021C0.753906 7.08789 1.0897 6.75211 1.50391 6.75211H3.00391C3.41812 6.75211 3.75391 7.08789 3.75391 7.5021V14.2521ZM13.5039 3.75211C14.7465 3.75211 15.7539 4.75946 15.7539 6.00211C15.7539 7.24474 14.7465 8.2521 13.5039 8.2521C12.2612 8.2521 11.2539 7.24474 11.2539 6.00211C11.2539 4.75946 12.2612 3.75211 13.5039 3.75211ZM8.25392 1.50211C9.49652 1.50211 10.5039 2.50946 10.5039 3.75211C10.5039 4.99474 9.49652 6.00211 8.25392 6.00211C7.01127 6.00211 6.00391 4.99474 6.00391 3.75211C6.00391 2.50946 7.01127 1.50211 8.25392 1.50211Z"
      fill={color}
    />
  </svg>
);

export const VipSignInIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  color = "currentColor",
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    className={className}
  >
    <path
      d="M10.6918 16.3081L9 18L7.30812 16.3081C3.98206 15.5403 1.5 12.5582 1.5 9C1.5 4.86 4.86 1.5 9 1.5C13.14 1.5 16.5 4.86 16.5 9C16.5 12.5582 14.0179 15.5403 10.6918 16.3081ZM4.51749 11.5622C5.61812 13.2052 7.27133 14.25 9.11977 14.25C10.9682 14.25 12.6214 13.2052 13.7221 11.5622C12.5164 10.4379 10.8984 9.75 9.11977 9.75C7.34116 9.75 5.72321 10.4379 4.51749 11.5622ZM9 8.25C10.2427 8.25 11.25 7.24264 11.25 6C11.25 4.75736 10.2427 3.75 9 3.75C7.75732 3.75 6.75 4.75736 6.75 6C6.75 7.24264 7.75732 8.25 9 8.25Z"
      fill={color}
    />
  </svg>
);

export const TitleLineLeftIcon: React.FC<SvgIconProps> = ({
  width = 32,
  height = 1,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 32 1"
    fill="none"
    className={className}
  >
    <path d="M0 0V1H32V0H0Z" fill="url(#paint0_linear_1863_1143)" />
    <defs>
      <linearGradient
        id="paint0_linear_1863_1143"
        x1="32"
        y1="1.5"
        x2="0.00038528"
        y2="1.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF1B2" />
        <stop offset="1" stopColor="#FFF1B2" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const TitleLineRightIcon: React.FC<SvgIconProps> = ({
  width = 32,
  height = 1,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 32 1"
    fill="none"
    className={className}
  >
    <path d="M32 0V1H0V0H32Z" fill="url(#paint0_linear_1863_1138)" />
    <defs>
      <linearGradient
        id="paint0_linear_1863_1138"
        x1="0"
        y1="1.5"
        x2="31.9996"
        y2="1.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF1B2" />
        <stop offset="1" stopColor="#FFF1B2" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

// 左箭头图标
export const ArrowLeftIcon: React.FC<SvgIconProps> = ({
  width = 30,
  height = 30,
  variant,
  color,
  className,
  onClick,
}) => {
  const arrowColor = color || (variant === "custom" ? "#2C4686" : "white");

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      className={className}
      onClick={onClick}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      <circle cx="15" cy="15" r="15" fill="#13244D" />
      <path
        d="M10 15H21"
        stroke={arrowColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M15 9L9.56194 14.9324C9.52689 14.9707 9.5269 15.0293 9.56194 15.0676L15 21"
        stroke={arrowColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

// 简单左箭头图标（无背景）
export const ArrowLeftSimpleIcon: React.FC<SvgIconProps> = ({
  width = 30,
  height = 30,
  variant,
  color,
  className,
  onClick,
}) => {
  const arrowColor = color || (variant === "custom" ? "#2C4686" : "white");

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      className={className}
      onClick={onClick}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      <path
        d="M10 15H21"
        stroke={arrowColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M15 9L9.56194 14.9324C9.52689 14.9707 9.5269 15.0293 9.56194 15.0676L15 21"
        stroke={arrowColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

// 右箭头图标
export const ArrowRightIcon: React.FC<SvgIconProps> = ({
  width = 30,
  height = 30,
  variant,
  bgColor,
  color,
  className,
  onClick,
}) => {
  const arrowColor = color || (variant === "custom" ? "#2C4686" : "white");

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      className={className}
      onClick={onClick}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      <circle
        cx="15"
        cy="15"
        r="15"
        transform="matrix(-1 0 0 1 30 0)"
        fill={bgColor || "#13244D"}
      />
      <path
        d="M20 15H9"
        stroke={arrowColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M15 9L20.4381 14.9324C20.4731 14.9707 20.4731 15.0293 20.4381 15.0676L15 21"
        stroke={arrowColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

// 倒计时图标
export const TimeIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      d="M9.95898 1.25781C5.14258 1.25781 1.23633 5.16406 1.23633 9.98047C1.23633 14.7969 5.14062 18.7031 9.95898 18.7031C14.7773 18.7031 18.6816 14.7988 18.6816 9.98047C18.6816 5.16406 14.7773 1.25781 9.95898 1.25781ZM12.2461 10.8652H9.8125C9.32422 10.8652 8.92773 10.4687 8.92773 9.98047V5.35742C8.92773 4.86914 9.32422 4.47266 9.8125 4.47266C10.3008 4.47266 10.6973 4.86914 10.6973 5.35742V9.09766H12.2461C12.7344 9.09766 13.1309 9.49414 13.1309 9.98242C13.1309 10.4707 12.7344 10.8652 12.2461 10.8652Z"
      fill="url(#paint0_linear_7450_12415)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7450_12415"
        x1="9.95898"
        y1="1.25781"
        x2="9.95898"
        y2="18.7031"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF0B4" />
        <stop offset="0.745192" stopColor="#FFFDEE" />
      </linearGradient>
    </defs>
  </svg>
);

export const VipCardBottomTipIcon: React.FC<SvgIconProps> = ({
  width = 12,
  height = 11,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 12 11"
    fill="none"
    className={className}
  >
    <path
      d="M11.6365 5.41651C11.7016 5.41651 11.7613 5.44003 11.8156 5.48707C11.8699 5.53411 11.9115 5.59562 11.9404 5.6716C11.9694 5.74758 11.9784 5.83442 11.9676 5.93211C11.9567 6.02981 11.9151 6.13293 11.8427 6.24147C11.698 6.45857 11.5189 6.73355 11.3054 7.06643C11.092 7.39931 10.8224 7.76475 10.4968 8.16276C10.4027 8.27855 10.3122 8.35815 10.2254 8.40157C10.1385 8.44498 10.0409 8.45946 9.93231 8.44498C9.81652 8.43051 9.72607 8.37986 9.66094 8.29302C9.59581 8.20618 9.50897 8.10849 9.40043 7.99994C9.24122 7.84074 9.08745 7.66525 8.9391 7.47349C8.79075 7.28172 8.65507 7.09719 8.53205 6.91989C8.40903 6.7426 8.3041 6.58521 8.21726 6.44771C8.13042 6.31022 8.07253 6.21615 8.04358 6.16549C7.97122 6.05694 7.92961 5.95563 7.91875 5.86156C7.9079 5.76748 7.91514 5.68788 7.94046 5.62275C7.96579 5.55763 8.00197 5.50697 8.04901 5.47079C8.09605 5.4346 8.1449 5.41651 8.19555 5.41651H9.30273C9.30273 4.88825 9.196 4.36541 8.98252 3.848C8.76904 3.33059 8.4633 2.87289 8.06529 2.47488C7.69623 2.10582 7.2729 1.83264 6.79529 1.65535C6.31768 1.47805 5.82922 1.39302 5.3299 1.40026C4.83058 1.4075 4.34393 1.50519 3.86994 1.69334C3.39595 1.88149 2.97442 2.16009 2.60536 2.52915C2.2363 2.89821 1.94865 3.32879 1.74241 3.82087C1.53617 4.31295 1.4222 4.8195 1.40049 5.34053C1.37878 5.86156 1.45295 6.3663 1.62301 6.85477C1.79307 7.34323 2.06624 7.76475 2.44254 8.11934C2.77542 8.42327 3.1083 8.66389 3.44118 8.84118C3.77406 9.01848 4.0997 9.14692 4.4181 9.22653C4.73651 9.30613 5.04044 9.34231 5.3299 9.33507C5.61936 9.32784 5.8853 9.29527 6.12772 9.23738C6.37015 9.17949 6.58543 9.1017 6.77358 9.004C6.96173 8.90631 7.11008 8.80681 7.21862 8.7055C7.3923 8.60419 7.57683 8.54991 7.77222 8.54268C7.9676 8.53544 8.13766 8.60781 8.28239 8.75977C8.4633 8.94068 8.52843 9.12702 8.47777 9.31879C8.42712 9.51056 8.31495 9.69328 8.14128 9.86695C8.06168 9.94656 7.97122 10.0081 7.86991 10.0515C7.3923 10.3916 6.87489 10.6159 6.31768 10.7245C5.76047 10.833 5.19964 10.8403 4.6352 10.7462C4.07075 10.6521 3.52078 10.4658 2.98528 10.1872C2.44978 9.90856 1.96855 9.55579 1.5416 9.12883C1.02057 8.60781 0.6298 8.01984 0.369286 7.36494C0.108772 6.71004 -0.0214844 6.04066 -0.0214844 5.35681C-0.0214844 4.67296 0.110582 4.00178 0.374713 3.34326C0.638845 2.68474 1.03142 2.09496 1.55245 1.57394C2.07348 1.05291 2.66144 0.66033 3.31635 0.396198C3.97125 0.132066 4.64062 -7.06714e-09 5.32447 0C6.00832 7.06714e-09 6.67951 0.132066 7.33803 0.396198C7.99655 0.66033 8.58632 1.05291 9.10735 1.57394C9.39681 1.8634 9.64104 2.17095 9.84004 2.49659C10.039 2.82223 10.1982 3.1533 10.3177 3.4898C10.4371 3.82629 10.5221 4.15917 10.5727 4.48843C10.6234 4.81769 10.6487 5.12705 10.6487 5.41651H11.6365ZM6.1223 5.3948C6.1223 5.58295 6.05717 5.74397 5.92691 5.87784C5.79665 6.01172 5.63745 6.07865 5.4493 6.07865C5.26115 6.07865 5.10014 6.01172 4.96627 5.87784C4.83239 5.74397 4.76545 5.58295 4.76545 5.3948V3.35411C4.76545 3.16596 4.83239 3.00676 4.96627 2.87651C5.10014 2.74625 5.26115 2.68112 5.4493 2.68112C5.63745 2.68112 5.79665 2.74625 5.92691 2.87651C6.05717 3.00676 6.1223 3.16596 6.1223 3.35411V5.3948ZM5.4493 6.75165C5.63745 6.75165 5.79665 6.81858 5.92691 6.95246C6.05717 7.08633 6.1223 7.24735 6.1223 7.43549C6.1223 7.62364 6.05717 7.78285 5.92691 7.9131C5.79665 8.04336 5.63745 8.10849 5.4493 8.10849C5.26115 8.10849 5.10014 8.04336 4.96627 7.9131C4.83239 7.78285 4.76545 7.62364 4.76545 7.43549C4.76545 7.24735 4.83239 7.08633 4.96627 6.95246C5.10014 6.81858 5.26115 6.75165 5.4493 6.75165Z"
      fill="currentColor"
    />
  </svg>
);

export const InviteFriendsListNotQualifiedIcon: React.FC<SvgIconProps> = ({
  width = 12,
  height = 12,
  className,
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_935_2177)">
      <path
        d="M6 10.8C5.36965 10.8 4.74548 10.6758 4.16312 10.4346C3.58076 10.1934 3.05161 9.83983 2.60589 9.39411C2.16017 8.94839 1.8066 8.41924 1.56538 7.83688C1.32416 7.25452 1.2 6.63034 1.2 6C1.2 5.36965 1.32416 4.74548 1.56538 4.16312C1.8066 3.58076 2.16017 3.05161 2.60589 2.60589C3.05161 2.16017 3.58076 1.8066 4.16312 1.56538C4.74548 1.32416 5.36965 1.2 6 1.2C7.27304 1.2 8.49394 1.70571 9.39411 2.60589C10.2943 3.50606 10.8 4.72696 10.8 6C10.8 7.27304 10.2943 8.49394 9.39411 9.39411C8.49394 10.2943 7.27304 10.8 6 10.8ZM6 0C2.6862 0 0 2.6862 0 6C0 9.3138 2.6862 12 6 12C9.3138 12 12 9.3138 12 6C12 4.4087 11.3679 2.88258 10.2426 1.75736C9.11742 0.632141 7.5913 0 6 0ZM7.554 3.6L6 5.154L4.446 3.6L3.6 4.446L5.154 6L3.6 7.554L4.446 8.4L6 6.846L7.554 8.4L8.4 7.554L6.846 6L8.4 4.446L7.554 3.6Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_935_2177">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const InviteFriendsListExpiredIcon: React.FC<SvgIconProps> = ({
  width = 12,
  height = 12,
  className,
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_935_2154)">
      <path
        d="M6 0C9.3138 0 12 2.6862 12 6C12 9.3138 9.3138 12 6 12C2.6862 12 0 9.3138 0 6C0 2.6862 2.6862 0 6 0ZM6 1.2C3.3489 1.2 1.2 3.3489 1.2 6C1.2 8.6511 3.3489 10.8 6 10.8C8.6511 10.8 10.8 8.6511 10.8 6C10.8 3.3489 8.6511 1.2 6 1.2ZM6 2.7C6.0394 2.7 6.07841 2.70776 6.11481 2.72284C6.1512 2.73791 6.18427 2.76001 6.21213 2.78787C6.23999 2.81573 6.26209 2.8488 6.27716 2.88519C6.29224 2.92159 6.3 2.9606 6.3 3V6.3H8.7C8.7394 6.3 8.77841 6.30776 8.81481 6.32284C8.8512 6.33791 8.88427 6.36001 8.91213 6.38787C8.93999 6.41573 8.96209 6.4488 8.97716 6.48519C8.99224 6.52159 9 6.5606 9 6.6V7.2C9 7.2394 8.99224 7.27841 8.97716 7.31481C8.96209 7.3512 8.93999 7.38427 8.91213 7.41213C8.88427 7.43999 8.8512 7.46209 8.81481 7.47716C8.77841 7.49224 8.7394 7.5 8.7 7.5H5.4C5.3606 7.5 5.32159 7.49224 5.28519 7.47716C5.2488 7.46209 5.21572 7.43999 5.18787 7.41213C5.16001 7.38427 5.13791 7.3512 5.12284 7.31481C5.10776 7.27841 5.1 7.2394 5.1 7.2V3C5.1 2.9606 5.10776 2.92159 5.12284 2.88519C5.13791 2.8488 5.16001 2.81573 5.18787 2.78787C5.21572 2.76001 5.2488 2.73791 5.28519 2.72284C5.32159 2.70776 5.3606 2.7 5.4 2.7H6Z"
        fill="#FEB030"
      />
    </g>
    <defs>
      <clipPath id="clip0_935_2154">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const InviteFriendsListQualifiedIcon: React.FC<SvgIconProps> = ({
  width = 12,
  height = 12,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M6 12C2.68617 12 0 9.31383 0 6C0 2.68617 2.68617 0 6 0C9.31383 0 12 2.68617 12 6C12 9.31383 9.31383 12 6 12ZM6 10.9565C8.7373 10.9565 10.9565 8.7373 10.9565 6C10.9565 3.2627 8.7373 1.04348 6 1.04348C3.2627 1.04348 1.04348 3.2627 1.04348 6C1.04348 8.7373 3.2627 10.9565 6 10.9565ZM8.058 4.12226L8.82365 4.88817L5.63009 8.06035L3.54391 5.9713L4.29391 5.22157L5.61574 6.54548L8.058 4.12226Z"
      fill="#00FFCC"
    />
  </svg>
);

export const RechargeServiceIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  className,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    className={className}
    onClick={onClick}
  >
    <g clipPath="url(#clip0_1165_5059)">
      <path
        d="M10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0ZM10 2C14.4185 2 18 5.5815 18 10C18 14.4185 14.4185 18 10 18C5.5815 18 2 14.4185 2 10C2 5.5815 5.5815 2 10 2Z"
        fill="url(#paint0_linear_1165_5059)"
      />
      <path
        d="M9.98648 4C13.0006 4 15.0408 7.15158 13.4393 9.33697C13.176 9.69575 12.8927 9.99564 12.4956 10.3571L11.9225 10.8659C11.3015 11.4188 11.0948 11.7126 11.0738 12.102L11.0721 12.1718L11.0754 12.717L8.91702 12.7312L8.91378 12.1788C8.91378 11.0098 9.37459 10.2568 10.3626 9.34896L10.6459 9.09651L10.9157 8.85878C11.2912 8.52508 11.5189 8.29171 11.7045 8.03871C12.1594 7.41876 11.3581 6.18102 9.98648 6.18102C8.75946 6.18102 8.1999 6.72737 8.16051 7.4711L8.15836 7.5518V7.80534H6V7.54798C6.0054 5.58124 7.50275 4 9.98648 4ZM11.0759 13.8146V16H8.91756V13.8146H11.0759Z"
        fill="url(#paint1_linear_1165_5059)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1165_5059"
        x1="10.0433"
        y1="3.66667"
        x2="10.0433"
        y2="16.6667"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC628" />
        <stop offset="0.5" stopColor="#FFFBB0" />
        <stop offset="1" stopColor="#FFC628" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1165_5059"
        x1="10.0173"
        y1="6.2"
        x2="10.0173"
        y2="14"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC628" />
        <stop offset="0.5" stopColor="#FFFBB0" />
        <stop offset="1" stopColor="#FFC628" />
      </linearGradient>
      <clipPath id="clip0_1165_5059">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const RechargeBetClaimedIcon: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <g filter="url(#filter0_i_8455_5172)">
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
        fill="url(#paint0_linear_8455_5172)"
      />
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
        fill="url(#paint1_linear_8455_5172)"
      />
    </g>
    <path
      d="M6 12.974L9.93036 17L18 8.64036L16.4087 7L9.9102 13.6984L7.58627 11.3281L6 12.974Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_i_8455_5172"
        x="0"
        y="-2"
        width="24"
        height="26"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-2" />
        <feGaussianBlur stdDeviation="2.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
        />
        <feBlend
          mode="plus-lighter"
          in2="shape"
          result="effect1_innerShadow_8455_5172"
        />
      </filter>
      <linearGradient
        id="paint0_linear_8455_5172"
        x1="12"
        y1="0"
        x2="12"
        y2="24"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1374F4" />
        <stop offset="1" stopColor="#00FFFF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_8455_5172"
        x1="12"
        y1="0"
        x2="12"
        y2="24"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFFF05" />
        <stop offset="1" stopColor="#19E14B" />
      </linearGradient>
    </defs>
  </svg>
);

export const RechargeBetClockIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <circle cx="10" cy="10" r="10" fill="white" />
    <g filter="url(#filter0_i_8455_5118)">
      <circle cx="10" cy="10" r="9" fill="url(#paint0_linear_8455_5118)" />
    </g>
    <circle
      cx="10"
      cy="10"
      r="6"
      fill="white"
      fillOpacity="0.25"
      style={{ mixBlendMode: "plus-lighter" }}
    />
    <rect x="9" y="5" width="2" height="6" rx="1" fill="white" />
    <rect
      x="14.3301"
      y="11.5"
      width="2"
      height="5"
      rx="1"
      transform="rotate(120 14.3301 11.5)"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_i_8455_5118"
        x="1"
        y="-1"
        width="18"
        height="20"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-2" />
        <feGaussianBlur stdDeviation="2.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
        />
        <feBlend
          mode="plus-lighter"
          in2="shape"
          result="effect1_innerShadow_8455_5118"
        />
      </filter>
      <linearGradient
        id="paint0_linear_8455_5118"
        x1="10"
        y1="1"
        x2="10"
        y2="19"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DD4D00" />
        <stop offset="1" stopColor="#FFAE00" />
      </linearGradient>
    </defs>
  </svg>
);

export const RechargeBetHelpIcon: React.FC<
  SvgIconProps & { periodType?: string }
> = ({ width = 20, height = 20, className, periodType }) => {
  const uid =
    periodType === "WEEKLY"
      ? "weekly"
      : periodType === "MONTHLY"
        ? "monthly"
        : "default";

  const gradients: Record<string, { stop0: string; stop1: string }> = {
    default: { stop0: "#702C02", stop1: "#D66604" },
    weekly: { stop0: "#B8053E", stop1: "#FD3B79" },
    monthly: { stop0: "#4459FD", stop1: "#FF66DD" },
  };
  const { stop0, stop1 } = gradients[uid];
  const g0 = `rbi-g0-${uid}`;
  const g1 = `rbi-g1-${uid}`;
  const clip = `rbi-clip-${uid}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <g clipPath={`url(#${clip})`}>
        <path
          d="M10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0ZM10 2C14.4185 2 18 5.5815 18 10C18 14.4185 14.4185 18 10 18C5.5815 18 2 14.4185 2 10C2 5.5815 5.5815 2 10 2Z"
          fill={`url(#${g0})`}
        />
        <path
          d="M9.98648 4C13.0006 4 15.0408 7.15158 13.4393 9.33697C13.176 9.69575 12.8927 9.99564 12.4956 10.3571L11.9225 10.8659C11.3015 11.4188 11.0948 11.7126 11.0738 12.102L11.0721 12.1718L11.0754 12.717L8.91702 12.7312L8.91378 12.1788C8.91378 11.0098 9.37459 10.2568 10.3626 9.34896L10.6459 9.09651L10.9157 8.85878C11.2912 8.52508 11.5189 8.29171 11.7045 8.03871C12.1594 7.41876 11.3581 6.18102 9.98648 6.18102C8.75946 6.18102 8.1999 6.72737 8.16051 7.4711L8.15836 7.5518V7.80534H6V7.54798C6.0054 5.58124 7.50275 4 9.98648 4ZM11.0759 13.8146V16H8.91756V13.8146H11.0759Z"
          fill={`url(#${g1})`}
        />
      </g>
      <defs>
        <linearGradient
          id={g0}
          x1="10"
          y1="20"
          x2="10"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={stop0} />
          <stop offset="1" stopColor={stop1} />
        </linearGradient>
        <linearGradient
          id={g1}
          x1="10"
          y1="16"
          x2="10"
          y2="4"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={stop0} />
          <stop offset="1" stopColor={stop1} />
        </linearGradient>
        <clipPath id={clip}>
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RechargeClaimedIcon: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <g filter="url(#filter0_i_1169_5729)">
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
        fill="url(#paint0_linear_1169_5729)"
      />
    </g>
    <path
      d="M6 12.974L9.93036 17L18 8.64036L16.4087 7L9.9102 13.6984L7.58627 11.3281L6 12.974Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_i_1169_5729"
        x="0"
        y="-2"
        width="24"
        height="26"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-2" />
        <feGaussianBlur stdDeviation="2.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
        />
        <feBlend
          mode="lighten"
          in2="shape"
          result="effect1_innerShadow_1169_5729"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1169_5729"
        x1="12"
        y1="0"
        x2="12"
        y2="24"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1374F4" />
        <stop offset="1" stopColor="#00FFFF" />
      </linearGradient>
    </defs>
  </svg>
);

// Instagram 图标组件（兼容 react-share 的 size/borderRadius 参数）
export const InstagramIcon: React.FC<
  SvgIconProps & { size?: number; borderRadius?: number }
> = ({ width, height, size = 40, borderRadius = 10, className, onClick }) => {
  const iconSize = width || height || size;
  return (
    <svg
      viewBox="0 0 64 64"
      width={iconSize}
      height={iconSize}
      className={className}
      onClick={onClick}
      style={{ cursor: onClick ? "pointer" : "default", borderRadius }}
    >
      <defs>
        <linearGradient
          id="instagram-gradient"
          x1="0%"
          y1="100%"
          x2="100%"
          y2="0%"
        >
          <stop offset="0%" stopColor="#FFDC80" />
          <stop offset="25%" stopColor="#F77737" />
          <stop offset="50%" stopColor="#E1306C" />
          <stop offset="75%" stopColor="#C13584" />
          <stop offset="100%" stopColor="#833AB4" />
        </linearGradient>
      </defs>
      <rect
        width="64"
        height="64"
        rx={borderRadius}
        fill="url(#instagram-gradient)"
      />
      <g fill="white">
        <path d="M32 20.5c-3.7 0-4.2 0-5.6.1-1.5.1-2.5.3-3.4.6-.9.4-1.7.9-2.5 1.7-.8.8-1.3 1.6-1.7 2.5-.3.9-.5 1.9-.6 3.4-.1 1.5-.1 1.9-.1 5.6s0 4.2.1 5.6c.1 1.5.3 2.5.6 3.4.4.9.9 1.7 1.7 2.5.8.8 1.6 1.3 2.5 1.7.9.3 1.9.5 3.4.6 1.5.1 1.9.1 5.6.1s4.2 0 5.6-.1c1.5-.1 2.5-.3 3.4-.6.9-.4 1.7-.9 2.5-1.7.8-.8 1.3-1.6 1.7-2.5.3-.9.5-1.9.6-3.4.1-1.5.1-1.9.1-5.6s0-4.2-.1-5.6c-.1-1.5-.3-2.5-.6-3.4-.4-.9-.9-1.7-1.7-2.5-.8-.8-1.6-1.3-2.5-1.7-.9-.3-1.9-.5-3.4-.6-1.4-.1-1.9-.1-5.6-.1zm0 2.1c3.6 0 4.1 0 5.5.1 1.3.1 2 .2 2.5.4.6.2 1.1.5 1.5 1 .5.5.8.9 1 1.5.2.5.4 1.2.4 2.5.1 1.4.1 1.9.1 5.5s0 4.1-.1 5.5c-.1 1.3-.2 2-.4 2.5-.2.6-.5 1.1-1 1.5-.5.5-.9.8-1.5 1-.5.2-1.2.4-2.5.4-1.4.1-1.9.1-5.5.1s-4.1 0-5.5-.1c-1.3-.1-2-.2-2.5-.4-.6-.2-1.1-.5-1.5-1-.5-.5-.8-.9-1-1.5-.2-.5-.4-1.2-.4-2.5-.1-1.4-.1-1.9-.1-5.5s0-4.1.1-5.5c.1-1.3.2-2 .4-2.5.2-.6.5-1.1 1-1.5.5-.5.9-.8 1.5-1 .5-.2 1.2-.4 2.5-.4 1.4-.1 1.9-.1 5.5-.1z" />
        <path d="M32 26.3a5.7 5.7 0 100 11.4 5.7 5.7 0 000-11.4zm0 9.4a3.7 3.7 0 110-7.4 3.7 3.7 0 010 7.4z" />
        <circle cx="38" cy="26" r="1.3" />
      </g>
    </svg>
  );
};

// 分页左侧按钮图标
export const PaginationLeftIcon: React.FC<
  SvgIconProps & { disabled?: boolean }
> = ({ width = 20, height = 20, className, onClick, disabled = false }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick && !disabled ? onClick : undefined}
    style={{
      cursor: onClick && !disabled ? "pointer" : "default",
      opacity: disabled ? 0.5 : 1,
    }}
  >
    <defs>
      <linearGradient
        id="pagination_left_bg"
        x1="10"
        y1="0"
        x2="10"
        y2="20"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0%" stopColor="#F2F7FF" />
        <stop offset="100%" stopColor="#FFFFFF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_pagination_left"
        x1="10.0003"
        y1="5.00134"
        x2="10.0003"
        y2="15.002"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C7D8EF" />
        <stop offset="0.490385" stopColor="#98AEC9" />
        <stop offset="1" stopColor="#9DB7D1" />
      </linearGradient>
    </defs>
    <rect
      x="0.5"
      y="0.5"
      width="19"
      height="19"
      rx="3.5"
      fill="url(#pagination_left_bg)"
      stroke="white"
    />
    <path
      d="M11.5747 5.23767C11.9008 4.92208 12.4293 4.92203 12.7554 5.23767C13.0814 5.55326 13.0812 6.06457 12.7554 6.38025L9.01514 10.0004L12.7554 13.6215C13.0815 13.9371 13.0815 14.4494 12.7554 14.765C12.4293 15.0805 11.9007 15.0806 11.5747 14.765L7.24463 10.5736C7.12251 10.4553 7.04672 10.3093 7.01611 10.1566C6.96447 9.90138 7.04036 9.62681 7.24463 9.42908L11.5747 5.23767Z"
      fill="url(#paint1_linear_pagination_left)"
      fillOpacity={disabled ? "0.4" : "1"}
    />
  </svg>
);

// 分页右侧按钮图标
export const PaginationRightIcon: React.FC<
  SvgIconProps & { disabled?: boolean }
> = ({ width = 20, height = 20, className, onClick, disabled = false }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick && !disabled ? onClick : undefined}
    style={{
      cursor: onClick && !disabled ? "pointer" : "default",
      opacity: disabled ? 0.5 : 1,
    }}
  >
    <defs>
      <linearGradient
        id="pagination_right_bg"
        x1="10"
        y1="0"
        x2="10"
        y2="20"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0%" stopColor="#F2F7FF" />
        <stop offset="100%" stopColor="#FFFFFF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_pagination_right"
        x1="10.0005"
        y1="5.00195"
        x2="10.0005"
        y2="15.0026"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C7D8EF" />
        <stop offset="0.490385" stopColor="#98AEC9" />
        <stop offset="1" stopColor="#9DB7D1" />
      </linearGradient>
    </defs>
    <rect
      x="0.5"
      y="0.5"
      width="19"
      height="19"
      rx="3.5"
      fill="url(#pagination_right_bg)"
      stroke="white"
    />
    <path
      d="M8.42578 5.23926C8.09969 4.92359 7.57121 4.92359 7.24512 5.23926C6.91903 5.55492 6.91903 6.06617 7.24512 6.38184L10.9854 10.002L7.24414 13.623C6.9182 13.9387 6.9181 14.451 7.24414 14.7666C7.57024 15.0822 8.0997 15.0822 8.42578 14.7666L12.7549 10.5752C12.9789 10.3583 13.0497 10.0483 12.9658 9.77344C12.9278 9.648 12.858 9.52966 12.7559 9.43066L8.42578 5.23926Z"
      fill="url(#paint1_linear_pagination_right)"
      fillOpacity={disabled ? "0.4" : "1"}
    />
  </svg>
);

export const VipCarouselArrowLeftIcon: React.FC<SvgIconProps> = ({
  width = 80,
  height = 80,
  className,
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        id="arrowGradientLeft"
        x1="0%"
        y1="0%"
        x2="100%"
        y2="100%"
      >
        <stop offset="0%" stopColor="#FFD700" />
        <stop offset="50%" stopColor="#FFA500" />
        <stop offset="100%" stopColor="#FF8C00" />
      </linearGradient>
      <linearGradient id="shineLeft" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="rgba(255,255,255,0)" />
        <stop offset="50%" stopColor="rgba(255,255,255,0.8)" />
        <stop offset="100%" stopColor="rgba(255,255,255,0)" />
      </linearGradient>
    </defs>
    {/* 主箭头 */}
    <path
      d="M50 15 L20 40 L50 65 L50 52 L33 40 L50 28 Z"
      fill="url(#arrowGradientLeft)"
    />
  </svg>
);

export const VipCarouselArrowRightIcon: React.FC<SvgIconProps> = ({
  width = 80,
  height = 80,
  className,
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        id="arrowGradientRight"
        x1="0%"
        y1="0%"
        x2="100%"
        y2="100%"
      >
        <stop offset="0%" stopColor="#FFD700" />
        <stop offset="50%" stopColor="#FFA500" />
        <stop offset="100%" stopColor="#FF8C00" />
      </linearGradient>
      <linearGradient id="shineRight" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="rgba(255,255,255,0)" />
        <stop offset="50%" stopColor="rgba(255,255,255,0.8)" />
        <stop offset="100%" stopColor="rgba(255,255,255,0)" />
      </linearGradient>
    </defs>
    {/* 主箭头 */}
    <path
      d="M30 15 L60 40 L30 65 L30 52 L47 40 L30 28 Z"
      fill="url(#arrowGradientRight)"
    />
  </svg>
);

export const LanguageIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  className,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-80 -80 1184 1184"
    fill="none"
    width={width}
    height={height}
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <path
      d="M185.6 0h731.733333c58.909867 0 106.666667 47.7568 106.666667 106.666667v601.6c0 17.6736-14.3264 32-32 32-17.6736 0-32-14.3264-32-32V117.333333c0-29.454933-23.8784-53.333333-53.333333-53.333333H185.6c-17.6736 0-32-14.3264-32-32 0-17.6736 14.3264-32 32-32z m263.8208 397.453867l-50.837333 139.6736h101.674666l-50.837333-139.6736z m32.010667-99.175467l150.938666 414.7008c6.0448 16.608-2.517333 34.970667-19.125333 41.015467-16.608 6.0448-34.9696-2.5184-41.0144-19.125334L523.552 601.127467H375.290667L326.612267 734.869333c-6.0448 16.606933-24.407467 25.170133-41.0144 19.125334-16.608-6.0448-25.170133-24.407467-19.125334-41.015467l150.938667-414.7008c1.666133-11.245867 9.2864-21.2448 20.72-25.406933a31.9296 31.9296 0 0 1 11.2896-1.936c3.746133-0.0416 7.562667 0.5792 11.290667 1.936 11.4336 4.162133 19.053867 14.161067 20.72 25.406933zM613.079467 896l62.605866-64H778.666667c29.454933 0 53.333333-23.8784 53.333333-53.333333V245.333333c0-29.454933-23.8784-53.333333-53.333333-53.333333H117.333333c-29.454933 0-53.333333 23.8784-53.333333 53.333333v533.333334c0 29.454933 23.8784 53.333333 53.333333 53.333333h342.357334l63.136 64H106.666667C47.7568 896 0 848.2432 0 789.333333V234.666667c0-58.909867 47.7568-106.666667 106.666667-106.666667h682.666666c58.909867 0 106.666667 47.7568 106.666667 106.666667v554.666666c0 58.909867-47.7568 106.666667-106.666667 106.666667H613.079467z m90.449066 0l-98.0512 98.052267c-20.8288 20.827733-54.597333 20.827733-75.425066 0L432 896h271.528533z m-90.352 0H522.666667l26.398933 26.398933c10.413867 10.413867 27.298133 10.413867 37.712 0L613.176533 896z"
      fill="url(#paint0_linear_language)"
      stroke="url(#paint0_linear_language)"
      strokeWidth="18"
    />
    <path
      d="M185.6 0h731.733333c58.909867 0 106.666667 47.7568 106.666667 106.666667v601.6c0 17.6736-14.3264 32-32 32-17.6736 0-32-14.3264-32-32V117.333333c0-29.454933-23.8784-53.333333-53.333333-53.333333H185.6c-17.6736 0-32-14.3264-32-32 0-17.6736 14.3264-32 32-32z m263.8208 397.453867l-50.837333 139.6736h101.674666l-50.837333-139.6736z m32.010667-99.175467l150.938666 414.7008c6.0448 16.608-2.517333 34.970667-19.125333 41.015467-16.608 6.0448-34.9696-2.5184-41.0144-19.125334L523.552 601.127467H375.290667L326.612267 734.869333c-6.0448 16.606933-24.407467 25.170133-41.0144 19.125334-16.608-6.0448-25.170133-24.407467-19.125334-41.015467l150.938667-414.7008c1.666133-11.245867 9.2864-21.2448 20.72-25.406933a31.9296 31.9296 0 0 1 11.2896-1.936c3.746133-0.0416 7.562667 0.5792 11.290667 1.936 11.4336 4.162133 19.053867 14.161067 20.72 25.406933zM613.079467 896l62.605866-64H778.666667c29.454933 0 53.333333-23.8784 53.333333-53.333333V245.333333c0-29.454933-23.8784-53.333333-53.333333-53.333333H117.333333c-29.454933 0-53.333333 23.8784-53.333333 53.333333v533.333334c0 29.454933 23.8784 53.333333 53.333333 53.333333h342.357334l63.136 64H106.666667C47.7568 896 0 848.2432 0 789.333333V234.666667c0-58.909867 47.7568-106.666667 106.666667-106.666667h682.666666c58.909867 0 106.666667 47.7568 106.666667 106.666667v554.666666c0 58.909867-47.7568 106.666667-106.666667 106.666667H613.079467z m90.449066 0l-98.0512 98.052267c-20.8288 20.827733-54.597333 20.827733-75.425066 0L432 896h271.528533z m-90.352 0H522.666667l26.398933 26.398933c10.413867 10.413867 27.298133 10.413867 37.712 0L613.176533 896z"
      fill="url(#paint1_linear_language)"
      stroke="url(#paint1_linear_language)"
      strokeWidth="18"
    />
    <defs>
      <linearGradient
        id="paint0_linear_language"
        x1="512"
        y1="994"
        x2="512"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-header-start, currentColor)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-header-end, currentColor)" }}
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_language"
        x1="512"
        y1="0"
        x2="512"
        y2="994"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-start, currentColor)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-end, currentColor)" }}
        />
      </linearGradient>
    </defs>
  </svg>
);

// 地球图标（国家/地区选择）
export const GlobeIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  className,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    width={width}
    height={height}
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <circle
      cx="10"
      cy="10"
      r="8"
      stroke="url(#paint0_linear_globe)"
      strokeWidth="0.9"
      fill="none"
    />
    <circle
      cx="10"
      cy="10"
      r="8"
      stroke="url(#paint1_linear_globe)"
      strokeWidth="0.9"
      fill="none"
    />
    <ellipse
      cx="10"
      cy="10"
      rx="4.2"
      ry="8"
      stroke="url(#paint1_linear_globe)"
      strokeWidth="0.8"
      fill="none"
    />
    <line
      x1="2.5"
      y1="7.2"
      x2="17.5"
      y2="7.2"
      stroke="url(#paint1_linear_globe)"
      strokeWidth="0.7"
    />
    <line
      x1="2.5"
      y1="12.8"
      x2="17.5"
      y2="12.8"
      stroke="url(#paint1_linear_globe)"
      strokeWidth="0.7"
    />
    <defs>
      <linearGradient
        id="paint0_linear_globe"
        x1="10"
        y1="18"
        x2="10"
        y2="2"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-header-start, currentColor)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-header-end, currentColor)" }}
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_globe"
        x1="10"
        y1="2"
        x2="10"
        y2="18"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-start, currentColor)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-end, currentColor)" }}
        />
      </linearGradient>
    </defs>
  </svg>
);

export const BettingLimitIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  className,
}) => (
  <svg width={width} height={height} className={className} viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="betting_limit_grad" x1="28" y1="2" x2="28" y2="53" gradientUnits="userSpaceOnUse">
        <stop style={{ stopColor: "var(--color-icon-start, #FFF1B2)" }} />
        <stop offset="1" style={{ stopColor: "var(--color-icon-end, #FFF1B2)" }} />
      </linearGradient>
    </defs>
    <path d="M10 30 C11.6569 30 13 31.3431 13 33 V50 C13 51.6569 11.6569 53 10 53 H8 C6.3431 53 5 51.6569 5 50 V33 C5 31.3431 6.3431 30 8 30 H10ZM23 37 C24.6569 37 26 38.3431 26 40 V50 C26 51.6569 24.6569 53 23 53 H21 C19.3431 53 18 51.6569 18 50 V40 C18 38.3431 19.3431 37 21 37 H23ZM36 37 C37.6569 37 39 38.3431 39 40 V50 C39 51.6569 37.6569 53 36 53 H34 C32.3431 53 31 51.6569 31 50 V40 C31 38.3431 32.3431 37 34 37 H36ZM49 30 C50.6569 30 52 31.3431 52 33 V50 C52 51.6569 50.6569 53 49 53 H47 C45.3431 53 44 51.6569 44 50 V33 C44 31.3431 45.3431 30 47 30 H49ZM27.999 2.5C37.1117 2.5 44.499 9.8873 44.499 19C44.499 28.1127 37.1117 35.5 27.999 35.5C18.8863 35.5 11.499 28.1127 11.499 19C11.499 9.8873 18.8863 2.5 27.999 2.5ZM27.999 5.5C20.5432 5.5 14.499 11.5442 14.499 19C14.499 26.4558 20.5432 32.5 27.999 32.5C35.4549 32.5 41.499 26.4558 41.499 19C41.499 11.5442 35.4549 5.5 27.999 5.5ZM28.3506 8.5C28.6267 8.5 28.8505 8.72394 28.8506 9V10.3652C29.7257 10.4423 30.5324 10.6249 31.2666 10.9199C32.2603 11.3193 33.0712 11.8798 33.6777 12.6104C34.2988 13.3454 34.6374 14.1949 34.6807 15.1426C34.6868 15.2788 34.6372 15.4121 34.543 15.5107C34.4486 15.6095 34.3172 15.665 34.1807 15.665H32.46C32.2065 15.665 31.9925 15.4754 31.9629 15.2236C31.8744 14.473 31.4911 13.8717 30.7549 13.4033C30.2307 13.0699 29.5991 12.8475 28.8506 12.7422V18.1318L29.2773 18.2354H29.2764C29.9163 18.3843 30.5554 18.574 31.1934 18.8047C31.8497 19.0421 32.4537 19.3438 33.0029 19.71H33.002C33.5745 20.082 34.0402 20.5443 34.3906 21.0977L34.5234 21.3203C34.8112 21.8516 34.9472 22.4602 34.9473 23.1289C34.9472 24.1175 34.6406 25.0142 34.0352 25.8018C33.4312 26.5872 32.5786 27.1912 31.5078 27.6289L31.5059 27.6299C30.7206 27.9467 29.8333 28.1411 28.8506 28.2256V29.5508C28.8504 29.8268 28.6266 30.0508 28.3506 30.0508H27.1055C26.8295 30.0508 26.6056 29.8268 26.6055 29.5508V28.2314C25.6733 28.1549 24.8251 27.9777 24.0654 27.6904L24.0635 27.6895C23.0252 27.2911 22.1822 26.7307 21.5596 25.9961C20.9335 25.2575 20.5791 24.396 20.501 23.4258C20.4898 23.2867 20.5372 23.1484 20.6318 23.0459C20.7265 22.9436 20.8596 22.8858 20.999 22.8857H22.8252L22.9189 22.8945C23.1329 22.9353 23.3002 23.1129 23.3223 23.3369C23.3749 23.8738 23.581 24.3145 23.9414 24.6797C24.3204 25.0635 24.8257 25.3688 25.4746 25.584H25.4736C25.8253 25.6978 26.2026 25.7796 26.6055 25.833V20.0762L26.2051 19.9775L26.2031 19.9766C24.6345 19.581 23.3731 19.0249 22.4541 18.2842C21.4969 17.5127 21.003 16.504 21.0029 15.2939C21.003 14.2958 21.3221 13.4056 21.9561 12.6455L21.957 12.6445C22.5835 11.8962 23.4178 11.3267 24.4395 10.9268L24.8311 10.7842C25.3911 10.5967 25.9832 10.4688 26.6055 10.3955V9C26.6056 8.72396 26.8294 8.50002 27.1055 8.5H28.3506ZM28.8506 25.8262C29.3064 25.7632 29.726 25.6633 30.1104 25.5244L30.3643 25.4248C30.9378 25.1817 31.3747 24.8727 31.6934 24.5088L31.6943 24.5078C32.0519 24.1008 32.2256 23.6401 32.2256 23.1045C32.2255 22.6599 32.0933 22.3181 31.8438 22.0449L31.8408 22.042C31.5606 21.7312 31.1502 21.4504 30.584 21.2139L30.582 21.2129C30.0817 21.0018 29.5047 20.8108 28.8506 20.6377V25.8262ZM26.6055 12.7646C26.242 12.8252 25.9068 12.9138 25.5996 13.0303C24.9785 13.2682 24.515 13.588 24.1865 13.9766L24.1875 13.9775C23.8747 14.3497 23.7246 14.7613 23.7246 15.2295C23.7246 15.5727 23.8109 15.8526 23.9707 16.0879C24.1487 16.3497 24.3932 16.5836 24.7139 16.7861C25.0631 16.997 25.4507 17.1807 25.8779 17.3359H25.877C26.1189 17.4226 26.362 17.5008 26.6055 17.5723V12.7646Z" fill="url(#betting_limit_grad)"/>
  </svg>
);

// 加载旋转图标
export const SpinnerIcon: React.FC<SvgIconProps> = ({
  width = 40,
  height = 40,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    className={className}
  >
    <path
      d="M20.0014 1C20.5309 1.00173 21.038 1.16987 21.4122 1.46773C21.7864 1.76559 21.9972 2.16901 21.9986 2.58996V7.35112C22.0086 7.56473 21.9643 7.77774 21.8683 7.97743C21.7724 8.17711 21.6268 8.35936 21.4402 8.51328C21.2536 8.66721 21.0299 8.78964 20.7825 8.87327C20.535 8.9569 20.2689 9 20 9C19.7311 9 19.465 8.9569 19.2175 8.87327C18.9701 8.78964 18.7464 8.66721 18.5598 8.51328C18.3732 8.35936 18.2276 8.17711 18.1317 7.97743C18.0357 7.77774 17.9914 7.56473 18.0014 7.35112V2.59215C18.0014 1.71199 18.897 1 20.0014 1Z"
      fill="#999999"
    />
    <path
      d="M29.9996 3.26397C30.4588 3.52328 30.794 3.95046 30.9315 4.4516C31.0691 4.95273 30.9977 5.48681 30.733 5.93643L27.7361 11.0152C27.5611 11.3138 27.3089 11.562 27.0048 11.7349C26.7007 11.9077 26.3554 11.9992 26.0038 12C25.6521 12.0008 25.3064 11.911 25.0015 11.7395C24.6965 11.568 24.4431 11.321 24.2667 11.0232C24.0906 10.7246 23.9986 10.3856 24 10.0408C24.0015 9.69603 24.0963 9.35778 24.2749 9.06058L27.2691 3.97914C27.4 3.75628 27.5746 3.56093 27.7828 3.40428C27.991 3.24764 28.2288 3.1328 28.4825 3.06635C28.7362 2.9999 29.0009 2.98315 29.2612 3.01706C29.5215 3.05098 29.7725 3.13489 29.9996 3.26397Z"
      fill="#999999"
      fillOpacity="0.12"
    />
    <path
      d="M36.7348 10.008C36.8649 10.2374 36.9492 10.4906 36.9831 10.7532C37.017 11.0158 36.9998 11.2827 36.9324 11.5385C36.865 11.7943 36.7487 12.0341 36.5903 12.244C36.4319 12.454 36.2345 12.6301 36.0092 12.7621L30.8728 15.7822C30.4214 16.0154 29.8995 16.0634 29.4145 15.9163C28.9295 15.7693 28.5182 15.4383 28.2651 14.9916C28.0121 14.5448 27.9366 14.0162 28.0541 13.5144C28.1716 13.0127 28.4733 12.5759 28.897 12.2939L34.0335 9.27102C34.2582 9.13835 34.5065 9.05218 34.764 9.01743C35.0215 8.98267 35.2831 9.00002 35.534 9.06847C35.785 9.13692 36.0202 9.25514 36.2262 9.41636C36.4323 9.57758 36.6051 9.77864 36.7348 10.008Z"
      fill="#999999"
      fillOpacity="0.2"
    />
    <path
      d="M39 19.9986C39.0003 20.2613 38.9591 20.5215 38.8789 20.7643C38.7987 21.0071 38.681 21.2278 38.5325 21.4136C38.384 21.5995 38.2076 21.747 38.0135 21.8476C37.8193 21.9482 37.6113 22 37.4011 22H32.6C32.1757 22 31.7687 21.7893 31.4686 21.4142C31.1686 21.0391 31 20.5304 31 20C31 19.4696 31.1686 18.9609 31.4686 18.5858C31.7687 18.2107 32.1757 18 32.6 18H37.3989C37.8224 18.0022 38.2281 18.2134 38.5276 18.5878C38.827 18.9621 38.9961 19.4692 38.9978 19.9986"
      fill="#999999"
      fillOpacity="0.28"
    />
    <path
      d="M36.7393 30.0037C36.6119 30.2301 36.4422 30.4285 36.2398 30.5878C36.0374 30.747 35.8064 30.8639 35.5599 30.9318C35.3133 30.9996 35.0562 31.0171 34.8031 30.9832C34.5499 30.9493 34.3058 30.8647 34.0847 30.7342L29.0292 27.749C28.799 27.6231 28.5958 27.4511 28.4319 27.2432C28.2679 27.0353 28.1465 26.7958 28.0748 26.5389C28.0031 26.282 27.9827 26.013 28.0147 25.7478C28.0467 25.4826 28.1305 25.2268 28.2611 24.9954C28.3917 24.7641 28.5664 24.562 28.7748 24.4012C28.9833 24.2404 29.2212 24.1242 29.4745 24.0594C29.7278 23.9946 29.9912 23.9827 30.249 24.0243C30.5069 24.0658 30.7539 24.1601 30.9755 24.3013L36.0255 27.2866C36.247 27.4167 36.4412 27.5903 36.597 27.7974C36.7528 28.0045 36.8671 28.2411 36.9334 28.4935C36.9997 28.7459 37.0167 29.0092 36.9834 29.2684C36.9501 29.5275 36.8672 29.7774 36.7393 30.0037Z"
      fill="#999999"
      fillOpacity="0.36"
    />
    <path
      d="M29.9936 36.7356C29.7648 36.8653 29.5122 36.9494 29.2502 36.9832C28.9882 37.017 28.7219 36.9997 28.4668 36.9325C28.2116 36.8652 27.9724 36.7493 27.763 36.5913C27.5537 36.4333 27.3781 36.2363 27.2466 36.0117L24.2285 30.8871C23.9882 30.4358 23.9351 29.911 24.0803 29.4222C24.2254 28.9335 24.5576 28.5186 25.0074 28.2642C25.4573 28.0098 25.99 27.9356 26.4943 28.057C26.9987 28.1784 27.4357 28.4861 27.7141 28.9159L30.7294 34.0405C30.8619 34.2647 30.9479 34.5124 30.9826 34.7693C31.0173 35.0262 31 35.2873 30.9316 35.5376C30.8633 35.7879 30.7453 36.0226 30.5843 36.2282C30.4233 36.4337 30.2226 36.6062 29.9936 36.7356Z"
      fill="#999999"
      fillOpacity="0.44"
    />
    <path
      d="M20.0014 39C19.7387 39.0003 19.4785 38.9591 19.2357 38.8789C18.9929 38.7986 18.7722 38.6809 18.5864 38.5323C18.4005 38.3838 18.253 38.2074 18.1524 38.0132C18.0518 37.819 18 37.6109 18 37.4007V32.6004C18 32.176 18.2107 31.7689 18.5858 31.4688C18.9609 31.1686 19.4696 31 20 31C20.5304 31 21.0391 31.1686 21.4142 31.4688C21.7893 31.7689 22 32.176 22 32.6004V37.4007C21.9978 37.8243 21.7866 38.2301 21.4122 38.5296C21.0379 38.8292 20.5308 38.9983 20.0014 39Z"
      fill="#999999"
      fillOpacity="0.52"
    />
    <path
      d="M9.99459 36.7392C9.53768 36.4814 9.2043 36.0569 9.06777 35.5591C8.93124 35.0613 9.00274 34.5309 9.26654 34.0845L12.2499 29.0292C12.3758 28.799 12.5479 28.5958 12.7558 28.4319C12.9638 28.2679 13.2034 28.1465 13.4604 28.0748C13.7173 28.0031 13.9865 27.9827 14.2517 28.0147C14.5169 28.0467 14.7729 28.1305 15.0043 28.2611C15.2357 28.3916 15.4378 28.5664 15.5987 28.7748C15.7595 28.9833 15.8758 29.2212 15.9406 29.4745C16.0054 29.7277 16.0173 29.9911 15.9757 30.249C15.9342 30.5068 15.8399 30.7539 15.6986 30.9754L12.7152 36.0254C12.5848 36.2469 12.4108 36.4412 12.2034 36.597C11.996 36.7528 11.7592 36.8672 11.5065 36.9335C11.2538 36.9998 10.9902 37.0167 10.7307 36.9834C10.4713 36.9501 10.2211 36.8671 9.99459 36.7392Z"
      fill="#999999"
      fillOpacity="0.6"
    />
    <path
      d="M3.2651 29.9937C3.13531 29.7651 3.05101 29.5126 3.01702 29.2507C2.98304 28.9888 3.00004 28.7226 3.06706 28.4675C3.13407 28.2123 3.24977 27.9731 3.40755 27.7636C3.56532 27.5541 3.76206 27.3784 3.9865 27.2466L9.11227 24.2285C9.56366 23.9882 10.0886 23.9351 10.5775 24.0803C11.0663 24.2254 11.4813 24.5576 11.7358 25.0075C11.9902 25.4573 12.0645 25.99 11.943 26.4944C11.8215 26.9988 11.5138 27.4358 11.0839 27.7141L5.95816 30.7323C5.50486 30.998 4.96678 31.0694 4.46192 30.9309C3.95707 30.7924 3.52666 30.4554 3.2651 29.9937Z"
      fill="#999999"
      fillOpacity="0.68"
    />
    <path
      d="M1 19.9986C1 18.897 1.71199 18.0014 2.58996 18.0014H7.35112C7.56473 17.9914 7.77774 18.0357 7.97743 18.1317C8.17711 18.2276 8.35936 18.3732 8.51328 18.5598C8.66721 18.7464 8.78964 18.9701 8.87327 19.2175C8.9569 19.465 9 19.7311 9 20C9 20.2689 8.9569 20.535 8.87327 20.7825C8.78964 21.0299 8.66721 21.2536 8.51328 21.4402C8.35936 21.6267 8.17711 21.7724 7.97743 21.8683C7.77774 21.9643 7.56473 22.0086 7.35112 21.9986H2.59215C2.17062 21.9972 1.76664 21.7861 1.46837 21.4114C1.1701 21.0367 1.00173 20.5289 1 19.9986Z"
      fill="#999999"
      fillOpacity="0.76"
    />
    <path
      d="M3.26206 9.99859C3.52188 9.53974 3.94934 9.20503 4.45055 9.06799C4.95176 8.93096 5.48571 9.0028 5.93511 9.26775L11.015 12.2653C11.3136 12.4403 11.5619 12.6926 11.7348 12.9968C11.9077 13.3009 11.9992 13.6463 12 13.998C12.0008 14.3498 11.911 14.6955 11.7395 15.0005C11.568 15.3055 11.3209 15.559 11.023 15.7355C10.7239 15.9106 10.3848 16.0019 10.04 16C9.69527 15.998 9.35714 15.903 9.05993 15.7245L3.97738 12.7297C3.52828 12.4642 3.20068 12.0275 3.06655 11.5154C2.93242 11.0033 3.00274 10.4577 3.26206 9.99859Z"
      fill="#999999"
      fillOpacity="0.84"
    />
    <path
      d="M10.0035 3.26431C10.4661 3.00277 11.0156 2.93184 11.5314 3.06712C12.0473 3.2024 12.4872 3.53282 12.7546 3.98578L15.7714 9.11201C16.0118 9.56344 16.0649 10.0884 15.9197 10.5773C15.7745 11.0662 15.4421 11.4812 14.9921 11.7357C14.542 11.9902 14.009 12.0645 13.5044 11.943C12.9998 11.8215 12.5626 11.5137 12.2841 11.0838L9.26732 5.95762C9.00219 5.50485 8.93079 4.96762 9.06876 4.46341C9.20672 3.9592 9.54281 3.52905 10.0035 3.26703"
      fill="#999999"
      fillOpacity="0.92"
    />
  </svg>
);

export const InfoGoldIcon: React.FC<SvgIconProps> = ({
  width = 12,
  height = 12,
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <g clipPath="url(#infoGoldClip)">
      <path
        d="M6 12C2.7 12 0 9.3 0 6C0 2.7 2.7 0 6 0C9.3 0 12 2.7 12 6C12 9.3 9.3 12 6 12ZM6 10.5C8.475 10.5 10.5 8.475 10.5 6C10.5 3.525 8.475 1.5 6 1.5C3.525 1.5 1.5 3.525 1.5 6C1.5 8.475 3.525 10.5 6 10.5ZM6.75 7.5V9H5.25V7.5H6.75ZM6.75 3V6.75H5.25V3H6.75Z"
        fill="#FFF1B2"
      />
      <path
        d="M6 12C2.7 12 0 9.3 0 6C0 2.7 2.7 0 6 0C9.3 0 12 2.7 12 6C12 9.3 9.3 12 6 12ZM6 10.5C8.475 10.5 10.5 8.475 10.5 6C10.5 3.525 8.475 1.5 6 1.5C3.525 1.5 1.5 3.525 1.5 6C1.5 8.475 3.525 10.5 6 10.5ZM6.75 7.5V9H5.25V7.5H6.75ZM6.75 3V6.75H5.25V3H6.75Z"
        fill="url(#infoGoldGrad)"
      />
    </g>
    <defs>
      <linearGradient
        id="infoGoldGrad"
        x1="6"
        y1="2.1"
        x2="6"
        y2="9.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF9C7" />
        <stop offset="1" stopColor="#FFDE71" />
      </linearGradient>
      <clipPath id="infoGoldClip">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const OrderVerifyIcon: React.FC<SvgIconProps> = ({
  width = 12,
  height = 12,
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <path
      d="M1.2 11C0.87 11 0.5875 10.8912 0.3525 10.6736C0.1175 10.456 0 10.1944 0 9.88889V2.11111C0 1.80556 0.1175 1.54398 0.3525 1.32639C0.5875 1.1088 0.87 1 1.2 1H10.8C11.13 1 11.4125 1.1088 11.6475 1.32639C11.8825 1.54398 12 1.80556 12 2.11111V9.88889C12 10.1944 11.8825 10.456 11.6475 10.6736C11.4125 10.8912 11.13 11 10.8 11H1.2ZM1.2 9.88889H10.8V2.11111H1.2V9.88889ZM1.8 8.77778H4.8V7.66667H1.8V8.77778ZM7.53 7.66667L10.5 4.91667L9.645 4.125L7.53 6.09722L6.675 5.30556L5.835 6.09722L7.53 7.66667ZM1.8 6.55556H4.8V5.44444H1.8V6.55556ZM1.8 4.33333H4.8V3.22222H1.8V4.33333ZM1.2 9.88889V2.11111V9.88889Z"
      fill="var(--color-brand-primary)"
    />
    <defs>
      <linearGradient
        id="paint_orderVerify"
        x1="6.17143"
        y1="11.4762"
        x2="6.17143"
        y2="1"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBF3B4" />
        <stop offset="1" stopColor="#FFC871" />
      </linearGradient>
    </defs>
  </svg>
);

// 帮助/问号圆圈图标
export const HelpCircleIcon: React.FC<SvgIconProps> = ({
  width = 12,
  height = 12,
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <path
      d="M5.97 9.6C6.18 9.6 6.3575 9.5275 6.5025 9.3825C6.6475 9.2375 6.72 9.06 6.72 8.85C6.72 8.64 6.6475 8.4625 6.5025 8.3175C6.3575 8.1725 6.18 8.1 5.97 8.1C5.76 8.1 5.5825 8.1725 5.4375 8.3175C5.2925 8.4625 5.22 8.64 5.22 8.85C5.22 9.06 5.2925 9.2375 5.4375 9.3825C5.5825 9.5275 5.76 9.6 5.97 9.6ZM5.43 7.29H6.54C6.54 6.96 6.5775 6.7 6.6525 6.51C6.7275 6.32 6.94 6.06 7.29 5.73C7.55 5.47 7.755 5.2225 7.905 4.9875C8.055 4.7525 8.13 4.47 8.13 4.14C8.13 3.58 7.925 3.15 7.515 2.85C7.105 2.55 6.62 2.4 6.06 2.4C5.49 2.4 5.0275 2.55 4.6725 2.85C4.3175 3.15 4.07 3.51 3.93 3.93L4.92 4.32C4.97 4.14 5.0825 3.945 5.2575 3.735C5.4325 3.525 5.7 3.42 6.06 3.42C6.38 3.42 6.62 3.5075 6.78 3.6825C6.94 3.8575 7.02 4.05 7.02 4.26C7.02 4.46 6.96 4.6475 6.84 4.8225C6.72 4.9975 6.57 5.16 6.39 5.31C5.95 5.7 5.68 5.995 5.58 6.195C5.48 6.395 5.43 6.76 5.43 7.29ZM6 12C5.17 12 4.39 11.8425 3.66 11.5275C2.93 11.2125 2.295 10.785 1.755 10.245C1.215 9.705 0.7875 9.07 0.4725 8.34C0.1575 7.61 0 6.83 0 6C0 5.17 0.1575 4.39 0.4725 3.66C0.7875 2.93 1.215 2.295 1.755 1.755C2.295 1.215 2.93 0.7875 3.66 0.4725C4.39 0.1575 5.17 0 6 0C6.83 0 7.61 0.1575 8.34 0.4725C9.07 0.7875 9.705 1.215 10.245 1.755C10.785 2.295 11.2125 2.93 11.5275 3.66C11.8425 4.39 12 5.17 12 6C12 6.83 11.8425 7.61 11.5275 8.34C11.2125 9.07 10.785 9.705 10.245 10.245C9.705 10.785 9.07 11.2125 8.34 11.5275C7.61 11.8425 6.83 12 6 12ZM6 10.8C7.34 10.8 8.475 10.335 9.405 9.405C10.335 8.475 10.8 7.34 10.8 6C10.8 4.66 10.335 3.525 9.405 2.595C8.475 1.665 7.34 1.2 6 1.2C4.66 1.2 3.525 1.665 2.595 2.595C1.665 3.525 1.2 4.66 1.2 6C1.2 7.34 1.665 8.475 2.595 9.405C3.525 10.335 4.66 10.8 6 10.8Z"
      fill="url(#paint_helpCircle)"
    />
    <defs>
      <linearGradient
        id="paint_helpCircle"
        x1="5.4"
        y1="10.8"
        x2="5.4"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBF3B4" />
        <stop offset="1" stopColor="#FFC871" />
      </linearGradient>
    </defs>
  </svg>
);

export const BottomNavBgIcon: React.FC<SvgIconProps> = ({
  className,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 375 74"
    preserveAspectRatio="none"
    fill="none"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <path
      d="M188 0C198.609 8.00932e-07 208.783 4.21437 216.284 11.7158C217.346 12.7772 218.341 13.8921 219.268 15.0541C223.235 20.0278 228.771 24 235.132 24H359C367.837 24 375 31.1634 375 40V73C375 73.5523 374.552 74 374 74H1C0.447715 74 0 73.5523 0 73V40C0 31.1634 7.16344 24 16 24H140.868C147.229 24 152.765 20.0278 156.732 15.0541C157.659 13.8921 158.654 12.7772 159.716 11.7158C167.217 4.21437 177.391 2.09327e-07 188 0Z"
      style={{ fill: "var(--color-bg-bottom-nav)" }}
    />
  </svg>
);

export const CashbackClaimedIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  className,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <g clipPath="url(#clip0_cashback_claimed)">
      <rect width="20" height="20" rx="10" fill="white" />
      <path
        d="M20 9.99903C20 15.525 15.5245 20 10 20C4.4785 20 0 15.525 0 9.99903C0 4.47503 4.4785 0 10 0C15.5245 0 20 4.47503 20 9.99903ZM15.8535 6.79167L14.2988 5.2378L7.81639 11.7316L5.70023 9.60836L4.14652 11.1593L7.75103 14.7622L7.81642 14.6948L7.88086 14.7622L15.8535 6.79167Z"
        fill="url(#paint0_linear_cashback_claimed)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_cashback_claimed"
        x1="10"
        y1="0"
        x2="10"
        y2="20"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1CCF9A" />
        <stop offset="1" stopColor="#82E52B" />
      </linearGradient>
      <clipPath id="clip0_cashback_claimed">
        <rect width="20" height="20" rx="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const VIP_TROPHY_PATH =
  "M8.00114 16.912C6.83094 16.5125 5.81779 15.7726 5.10122 14.7941C4.38466 13.8156 3.99992 12.6467 4 11.4483V7.31035C4 6.87137 4.18061 6.45037 4.5021 6.13996C4.82359 5.82956 5.25963 5.65517 5.71429 5.65517H7.42857V4H24.5714V5.65517H26.2857C26.7404 5.65517 27.1764 5.82956 27.4979 6.13996C27.8194 6.45037 28 6.87137 28 7.31035V11.4483C28 13.9708 26.3303 16.1159 23.9989 16.912C23.4272 18.3392 22.4573 19.5856 21.1967 20.5129C19.9361 21.4402 18.434 22.0123 16.8571 22.1655V24.6897H20.2857C20.7404 24.6897 21.1764 24.864 21.4979 25.1744C21.8194 25.4848 22 25.9058 22 26.3448C22 26.7838 21.8194 27.2048 21.4979 27.5152C21.1764 27.8256 20.7404 28 20.2857 28H11.7143C11.2596 28 10.8236 27.8256 10.5021 27.5152C10.1806 27.2048 10 26.7838 10 26.3448C10 25.9058 10.1806 25.4848 10.5021 25.1744C10.8236 24.864 11.2596 24.6897 11.7143 24.6897H15.1429V22.1655C13.566 22.0123 12.0639 21.4402 10.8033 20.5129C9.54268 19.5856 8.57276 18.3392 8.00114 16.912ZM7.47486 14.7917C7.44413 14.5058 7.42868 14.2185 7.42857 13.931V7.31035H5.71429V11.4483C5.71429 12.8221 6.40686 14.0386 7.47486 14.7917ZM24.5714 7.31035V13.931C24.5714 14.2223 24.5543 14.5103 24.5251 14.7917C25.0709 14.408 25.5149 13.905 25.8209 13.3239C26.1269 12.7429 26.2861 12.1001 26.2857 11.4483V7.31035H24.5714Z";

export const VipTabTrophyIcon: React.FC<SvgIconProps> = ({
  width = 32,
  height = 32,
  className,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    width={width}
    height={height}
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <path
      className="vip-tab-icon__default"
      d={VIP_TROPHY_PATH}
      fill="url(#paint0_vip_tab_trophy_h)"
    />
    <path
      className="vip-tab-icon__active"
      d={VIP_TROPHY_PATH}
      fill="url(#paint0_vip_tab_trophy_v)"
    />
    <defs>
      <linearGradient
        id="paint0_vip_tab_trophy_h"
        x1="4"
        y1="16"
        x2="28"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{
            stopColor: "var(--color-icon-vip-tab-start, #FFF0B4)",
          }}
        />
        <stop
          offset="1"
          style={{
            stopColor: "var(--color-icon-vip-tab-end, white)",
          }}
        />
      </linearGradient>
      <linearGradient
        id="paint0_vip_tab_trophy_v"
        x1="16"
        y1="4"
        x2="16"
        y2="28"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{
            stopColor: "var(--color-icon-vip-tab-active-start, #FFF0B4)",
          }}
        />
        <stop
          offset="1"
          style={{
            stopColor: "var(--color-icon-vip-tab-active-end, white)",
          }}
        />
      </linearGradient>
    </defs>
  </svg>
);

const VIP_REWARD_PATH =
  "M4.14842 20.1788C3.2317 22.2071 3.0077 24.2205 3 25.6953C2.99969 25.9981 3.06147 26.2979 3.18179 26.5777C3.30212 26.8575 3.47863 27.1117 3.70123 27.3258C3.92382 27.5399 4.18813 27.7097 4.47901 27.8253C4.76989 27.941 5.08163 28.0004 5.39639 28H26.6036C27.928 28 29.0047 26.9688 29 25.6953C28.997 24.2182 28.7683 22.2065 27.8539 20.1788C26.0821 16.2426 22.8662 11.9512 19.4998 9.87615H12.5056C9.13675 11.9512 5.92319 16.2426 4.14842 20.1788ZM17.677 20.0733C17.3203 19.6521 16.7093 19.4736 16.1564 19.3534C15.4744 19.204 14.8581 19.0547 14.2424 18.7212C13.8527 18.515 13.5326 18.2056 13.3204 17.8296C13.1064 17.4551 12.9992 17.0241 12.9992 16.551C12.9992 15.7061 13.315 15.0152 13.936 14.4913C14.3052 14.1801 14.8071 13.9646 15.3772 13.8666V13.406C15.3772 13.0947 15.6421 12.845 15.9603 12.845H16.2791C16.6021 12.845 16.8622 13.0998 16.8622 13.406V13.8734C17.389 13.972 17.8601 14.1698 18.2115 14.4549C18.585 14.7516 18.8669 15.1412 19.0263 15.5813C19.0547 15.6598 19.0647 15.7433 19.0557 15.826C19.0467 15.9086 19.0189 15.9883 18.9742 16.0594C18.9295 16.1305 18.869 16.1912 18.7971 16.2373C18.7252 16.2833 18.6436 16.3136 18.5582 16.3258L18.25 16.3697C18.1144 16.389 17.9761 16.3622 17.8589 16.2938C17.7417 16.2254 17.6531 16.1198 17.6083 15.9952C17.5466 15.8055 17.4461 15.6297 17.3126 15.4781C17.0352 15.1748 16.5943 15.0055 16.1055 15.0055C15.5864 15.0055 15.0951 15.2016 14.7947 15.5271C14.5446 15.7945 14.4249 16.1029 14.4249 16.4706C14.4249 16.828 14.5298 17.1341 14.736 17.3696C15.1662 17.8689 15.8738 18.0063 16.5564 18.1386C16.9564 18.2167 17.3683 18.2976 17.725 18.447C18.1042 18.6089 18.423 18.8095 18.6672 19.045C18.909 19.2775 19.1027 19.5614 19.2325 19.8829C19.3629 20.2033 19.431 20.5533 19.431 20.9284C19.431 21.7465 19.1561 22.4397 18.6133 22.9886C18.1682 23.439 17.562 23.7377 16.8646 23.8551V24.196C16.8641 24.3446 16.8025 24.487 16.6933 24.5921C16.584 24.6972 16.436 24.7565 16.2815 24.7569H15.9633C15.8088 24.7565 15.6607 24.6972 15.5515 24.5921C15.4422 24.487 15.3806 24.3446 15.3802 24.196V23.8409C15.0038 23.7734 14.6395 23.6546 14.2981 23.488C13.9082 23.2942 13.5692 22.9806 13.2872 22.5548C13.0928 22.2528 12.9548 21.9204 12.8795 21.5726C12.8635 21.4986 12.8631 21.4223 12.8785 21.3482C12.8938 21.2741 12.9245 21.2038 12.9688 21.1413C13.013 21.0789 13.0699 21.0257 13.136 20.9849C13.2021 20.9441 13.2761 20.9166 13.3535 20.9039L13.6718 20.8526C13.8167 20.8275 13.9661 20.8563 14.0899 20.9331C14.2136 21.0099 14.3024 21.1291 14.3384 21.2665C14.4273 21.6045 14.5476 21.8667 14.6975 22.0503C15.0335 22.4642 15.5887 22.7139 16.1819 22.7139C16.2838 22.7139 16.3834 22.7042 16.4824 22.6945C16.8941 22.6392 17.2726 22.4468 17.552 22.1506C17.8293 21.8445 17.9721 21.4597 17.9721 21.0065C17.9721 20.6126 17.8725 20.3014 17.677 20.0733ZM16.1286 4H16.1233L11.5533 4.01254C10.7177 4.01482 10.2188 4.91152 10.6846 5.5802L12.7349 8.53652H19.5258L21.575 5.5802C22.0384 4.91152 21.5418 4.01482 20.7068 4.01254L16.1286 4Z";

export const VipTabRewardIcon: React.FC<SvgIconProps> = ({
  width = 32,
  height = 32,
  className,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    width={width}
    height={height}
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <path
      className="vip-tab-icon__default"
      d={VIP_REWARD_PATH}
      fill="url(#paint0_vip_tab_reward_h)"
    />
    <path
      className="vip-tab-icon__active"
      d={VIP_REWARD_PATH}
      fill="url(#paint0_vip_tab_reward_v)"
    />
    <defs>
      <linearGradient
        id="paint0_vip_tab_reward_h"
        x1="3"
        y1="16"
        x2="29"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{
            stopColor: "var(--color-icon-vip-tab-start, #D8A972)",
          }}
        />
        <stop
          offset="1"
          style={{
            stopColor: "var(--color-icon-vip-tab-end, #E9D09F)",
          }}
        />
      </linearGradient>
      <linearGradient
        id="paint0_vip_tab_reward_v"
        x1="16"
        y1="4"
        x2="16"
        y2="28"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{
            stopColor: "var(--color-icon-vip-tab-active-start, #D8A972)",
          }}
        />
        <stop
          offset="1"
          style={{
            stopColor: "var(--color-icon-vip-tab-active-end, #E9D09F)",
          }}
        />
      </linearGradient>
    </defs>
  </svg>
);

const VIP_SIGNIN_PATH =
  "M24.7992 5.71475H22.3986V4.85737C22.3986 4.38322 21.6348 4 20.7982 4C19.8525 4 19.1978 4.38322 19.1978 4.85737V5.71475H12.8022V4.85737C12.8022 4.38322 12.1111 4 11.2018 4C10.2561 4 9.60141 4.38322 9.60141 4.85737V5.71475H7.20081C5.43066 5.71475 4 7.24763 4 9.14425V24.5705C4 26.4606 5.43066 28 7.20081 28H24.7992C26.5633 28 28 26.4671 28 24.5705V9.14425C28 7.25413 26.5633 5.71475 24.7992 5.71475ZM20.483 17.8804L15.2089 23.3949C14.7906 23.8235 14.1359 23.8235 13.7176 23.3949L11.4807 21.0696C11.2806 20.8682 11.1715 20.5889 11.1715 20.2966C11.1715 20.0043 11.2806 19.725 11.4807 19.5237C11.899 19.095 12.5537 19.095 12.972 19.5237L14.4632 21.076L18.9917 16.341C19.41 15.9123 20.0647 15.9123 20.483 16.341C20.683 16.5424 20.7921 16.8217 20.7921 17.1139C20.7921 17.3932 20.683 17.6725 20.483 17.8804ZM26.3996 12.5737H5.6004V9.14425C5.6004 8.68958 5.77014 8.2544 6.06719 7.92963C6.36423 7.61137 6.77646 7.4295 7.20081 7.4295H9.60141V8.28687C9.60141 8.76103 10.2379 9.14425 11.2018 9.14425C12.3415 9.14425 12.8022 8.76103 12.8022 8.28687V7.4295H19.2038V8.28687C19.2038 8.76103 19.9677 9.14425 20.8042 9.14425C21.8227 9.14425 22.4046 8.76103 22.4046 8.28687V7.4295H24.7992C25.2235 7.4295 25.6297 7.61137 25.9328 7.92963C26.2359 8.2479 26.3996 8.68958 26.3996 9.14425V12.5737Z";

export const VipTabSigninIcon: React.FC<SvgIconProps> = ({
  width = 32,
  height = 32,
  className,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    width={width}
    height={height}
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <path
      className="vip-tab-icon__default"
      d={VIP_SIGNIN_PATH}
      fill="url(#paint0_vip_tab_signin_h)"
    />
    <path
      className="vip-tab-icon__active"
      d={VIP_SIGNIN_PATH}
      fill="url(#paint0_vip_tab_signin_v)"
    />
    <defs>
      <linearGradient
        id="paint0_vip_tab_signin_h"
        x1="4"
        y1="16"
        x2="28"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{
            stopColor: "var(--color-icon-vip-tab-start, #D8A972)",
          }}
        />
        <stop
          offset="1"
          style={{
            stopColor: "var(--color-icon-vip-tab-end, #E9D09F)",
          }}
        />
      </linearGradient>
      <linearGradient
        id="paint0_vip_tab_signin_v"
        x1="16"
        y1="4"
        x2="16"
        y2="28"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{
            stopColor: "var(--color-icon-vip-tab-active-start, #D8A972)",
          }}
        />
        <stop
          offset="1"
          style={{
            stopColor: "var(--color-icon-vip-tab-active-end, #E9D09F)",
          }}
        />
      </linearGradient>
    </defs>
  </svg>
);

export const BirthdayCalendarIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  className,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    width={width}
    height={height}
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <path
      d="M5.5 14.2921C5.5 13.8521 5.86181 13.5 6.26884 13.5H13.7312C14.1834 13.5 14.5 13.8521 14.5 14.2481C14.5 14.6882 14.1382 14.9963 13.7312 14.9963H6.31407C5.86181 15.0403 5.5 14.6882 5.5 14.2921Z"
      fill="url(#paint0_birthday_cal_h)"
    />
    <path
      d="M5.5 14.2921C5.5 13.8521 5.86181 13.5 6.26884 13.5H13.7312C14.1834 13.5 14.5 13.8521 14.5 14.2481C14.5 14.6882 14.1382 14.9963 13.7312 14.9963H6.31407C5.86181 15.0403 5.5 14.6882 5.5 14.2921Z"
      fill="url(#paint1_birthday_cal_v)"
    />
    <path
      d="M18.4375 16.6375H17.875V8.46229C17.875 7.17762 16.8625 6.12652 15.625 6.12652H14.8375V2.70073C14.8375 2.31144 14.5375 2 14.2 2C13.825 2 13.525 2.31144 13.525 2.70073V6.08759H10.5625V2.70073C10.5625 2.31144 10.2625 2 9.8875 2C9.5125 2 9.2125 2.31144 9.2125 2.70073V6.08759H6.175V2.70073C6.175 2.31144 5.875 2 5.5 2C5.125 2 4.825 2.31144 4.825 2.70073V6.08759H4.375C3.1375 6.08759 2.125 7.13869 2.125 8.42336V16.5985H1.5625C1.2625 16.6375 1 16.91 1 17.2214V17.4161C1 17.7275 1.2625 18 1.5625 18H18.4375C18.7375 18 19 17.7275 19 17.4161V17.2214C19 16.91 18.7375 16.6375 18.4375 16.6375ZM3.4375 16.6375V8.46229C3.4375 7.91728 3.85 7.48905 4.375 7.48905H15.625C16.15 7.48905 16.5625 7.91728 16.5625 8.46229V16.6375H3.4375Z"
      fill="url(#paint2_birthday_cal_h)"
    />
    <path
      d="M18.4375 16.6375H17.875V8.46229C17.875 7.17762 16.8625 6.12652 15.625 6.12652H14.8375V2.70073C14.8375 2.31144 14.5375 2 14.2 2C13.825 2 13.525 2.31144 13.525 2.70073V6.08759H10.5625V2.70073C10.5625 2.31144 10.2625 2 9.8875 2C9.5125 2 9.2125 2.31144 9.2125 2.70073V6.08759H6.175V2.70073C6.175 2.31144 5.875 2 5.5 2C5.125 2 4.825 2.31144 4.825 2.70073V6.08759H4.375C3.1375 6.08759 2.125 7.13869 2.125 8.42336V16.5985H1.5625C1.2625 16.6375 1 16.91 1 17.2214V17.4161C1 17.7275 1.2625 18 1.5625 18H18.4375C18.7375 18 19 17.7275 19 17.4161V17.2214C19 16.91 18.7375 16.6375 18.4375 16.6375ZM3.4375 16.6375V8.46229C3.4375 7.91728 3.85 7.48905 4.375 7.48905H15.625C16.15 7.48905 16.5625 7.91728 16.5625 8.46229V16.6375H3.4375Z"
      fill="url(#paint3_birthday_cal_v)"
    />
    <defs>
      <linearGradient
        id="paint0_birthday_cal_h"
        x1="10"
        y1="15"
        x2="10"
        y2="13.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-header-start, #F5E68A)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-header-end, #F6B447)" }}
        />
      </linearGradient>
      <linearGradient
        id="paint1_birthday_cal_v"
        x1="10"
        y1="13.5"
        x2="10"
        y2="15"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-start, #FAB137)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-end, #F9E56C)" }}
        />
      </linearGradient>
      <linearGradient
        id="paint2_birthday_cal_h"
        x1="10"
        y1="18"
        x2="10"
        y2="2"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-header-start, #F5E68A)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-header-end, #F6B447)" }}
        />
      </linearGradient>
      <linearGradient
        id="paint3_birthday_cal_v"
        x1="10"
        y1="2"
        x2="10"
        y2="18"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-start, #FAB137)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-end, #F9E56C)" }}
        />
      </linearGradient>
    </defs>
  </svg>
);

export const UnpaidOrderIcon: React.FC<SvgIconProps> = ({
  width = 20,
  height = 20,
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
  >
    <defs>
      <linearGradient
        id="paint0_linear_unpaid_order"
        x1="10"
        y1="18"
        x2="10"
        y2="2"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-header-start, currentColor)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-header-end, currentColor)" }}
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_unpaid_order"
        x1="10"
        y1="2"
        x2="10"
        y2="18"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: "var(--color-icon-start, currentColor)" }} />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-end, currentColor)" }}
        />
      </linearGradient>
    </defs>
    {/* 后面的钞票 - 显示没被遮住的部分（左边、底部、左上角、左下角、底部右段） */}
    <path
      d="M2.5 6C1.94772 6 1.5 6.44772 1.5 7V15C1.5 15.5523 1.94772 16 2.5 16H15.5C16.0523 16 16.5 15.5523 16.5 15V12.5"
      fill="none"
      stroke="url(#paint1_linear_unpaid_order)"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* 前面的钞票 */}
    <rect
      x="4.2"
      y="2.5"
      width="14"
      height="9"
      rx="1"
      fill="none"
      stroke="url(#paint0_linear_unpaid_order)"
      strokeWidth="1.3"
    />
    {/* 中间圆形 */}
    <circle
      cx="11.5"
      cy="6.5"
      r="2.2"
      fill="none"
      stroke="url(#paint0_linear_unpaid_order)"
      strokeWidth="1.3"
    />
    {/* 左侧角落装饰 */}
    <path
      d="M6.5 4C6.5 4.55228 6.05228 5 5.5 5"
      fill="none"
      stroke="url(#paint0_linear_unpaid_order)"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
    {/* 右侧角落装饰 */}
    <path
      d="M16.5 4C16.5 4.55228 16.9477 5 17.5 5"
      fill="none"
      stroke="url(#paint0_linear_unpaid_order)"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
    {/* 左下角装饰 */}
    <path
      d="M6.5 9C6.5 8.44772 6.05228 8 5.5 8"
      fill="none"
      stroke="url(#paint0_linear_unpaid_order)"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
    {/* 右下角装饰 */}
    <path
      d="M16.5 9C16.5 8.44772 16.9477 8 17.5 8"
      fill="none"
      stroke="url(#paint0_linear_unpaid_order)"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </svg>
);

export const CheckShieldOutlineIcon: React.FC<SvgIconProps> = ({
  width = "1em",
  height = "1em",
  className,
  onClick,
}) => (
  <svg
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    onClick={onClick}
    style={{
      verticalAlign: "-0.125em",
      cursor: onClick ? "pointer" : undefined,
    }}
  >
    <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
      <g>
        <rect fill="#FFFFFF" opacity={0} x={0} y={0} width={48} height={48} />
        <path
          d="M23.5828113,4.01694873 L39.8608414,7.3485224 C41.6942831,7.74819585 43,9.35541667 43,11.212546 L43,29.7608837 C43,32.637301 41.4221454,35.2872082 38.8789667,36.681899 L25.4394833,43.5037686 C24.2329985,44.1654105 22.7670015,44.1654105 21.5605167,43.5037686 L9.12103331,36.681899 C6.57785456,35.2872082 5,32.637301 5,29.7608837 L5,11.212546 C5,9.35541667 6.30571695,7.74819585 8.1391586,7.3485224 L23.4174116,4.01800352 C23.4718692,4.00613226 23.5282067,4.00577298 23.5828113,4.01694873 Z M23.417495,7.05577718 L8.78478965,10.2465401 C8.36462594,10.3381319 8.05532106,10.6833926 8.00668805,11.0979156 L8,11.212546 L8,29.7608837 C8,31.3482043 9.62086939,32.8251594 11.0260387,33.7491918 L11.3717744,33.9684245 L11.5756458,34.0865183 L23.0151292,40.9083879 C23.2790477,41.053122 23.5926385,41.0712138 23.8689752,40.9626632 L23.9848708,40.9083879 L37.4243542,34.0865183 C38.9447328,33.2527357 39.9131065,31.7011782 39.9944389,29.9945186 L40,29.7608837 L40,11.212546 C40,10.7869539 39.7257088,10.4138599 39.3269393,10.2776704 L39.2152103,10.2465401 L23.5827367,7.05467968 C23.5281801,7.04354024 23.4718988,7.04391405 23.417495,7.05577718 Z M32.7058154,19 C32.9267293,19 33.1058154,19.1790861 33.1058154,19.4 C33.1058154,19.5068429 33.0630714,19.6092453 32.9871111,19.6843814 L24.2457367,28.3309047 C23.9176305,28.6554624 23.5052693,28.8433642 23.0796048,28.8946101 L22.9194955,28.9074216 L22.7589706,28.9074216 C22.2776035,28.8882044 21.8018489,28.6960321 21.4327294,28.3309047 L15.6927625,22.6523601 C15.5357148,22.4969929 15.5343524,22.2437305 15.6897196,22.0866828 C15.7648541,22.0107357 15.8672473,21.968 15.9740797,21.968 L19.0785907,21.968 C19.1839217,21.968 19.2850018,22.0095463 19.3598871,22.0836194 L22.839,25.525 L29.3191147,19.1156096 C29.3939991,19.0415425 29.4950749,19 29.6004012,19 L32.7058154,19 Z"
          fill="url(#check-shield-gradient-a)"
          fillRule="nonzero"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="check-shield-gradient-a"
        x1="24"
        y1="44"
        x2="24"
        y2="4"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          style={{ stopColor: "var(--color-icon-header-end, currentColor)" }}
        />
        <stop
          offset="1"
          style={{ stopColor: "var(--color-icon-header-start, currentColor)" }}
        />
      </linearGradient>
    </defs>
  </svg>
);

// SVG图标映射
export const svgIconMap = {
  // 系统图标
  user: UserIcon,
  language: LanguageIcon,
  search: SearchIcon,
  password: PasswordIcon,
  "password-reset": PasswordResetIcon,
  eye: EyeIcon,
  "eye-closed": EyeClosedIcon,
  menu: MenuIcon,
  refresh: RefreshIcon,
  mail: MailIcon,
  mailTopRight: MailTopRightIcon,
  coin: CoinIcon,
  close: CloseIcon,
  closeDialog: CloseDialogIcon,
  homeDefault: HomeDefaultIcon,
  homeActive: HomeActiveIcon,
  eventDefault: EventDefaultIcon,
  eventActive: EventActiveIcon,
  rewardDefault: RewardDefaultIcon,
  rewardActive: RewardActiveIcon,
  profileDefault: ProfileDefaultIcon,
  profileActive: ProfileActiveIcon,
  settings: SettingsIcon,
  notification: NotificationIcon,
  games: GamesIcon,
  history: HistoryIcon,
  back: BackIcon,
  phone: PhoneIcon,
  message: MessageIcon,

  // 功能图标
  heart: HeartIcon,
  star: StarIcon,
  copy: CopyIcon,
  inviteCode: InviteCodeIcon,

  // 状态图标
  loading: LoadingIcon,
  success: SuccessIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,

  // VIP 相关图标
  vipCurrent: VipCurrentIcon,
  vipLocked: VipLockedIcon,
  signDay: SignDayIcon,
  lock: LockIcon,
  vipReward: VipRewardIcon,
  vipRebate: VipRebateIcon,
  vipSignIn: VipSignInIcon,

  // Agent Center 相关图标
  checkSuccess: CheckSuccessIcon,
  inputSearchIcon: InputSearchIcon,
  dropdownSearchIcon: DropdownSearchIcon,

  // profile 相关图标
  transactionRecord: TransactionRecordIcon,
  betRecord: BetRecordIcon,
  bonusRecord: BonusRecordIcon,
  redeem: RedeemTwowayIcon,
  supportService: SupportServiceIcon,
  logout: LogoutIcon,
  messageTips: MessageTipsIcon,
  kycConfig: KycConfigIcon,
  unpaidOrder: UnpaidOrderIcon,

  //向右的箭头
  rightArrow: RightArrowIcon,
  rightArrowOutline: RightArrowOutlineIcon,

  // 新增图标
  event: EventIcon,
  profile: ProfileIcon,
  reward: RewardIcon,
  invite: InviteIcon,

  //Rawnck 相关图标
  goldLight: GoldLightIcon,

  // 默认图标
  default: DefaultIcon,

  // header 相关图标
  shareAppBarClose: ShareAppBarCloseIcon,

  //title line 相关图标
  titleLineLeft: TitleLineLeftIcon,
  titleLineRight: TitleLineRightIcon,

  // 左右箭头图标
  arrowLeft: ArrowLeftIcon,
  arrowLeftSimple: ArrowLeftSimpleIcon,
  arrowRight: ArrowRightIcon,

  // 倒计时图标
  time: TimeIcon,

  // Invite Friends 相关图标
  inviteFriendsListNotQualified: InviteFriendsListNotQualifiedIcon,
  inviteFriendsListExpired: InviteFriendsListExpiredIcon,
  inviteFriendsListQualified: InviteFriendsListQualifiedIcon,

  // 社交分享图标
  instagram: InstagramIcon,

  // 分页按钮图标
  paginationLeft: PaginationLeftIcon,
  paginationRight: PaginationRightIcon,

  // 加载旋转图标
  spinner: SpinnerIcon,
  // 未付款订单相关图标
  orderVerify: OrderVerifyIcon,
  helpCircle: HelpCircleIcon,

  // 底部导航栏背景
  bottomNavBg: BottomNavBgIcon,

  // Cashback 已领取图标
  cashbackClaimed: CashbackClaimedIcon,

  // 生日日历图标
  birthdayCalendar: BirthdayCalendarIcon,

  // 地球图标（国家/地区选择）
  globe: GlobeIcon,

  // 投注限额图标
  bettingLimit: BettingLimitIcon,

  // 图形验证码盾牌图标
  checkShield: CheckShieldOutlineIcon,
} as const;
